import { AudioPresets, Room, RoomEvent, Track } from 'livekit-client';
import { io } from 'socket.io-client';

const joinPanel = document.querySelector('#join-panel');
const roomPanel = document.querySelector('#room-panel');
const joinForm = document.querySelector('#join-form');
const joinRoomSelect = document.querySelector('#join-room-select');
const joinButton = document.querySelector('#join-button');
const statusText = document.querySelector('#status-text');
const joinPanelHome = {
  parent: joinPanel.parentNode,
  nextSibling: joinPanel.nextSibling,
};

const DESKTOP_THEME_STORAGE_KEY = 'seslicity-desktop-theme';
const CHAT_VIEW_STORAGE_KEY = 'seslicity-desktop-chat-view-v1';


const authLoading = document.querySelector('#auth-loading');
const authForms = document.querySelector('#auth-forms');
const guestTab = document.querySelector('#guest-tab');
const loginTab = document.querySelector('#login-tab');
const registerTab = document.querySelector('#register-tab');
const loginForm = document.querySelector('#login-form');
const loginIdentifier = document.querySelector('#login-identifier');
const loginPassword = document.querySelector('#login-password');
const loginSubmit = document.querySelector('#login-submit');
const registerForm = document.querySelector('#register-form');
const registerUsername = document.querySelector('#register-username');
const registerDisplayName = document.querySelector('#register-display-name');
const registerGender = document.querySelector('#register-gender');
const registerEmail = document.querySelector('#register-email');
const registerPassword = document.querySelector('#register-password');
const registerSubmit = document.querySelector('#register-submit');
const guestForm = document.querySelector('#guest-form');
const guestDisplayName = document.querySelector('#guest-display-name');
const guestGender = document.querySelector('#guest-gender');
const guestGenderOptions = [...document.querySelectorAll('[data-gender-value]')];
const guestGenderError = document.querySelector('#guest-gender-error');
const guestSubmit = document.querySelector('#guest-submit');
const memberPanel = document.querySelector('#member-panel');
const memberAvatar = document.querySelector('#member-avatar');
const memberFrame = document.querySelector('#member-frame');
const memberName = document.querySelector('#member-name');
const memberUsername = document.querySelector('#member-username');
const memberRole = document.querySelector('#member-role');
const logoutButton = document.querySelector('#logout-button');
const adminPanelLink = document.querySelector('#admin-panel-link');

const desktopAccountProfile = document.querySelector('#desktop-account-profile');
const desktopAccountAvatar = document.querySelector('#desktop-account-avatar');
const desktopAccountFrame = document.querySelector('#desktop-account-frame');
const desktopAccountName = document.querySelector('#desktop-account-name');
const desktopAccountMeta = document.querySelector('#desktop-account-meta');
const desktopOkeyButton = document.querySelector('#desktop-okey-button');
const desktopOkeyLabel = document.querySelector('#desktop-okey-label');
const desktopOnlineCount = document.querySelector('#desktop-online-count');
const desktopRoomsTab = document.querySelector('#desktop-rooms-tab');
const desktopUsersTab = document.querySelector('#desktop-users-tab');
const desktopUsersCount = document.querySelector('#desktop-users-count');
const desktopRoomSubtitle = document.querySelector('#desktop-room-subtitle');
const desktopSignupButton = document.querySelector('#desktop-signup-button');
const desktopThemeToggle = document.querySelector('#desktop-theme-toggle');
const desktopThemeToggleIcon = document.querySelector('#desktop-theme-toggle-icon');
const desktopPrivateMessagesButton = document.querySelector('#desktop-private-messages-button');
const desktopPrivateUnreadBadge = document.querySelector('#desktop-private-unread-badge');
const authOverlayClose = document.querySelector('#auth-overlay-close');

const roomNameText = document.querySelector('#room-name');
const participantCount = document.querySelector('#participant-count');
const connectionBadge = document.querySelector('#connection-badge');
const onlineCount = document.querySelector('#online-count');
const onlineUsers = document.querySelector('#online-users');
const usersPanel = document.querySelector('#users-panel');
const mobileUsersButton = document.querySelector('#mobile-users-button');
const mobileUsersCount = document.querySelector('#mobile-users-count');
const usersPanelClose = document.querySelector('#users-panel-close');
const usersDrawerBackdrop = document.querySelector('#users-drawer-backdrop');
const roomsPanel = document.querySelector('#rooms-panel');
const roomsPanelClose = document.querySelector('#rooms-panel-close');
const roomsDrawerBackdrop = document.querySelector('#rooms-drawer-backdrop');
const mobileRoomsButton = document.querySelector('#mobile-rooms-button');
const mobileRoomBackButton = document.querySelector('#mobile-room-back-button');
const mobileHeaderAvatar = document.querySelector('#mobile-header-avatar');
const mobileRoomOwner = document.querySelector('#mobile-room-owner');
const mobileProfileButton = document.querySelector('#mobile-profile-button');
const mobileAccountMenu = document.querySelector('#mobile-account-menu');
const mobileAccountProfileButton = document.querySelector('#mobile-account-profile-button');
const mobileAccountMessagesButton = document.querySelector('#mobile-account-messages-button');
const mobileAccountUnreadBadge = document.querySelector('#mobile-account-unread-badge');
const mobileHeaderCameraButton = document.querySelector('#mobile-header-camera-button');
const mobileHeaderLeaveButton = document.querySelector('#mobile-header-leave-button');
const roomList = document.querySelector('#room-list');
const createRoomButton = document.querySelector('#create-room-button');
const roomSettingsButton = document.querySelector('#room-settings-button');
const joinRoomName = document.querySelector('#join-room-name');
const joinRoomMeta = document.querySelector('#join-room-meta');
const seatsGrid = document.querySelector('#seats-grid');
const seatSummary = document.querySelector('#seat-summary');
const voiceModePanel = document.querySelector('#voice-mode-panel');
const okeyModeButton = document.querySelector('#okey-mode-button');
const okeyModeButtonLabel = document.querySelector('.okey-mode-button-label');
const okeyModePanel = document.querySelector('#okey-mode-panel');
const okeyConnectionBadge = document.querySelector('#okey-connection-badge');
const okeySpectatorCount = document.querySelector('#okey-spectator-count');
const okeySpectatorsButton = document.querySelector('#okey-spectators-button');
const okeySpectatorsPopover = document.querySelector('#okey-spectators-popover');
const okeySpectatorsBackdrop = document.querySelector('#okey-spectators-backdrop');
const okeySpectatorsClose = document.querySelector('#okey-spectators-close');
const okeySpectatorsTotal = document.querySelector('#okey-spectators-total');
const okeySpectatorsList = document.querySelector('#okey-spectators-list');
const okeyTableStatus = document.querySelector('#okey-table-status');
const okeyTableSummary = document.querySelector('#okey-table-summary');
const okeyTableMark = document.querySelector('.okey-table-mark');
const okeyLastDiscard = document.querySelector('#okey-last-discard');
const okeyDrawWallButton = document.querySelector('#okey-draw-wall-button');
const okeyTakeDiscardButton = document.querySelector('#okey-take-discard-button');
const okeyDiscardButton = document.querySelector('#okey-discard-button');
const okeyRackTools = document.querySelector('#okey-rack-tools');
const okeyRackArrangeButton = document.querySelector('#okey-rack-arrange-button');
const okeyRackSortColorButton = document.querySelector('#okey-rack-sort-color-button');
const okeyRackSortNumberButton = document.querySelector('#okey-rack-sort-number-button');
const okeyReadyButton = document.querySelector('#okey-ready-button');
const okeyLeaveSeatButton = document.querySelector('#okey-leave-seat-button');
const okeyResetButton = document.querySelector('#okey-reset-button');
const okeyCloseButton = document.querySelector('#okey-close-button');
const okeyActionNote = document.querySelector('#okey-action-note');
const okeySeatButtons = [...document.querySelectorAll('[data-okey-seat]')];
const okeyVisualRacks = {
  top: document.querySelector('.okey-visual-rack-top'),
  right: document.querySelector('.okey-visual-rack-right'),
  bottom: document.querySelector('.okey-visual-rack-bottom'),
  left: document.querySelector('.okey-visual-rack-left'),
};

const chatMessages = document.querySelector('#chat-messages');
const chatTyping = document.querySelector('#chat-typing');
const chatForm = document.querySelector('#chat-form');
const chatInput = document.querySelector('#chat-input');
const chatSend = document.querySelector('#chat-send');
const chatAttachmentButton = document.querySelector('#chat-attachment-button');
const chatImageInput = document.querySelector('#chat-image-input');
const chatImagePreview = document.querySelector('#chat-image-preview');
const chatImagePreviewImage = document.querySelector('#chat-image-preview-image');
const chatImagePreviewName = document.querySelector('#chat-image-preview-name');
const chatImagePreviewRemove = document.querySelector('#chat-image-preview-remove');
const emojiWrap = document.querySelector('#emoji-wrap');
const emojiButton = document.querySelector('#emoji-button');
const emojiPicker = document.querySelector('#emoji-picker');
const chatContextMenu = document.querySelector('#chat-context-menu');
const chatContextClear = document.querySelector('#chat-context-clear');
const chatContextReset = document.querySelector('#chat-context-reset');
const chatContextAdmin = document.querySelector('#chat-context-admin');
const chatContextAdminDivider = document.querySelector('#chat-context-admin-divider');
const chatContextFontButtons = [...document.querySelectorAll('[data-chat-font]')];
const chatContextAlignButtons = [...document.querySelectorAll('[data-chat-align]')];

const seatButton = document.querySelector('#seat-button');
const micButton = document.querySelector('#mic-button');
const audioOutputButton = document.querySelector('#audio-output-button');
const cameraButton = document.querySelector('#camera-button');
const cameraQuickButton = document.querySelector('#camera-quick-button');
const okeyCameraButton = document.querySelector('#okey-camera-button');
const musicButton = document.querySelector('#music-button');
const leaveButton = document.querySelector('#leave-button');
const privateMessagesButton = document.querySelector('#private-messages-button');
const privateUnreadBadge = document.querySelector('#private-unread-badge');
const roomMenuWrap = document.querySelector('#room-menu-wrap');
const roomMenuButton = document.querySelector('#room-menu-button');
const roomActionMenu = document.querySelector('#room-action-menu');
const mobileRoomSettingsShortcut = document.querySelector('#mobile-room-settings-shortcut');
const connectionRefreshButton = document.querySelector('#connection-refresh-button');
const videoViewer = document.querySelector('#video-viewer');
const videoViewerName = document.querySelector('#video-viewer-name');
const videoViewerMedia = document.querySelector('#video-viewer-media');
const videoViewerClose = document.querySelector('#video-viewer-close');
const moderationDialog = document.querySelector('#moderation-dialog');
const moderationTargetName = document.querySelector('#moderation-target-name');
const moderationTargetRole = document.querySelector('#moderation-target-role');
const moderationReason = document.querySelector('#moderation-reason');
const moderationDuration = document.querySelector('#moderation-duration');
const moderationClose = document.querySelector('#moderation-close');
const moderationActionButtons = [...document.querySelectorAll('[data-moderation-action]')];
const profileDialog = document.querySelector('#profile-dialog');
const profileClose = document.querySelector('#profile-close');
const profileView = document.querySelector('#profile-view');
const profileAvatar = document.querySelector('#profile-avatar');
const profileFrame = document.querySelector('#profile-frame');
const profileName = document.querySelector('#profile-name');
const profileUsername = document.querySelector('#profile-username');
const profileRole = document.querySelector('#profile-role');
const profileGenderLabel = document.querySelector('#profile-gender-label');
const profileAccountLabel = document.querySelector('#profile-account-label');
const profileBio = document.querySelector('#profile-bio');
const profileJoined = document.querySelector('#profile-joined');
const profileEditButton = document.querySelector('#profile-edit-button');
const profileMessageButton = document.querySelector('#profile-message-button');
const profileGuestNote = document.querySelector('#profile-guest-note');
const profileEditForm = document.querySelector('#profile-edit-form');
const profileEditAvatar = document.querySelector('#profile-edit-avatar');
const profileEditFrame = document.querySelector('#profile-edit-frame');
const profileAvatarInput = document.querySelector('#profile-avatar-input');
const profileAvatarFileButton = document.querySelector('label[for="profile-avatar-input"]');
const profileDisplayName = document.querySelector('#profile-display-name');
const profileBioInput = document.querySelector('#profile-bio-input');
const profileBioCount = document.querySelector('#profile-bio-count');
const profileGender = document.querySelector('#profile-gender-input');
const profileNicknameEffect = document.querySelector('#profile-nickname-effect');
const profileFrameOptions = document.querySelector('#profile-frame-options');
const profileFrameAccessNote = document.querySelector('#profile-frame-access-note');
const profileFrameRemove = document.querySelector('#profile-frame-remove');
const profileSave = document.querySelector('#profile-save');
const profileRemoveAvatar = document.querySelector('#profile-remove-avatar');
const profileEditCancel = document.querySelector('#profile-edit-cancel');
const createRoomDialog = document.querySelector('#create-room-dialog');
const createRoomForm = document.querySelector('#create-room-form');
const createRoomName = document.querySelector('#create-room-name');
const createRoomDescription = document.querySelector('#create-room-description');
const createRoomSeatCount = document.querySelector('#create-room-seat-count');
const createRoomSubmit = document.querySelector('#create-room-submit');
const createRoomClose = document.querySelector('#create-room-close');
const roomSettingsDialog = document.querySelector('#room-settings-dialog');
const roomSettingsTitle = document.querySelector('#room-settings-title');
const roomSettingsClose = document.querySelector('#room-settings-close');
const roomSeatCountValue = document.querySelector('#room-seat-count-value');
const seatCountDecrease = document.querySelector('#seat-count-decrease');
const seatCountIncrease = document.querySelector('#seat-count-increase');
const privateMessagesDialog = document.querySelector('#private-messages-dialog');
const privateMessagesClose = document.querySelector('#private-messages-close');
const privateConversationsPanel = document.querySelector('#private-conversations-panel');
const privateConversationsElement = document.querySelector('#private-conversations');
const privateConversationsCount = document.querySelector('#private-conversations-count');
const privateThreadEmpty = document.querySelector('#private-thread-empty');
const privateThread = document.querySelector('#private-thread');
const privateThreadBack = document.querySelector('#private-thread-back');
const privateThreadAvatar = document.querySelector('#private-thread-avatar');
const privateThreadFrame = document.querySelector('#private-thread-frame');
const privateThreadName = document.querySelector('#private-thread-name');
const privateThreadUsername = document.querySelector('#private-thread-username');
const privateThreadMessages = document.querySelector('#private-thread-messages');
const privateMessageForm = document.querySelector('#private-message-form');
const privateMessageInput = document.querySelector('#private-message-input');
const privateMessageSend = document.querySelector('#private-message-send');

let room = null;
let seatSocket = null;
let session = null;
let authUser = null;
let currentRoomState = null;
let okeySocket = null;
let okeyMediaRoom = null;
let okeyMediaRole = 'disconnected';
let okeyMediaConnectPending = false;
let okeyMediaConnectionGeneration = 0;
let okeyMediaReconnectTimer = null;
let normalMediaSuspendedForOkey = false;
let okeyState = null;
let okeyModeActive = false;
let okeyActionPending = false;
let okeyActionSequence = 0;
let okeySelectedTileId = null;
let okeyRackLayoutKey = null;
let okeyRackGameId = null;
let okeyRackSlots = [];
let okeyRackArrangeMode = false;
let okeyRackMoveTileId = null;
let okeyRackDraggingTileId = null;
let okeyRackSuppressClickUntil = 0;
let okeyConnectPending = false;
let okeyIntentionalLeave = false;
let okeyReconnectTimer = null;
let okeyMediaRenewTimer = null;
let okeyMediaClaimPending = false;
let okeyMediaLeaseGranted = false;
let okeyMediaLeaseExpiresAt = 0;
let okeyLatestMediaGrant = null;
let okeyAutoEnableMicrophone = false;
let okeyMediaLeaseGeneration = 0;
let seatActionPending = false;
let leavingRoom = false;
let forcedExitMessage = null;
let moderationTargetIdentity = null;
let moderationPreviousFocus = null;
let statusDismissTimer = null;
let roomAudioMuted = false;
let roomDirectory = [];
let roomDirectoryPermissions = { canCreateRoom: false };
let selectedRoomSlug = null;
let initialPortalRoomSelectionApplied = false;
let switchingRoom = false;
let roomActionPending = false;
let roomManagerPreviousFocus = null;
let activeProfile = null;
let profilePreviousFocus = null;
let profilePreviewUrl = null;
let selectedAvatarFrame = 'none';
let roomMenuPreviousFocus = null;
let privateDialogPreviousFocus = null;
let privateConversations = [];
let activePrivatePeer = null;
let privateUnreadCountValue = 0;
let privateConversationLoading = false;
let seatReactionPending = false;
let seatReactionCooldownUntil = 0;
let seatReactionControlTimer = null;
let localTypingTimer = null;
let localTypingActive = false;
let remoteTypingCleanupTimer = null;
let chatComposerEnabled = false;
let chatImageFile = null;
let chatImagePreviewUrl = null;
let chatImageUploadPending = false;
const remoteTypers = new Map();

const PORTAL_ANALYTICS_EVENT_API = '/api/public/analytics/event';
const PORTAL_ANALYTICS_UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function portalAnalyticsUuid() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const random = Math.floor(Math.random() * 16);
    const value = character === 'x' ? random : (random & 3) | 8;
    return value.toString(16);
  });
}

function readPortalAnalyticsContext() {
  try {
    const params = new URL(window.location.href).searchParams;
    const visitorId = String(params.get('pv') || '').trim();
    const sessionId = String(params.get('ps') || '').trim();
    const clickId = String(params.get('pc') || '').trim();

    if (
      params.get('portal') !== '1'
      || !PORTAL_ANALYTICS_UUID_PATTERN.test(visitorId)
      || !PORTAL_ANALYTICS_UUID_PATTERN.test(sessionId)
      || !PORTAL_ANALYTICS_UUID_PATTERN.test(clickId)
    ) {
      return null;
    }

    return {
      visitorId,
      sessionId,
      clickId,
      sourcePath: String(params.get('pp') || '/').slice(0, 300),
      sourcePageType: String(params.get('pt') || 'portal').slice(0, 32),
      requestedRoomSlug: String(params.get('room') || '').slice(0, 48),
    };
  } catch {
    return null;
  }
}

const portalAnalyticsContext = readPortalAnalyticsContext();

function portalAnalyticsStorageHas(key) {
  try {
    return sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function portalAnalyticsStorageSet(key) {
  try {
    sessionStorage.setItem(key, '1');
  } catch {
    // Gizli modda oturum depolaması kapalı olabilir.
  }
}

function sendAppPortalAnalytics(eventType, roomSlug = '') {
  if (!portalAnalyticsContext) return;

  const storageKey = `seslicity:${eventType}:${portalAnalyticsContext.clickId}:${roomSlug || '-'}`;
  if (portalAnalyticsStorageHas(storageKey)) return;
  portalAnalyticsStorageSet(storageKey);

  const userAgent = navigator.userAgent || '';
  const deviceType = /iPad|Tablet/i.test(userAgent)
    ? 'tablet'
    : /Mobile|Android|iPhone|iPod/i.test(userAgent)
      ? 'mobile'
      : userAgent
        ? 'desktop'
        : 'other';

  void fetch(PORTAL_ANALYTICS_EVENT_API, {
    method: 'POST',
    credentials: 'omit',
    keepalive: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      eventId: portalAnalyticsUuid(),
      visitorId: portalAnalyticsContext.visitorId,
      sessionId: portalAnalyticsContext.sessionId,
      clickId: portalAnalyticsContext.clickId,
      eventType,
      pageType: 'chat_app',
      pagePath: window.location.pathname,
      pageTitle: document.title,
      sourcePath: portalAnalyticsContext.sourcePath,
      roomSlug: roomSlug || portalAnalyticsContext.requestedRoomSlug || null,
      referrerHost: 'seslicity.com',
      deviceType,
    }),
  }).catch(() => null);
}

const LOCAL_TYPING_IDLE_MS = 1_800;
const REMOTE_TYPING_TTL_MS = 4_000;
const desktopTypingMedia = window.matchMedia('(min-width: 1024px)');

let musicAudioTrack = null;
let musicVideoTrack = null;
let stoppingMusic = false;

const videoTracks = new Map();
const okeyMediaVideoTracks = new Map();
const seatVideoElements = new Map();
const okeyVideoElements = new Map();
const activeSeatReactions = new Map();
const seatReactionTimers = new Map();
let activeSpeakerIdentities = new Set();
let okeyActiveSpeakerIdentities = new Set();
let videoViewerIdentity = null;
let videoViewerTrack = null;
let videoViewerPreviousFocus = null;

const chatEmojis = [
  '😀', '😄', '😁', '😂', '🤣', '😊',
  '😍', '🥰', '😘', '😎', '🤩', '🥳',
  '🤔', '🙄', '😴', '😢', '😭', '😡',
  '👍', '👏', '🙏', '💪', '❤️', '💜',
  '🔥', '✨', '🎉', '🎵', '☕', '🌹',
];

const seatReactionCatalog = [
  { id: 'laugh', emoji: '😂', label: 'Kahkaha' },
  { id: 'kiss', emoji: '😘', label: 'Öpücük' },
  { id: 'love', emoji: '😍', label: 'Aşk' },
  { id: 'wow', emoji: '😮', label: 'Şaşkınlık' },
  { id: 'cool', emoji: '😎', label: 'Havalı' },
];
const seatReactionIds = new Set(seatReactionCatalog.map((reaction) => reaction.id));
const seatReactionButtons = [];
let seatReactionNote = null;

const nicknameEffects = new Set(['none', 'violet', 'gold', 'neon', 'rainbow']);
window.__SESLICITY_GIF_PROFILE_FRAMES__ = '20260806-gif-profile-frames-v1';
const gifAvatarFrameCatalog = Array.from({ length: 42 }, (_item, index) => {
  const number = index + 1;
  const paddedNumber = String(number).padStart(2, '0');

  return {
    id: `gif-${paddedNumber}`,
    name: `GIF ${paddedNumber}`,
    free: true,
    imageUrl: `/cerceve/${number}.gif`,
    previewUrl: `/cerceve/thumbs/${number}.webp`,
  };
});
const avatarFrameCatalog = [
  { id: 'violet', name: 'Mor Akış', free: true },
  { id: 'gold', name: 'Altın Halka', free: true },
  { id: 'neon', name: 'Neon Dalga', free: true },
  { id: 'royal', name: 'Kraliyet', free: false },
  { id: 'diamond', name: 'Elmas', free: false },
  { id: 'flame', name: 'Alev', free: false },
  { id: 'frost', name: 'Buz', free: false },
  { id: 'angel', name: 'Melek Kanadı', free: false },
  { id: 'demon', name: 'Gece Kanadı', free: false },
  { id: 'cosmic', name: 'Kozmik Yörünge', free: false },
  ...gifAvatarFrameCatalog,
];
const avatarFrames = new Set(['none', ...avatarFrameCatalog.map((frame) => frame.id)]);
const freeAvatarFrames = new Set(
  ['none', ...avatarFrameCatalog.filter((frame) => frame.free).map((frame) => frame.id)],
);
const genders = new Set(['unspecified', 'male', 'female']);
const allowedSeatCounts = [4, 6, 8, 12];

function setStatus(message, type = 'normal') {
  clearTimeout(statusDismissTimer);
  statusText.textContent = message;
  statusText.dataset.type = type;
  statusText.classList.remove('is-mobile-hidden');

  if (document.body.classList.contains('room-active')) {
    statusDismissTimer = setTimeout(() => {
      statusText.classList.add('is-mobile-hidden');
    }, 4_500);
  }
}

function roleLabel(role, isVip = false) {
  if (role === 'member' && isVip) return 'VIP Üye';

  return {
    admin: 'Yönetici',
    moderator: 'Moderatör',
    member: 'Üye',
    guest: 'Misafir',
    bot: 'BOT',
  }[role] || 'Üye';
}

async function apiRequest(url, options = {}) {
  const isFormData = options.body instanceof FormData;
  const response = await fetch(url, {
    ...options,
    headers: {
      ...(options.body && !isFormData ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });
  const data = await response.json().catch(() => ({
    status: false,
    message: 'Sunucudan geçersiz yanıt alındı.',
  }));

  if (!response.ok || !data.status) {
    const error = new Error(data.message || 'İşlem tamamlanamadı.');
    error.status = response.status;
    throw error;
  }

  return data;
}

function safeNicknameEffect(value) {
  return nicknameEffects.has(value) ? value : 'none';
}

function hasAllAvatarFrameAccess(subject = {}) {
  return Boolean(
    subject.isVip || subject.role === 'admin' || subject.role === 'moderator',
  );
}

function safeAvatarFrame(value, subject = {}) {
  const requested = avatarFrames.has(value) ? value : 'none';

  return freeAvatarFrames.has(requested) || hasAllAvatarFrameAccess(subject)
    ? requested
    : 'none';
}

function isAvatarFrameSubject(subject = {}) {
  const accountType = subject.accountType
    || (subject.profileId || subject.id ? 'member' : 'guest');

  return accountType === 'member' && subject.role !== 'guest';
}

function renderAvatarFrame(element, subject = {}, preferredFrame = null) {
  if (!element) return;

  const frame = safeAvatarFrame(preferredFrame || subject.avatarFrame, subject);
  const visible = isAvatarFrameSubject(subject) && frame !== 'none';
  const existingImage = element.querySelector('.avatar-frame-image');
  element.hidden = !visible;

  if (!visible) {
    delete element.dataset.frame;
    element.removeAttribute('title');
    element.classList.remove('is-gif-frame');
    existingImage?.remove();
    return;
  }

  const frameInfo = avatarFrameCatalog.find((item) => item.id === frame);
  element.dataset.frame = frame;
  element.title = frameInfo?.name || 'Profil çerçevesi';

  if (!frameInfo?.imageUrl) {
    element.classList.remove('is-gif-frame');
    existingImage?.remove();
    return;
  }

  const isPickerPreview = element.classList.contains('frame-picker-decoration');
  const sourceUrl = isPickerPreview
    ? frameInfo.previewUrl || frameInfo.imageUrl
    : frameInfo.imageUrl;
  const image = existingImage || document.createElement('img');
  image.className = 'avatar-frame-image';
  image.alt = '';
  image.decoding = 'async';
  image.loading = isPickerPreview ? 'lazy' : 'eager';
  image.setAttribute('fetchpriority', isPickerPreview ? 'low' : 'auto');

  if (image.getAttribute('src') !== sourceUrl) image.src = sourceUrl;
  if (!existingImage) element.append(image);
  element.classList.add('is-gif-frame');
}

function createAvatarFrameElement(subject, className = '', preferredFrame = null) {
  const frame = document.createElement('span');
  frame.className = `animated-avatar-frame ${className}`.trim();
  frame.setAttribute('aria-hidden', 'true');
  renderAvatarFrame(frame, subject, preferredFrame);
  return frame;
}

function renderAvatarFramePicker() {
  if (!activeProfile) return;

  const allUnlocked = hasAllAvatarFrameAccess(activeProfile);
  selectedAvatarFrame = safeAvatarFrame(selectedAvatarFrame, activeProfile);
  profileFrameOptions.replaceChildren();
  profileFrameRemove.classList.toggle('is-selected', selectedAvatarFrame === 'none');
  profileFrameRemove.setAttribute('aria-pressed', String(selectedAvatarFrame === 'none'));
  const freeFrameCount = avatarFrameCatalog.filter((frame) => frame.free).length;
  const vipFrameCount = avatarFrameCatalog.length - freeFrameCount;
  profileFrameAccessNote.textContent = allUnlocked
    ? `Koleksiyondaki ${avatarFrameCatalog.length} çerçevenin tamamı açık.`
    : `${freeFrameCount} çerçeve ücretsiz. ${vipFrameCount} klasik çerçeve VIP üyelere özeldir.`;

  for (const frameInfo of avatarFrameCatalog) {
    const unlocked = frameInfo.free || allUnlocked;
    const selected = frameInfo.id === selectedAvatarFrame;
    const option = document.createElement('button');
    option.className = 'frame-picker-option';
    option.classList.toggle('is-selected', selected);
    option.classList.toggle('is-locked', !unlocked);
    option.type = 'button';
    option.disabled = !unlocked;
    option.dataset.frameOption = frameInfo.id;
    option.setAttribute('role', 'radio');
    option.setAttribute('aria-checked', String(selected));
    option.title = unlocked
      ? `${frameInfo.name} çerçevesini seç`
      : `${frameInfo.name} • VIP`;

    const preview = document.createElement('span');
    preview.className = 'frame-picker-preview';
    const avatar = document.createElement('span');
    avatar.className = 'frame-picker-avatar';
    avatar.textContent = initials(activeProfile.displayName);
    const decoration = createAvatarFrameElement(
      { ...activeProfile, avatarFrame: frameInfo.id, isVip: true },
      'frame-picker-decoration',
      frameInfo.id,
    );
    preview.append(avatar, decoration);
    const label = document.createElement('span');
    label.className = 'frame-picker-label';
    label.textContent = frameInfo.name;
    const access = document.createElement('small');
    access.textContent = frameInfo.free
      ? 'ÜCRETSİZ'
      : unlocked
        ? 'VIP AÇIK'
        : '🔒 VIP';

    option.append(preview, label, access);

    if (unlocked) {
      option.addEventListener('click', () => {
        selectedAvatarFrame = frameInfo.id;
        renderAvatarFrame(profileEditFrame, activeProfile, selectedAvatarFrame);
        renderAvatar(profileEditAvatar, {
          ...activeProfile,
          displayName: profileDisplayName.value || activeProfile.displayName,
          avatarUrl: profilePreviewUrl || activeProfile.avatarUrl,
          avatarFrame: selectedAvatarFrame,
        });
        renderAvatarFramePicker();
      });
    }

    profileFrameOptions.append(option);
  }
}

function safeGender(value) {
  return genders.has(value) ? value : 'unspecified';
}

function genderLabel(value) {
  return {
    female: 'Kadın',
    male: 'Erkek',
    unspecified: 'Belirtilmemiş',
  }[safeGender(value)];
}

function setDesktopSidebarView(view = 'users') {
  const activeView = view === 'rooms' ? 'rooms' : 'users';
  document.body.classList.toggle('desktop-sidebar-rooms', activeView === 'rooms');
  document.body.classList.toggle('desktop-sidebar-users', activeView === 'users');
  desktopRoomsTab?.classList.toggle('is-active', activeView === 'rooms');
  desktopUsersTab?.classList.toggle('is-active', activeView === 'users');
  desktopRoomsTab?.setAttribute('aria-selected', String(activeView === 'rooms'));
  desktopUsersTab?.setAttribute('aria-selected', String(activeView === 'users'));
}

function renderDesktopAccount(user = authUser) {
  if (!desktopAccountAvatar) return;

  if (!user) {
    desktopAccountAvatar.textContent = 'YS';
    renderAvatarFrame(desktopAccountFrame, {});
    desktopAccountName.textContent = 'Seslicity';
    desktopAccountMeta.textContent = 'Sohbet kullanıcısı';
    desktopSignupButton.textContent = 'Üye Ol';
    return;
  }

  const isGuest = user.accountType === 'guest' || user.role === 'guest';
  renderAvatar(desktopAccountAvatar, user);
  renderAvatarFrame(desktopAccountFrame, user);
  desktopAccountName.textContent = user.displayName || 'Seslicity';
  applyNicknameEffect(desktopAccountName, user.nicknameEffect);
  desktopAccountMeta.textContent = isGuest
    ? 'Misafir • Çevrimiçi'
    : `${roleLabel(user.role, user.isVip)} • Çevrimiçi`;
  desktopSignupButton.textContent = isGuest ? 'Üye Ol' : 'Profilim';
}

function applyNicknameEffect(element, value) {
  for (const effect of nicknameEffects) {
    element.classList.remove(`nickname-effect-${effect}`);
  }

  const effect = safeNicknameEffect(value);
  element.classList.toggle('nickname-effect', effect !== 'none');
  if (effect !== 'none') element.classList.add(`nickname-effect-${effect}`);
}

function renderAvatar(element, subject = {}) {
  for (const frame of avatarFrames) {
    element.classList.remove(`avatar-frame-${frame}`);
  }

  const frame = safeAvatarFrame(subject.avatarFrame, subject);
  element.textContent = initials(subject.displayName || subject.name);
  element.classList.add(`avatar-frame-${frame}`);

  if (subject.avatarUrl) {
    const image = document.createElement('img');
    image.className = 'avatar-image';
    image.src = subject.avatarUrl;
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    element.append(image);
  }
}

function joinedDateText(value) {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return `${new Intl.DateTimeFormat('tr-TR', {
    month: 'long',
    year: 'numeric',
  }).format(date)} tarihinde katıldı`;
}


function syncGuestGenderCards(value = guestGender?.value || '') {
  guestGenderOptions.forEach((option) => {
    const active = option.dataset.genderValue === value;
    option.classList.toggle('is-selected', active);
    option.setAttribute('aria-checked', String(active));
    option.tabIndex = active || (!value && option === guestGenderOptions[0]) ? 0 : -1;
  });

  if (guestGenderError) guestGenderError.hidden = Boolean(value);
}

function setGuestGender(value, focus = false) {
  if (!guestGender || !['male', 'female', 'unspecified'].includes(value)) return;
  guestGender.value = value;
  syncGuestGenderCards(value);

  if (focus) {
    guestGenderOptions.find((option) => option.dataset.genderValue === value)
      ?.focus({ preventScroll: true });
  }
}

function setAuthTab(tab) {
  const activeTab = ['guest', 'login', 'register'].includes(tab)
    ? tab
    : 'guest';
  const showGuest = activeTab === 'guest';
  const showLogin = activeTab === 'login';
  const showRegister = activeTab === 'register';

  guestTab.classList.toggle('is-active', showGuest);
  loginTab.classList.toggle('is-active', showLogin);
  registerTab.classList.toggle('is-active', showRegister);

  guestTab.setAttribute('aria-selected', String(showGuest));
  loginTab.setAttribute('aria-selected', String(showLogin));
  registerTab.setAttribute('aria-selected', String(showRegister));

  guestForm.hidden = !showGuest;
  loginForm.hidden = !showLogin;
  registerForm.hidden = !showRegister;

  if (!authLoading.hidden) return;

  const focusTarget = showGuest
    ? guestDisplayName
    : showLogin
      ? loginIdentifier
      : registerUsername;
  focusTarget?.focus({ preventScroll: true });
}



function getDesktopTheme() {
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';
}

function updateDesktopThemeToggle(theme = getDesktopTheme()) {
  if (!desktopThemeToggle) return;

  const light = theme === 'light';
  const label = light ? 'Gece moduna geç' : 'Gündüz moduna geç';
  desktopThemeToggle.setAttribute('aria-label', label);
  desktopThemeToggle.setAttribute('title', label);
  desktopThemeToggle.setAttribute('aria-pressed', String(light));

  if (desktopThemeToggleIcon) {
    desktopThemeToggleIcon.textContent = light ? '☀' : '☾';
  }
}

function applyDesktopTheme(theme = 'dark', persist = true) {
  const nextTheme = theme === 'light' ? 'light' : 'dark';
  document.documentElement.dataset.theme = nextTheme;
  updateDesktopThemeToggle(nextTheme);

  if (!persist) return;

  try {
    window.localStorage.setItem(DESKTOP_THEME_STORAGE_KEY, nextTheme);
  } catch (error) {
    // ignore storage errors
  }
}

function loadDesktopTheme() {
  let savedTheme = 'dark';

  try {
    const raw = window.localStorage.getItem(DESKTOP_THEME_STORAGE_KEY);
    if (raw === 'light' || raw === 'dark') savedTheme = raw;
  } catch (error) {
    // ignore storage errors
  }

  applyDesktopTheme(savedTheme, false);
}

function mountAuthOverlay() {
  if (joinPanel.parentNode !== document.body) document.body.append(joinPanel);
}

function restoreAuthPanelHome() {
  const { parent, nextSibling } = joinPanelHome;
  if (!(parent instanceof Node) || !parent.isConnected) return;

  if (nextSibling instanceof Node && nextSibling.parentNode === parent) {
    parent.insertBefore(joinPanel, nextSibling);
    return;
  }

  parent.append(joinPanel);
}

function openAuthOverlay(tab = 'register') {
  setAuthTab('register');

  if (!document.body.classList.contains('room-active')) {
    joinPanel.hidden = false;
    joinPanel.scrollIntoView({ block: 'start', behavior: 'smooth' });
    return;
  }

  mountAuthOverlay();
  joinPanel.hidden = false;
  joinPanel.classList.add('register-only-overlay');
  authLoading.hidden = true;
  authForms.hidden = false;
  memberPanel.hidden = true;
  document.body.classList.add('auth-overlay-open');
  if (authOverlayClose) authOverlayClose.hidden = false;
  window.requestAnimationFrame(() => registerUsername?.focus({ preventScroll: true }));
}

function closeAuthOverlay(restoreFocus = false) {
  document.body.classList.remove('auth-overlay-open');
  joinPanel.classList.remove('register-only-overlay');
  if (authOverlayClose) authOverlayClose.hidden = true;

  if (document.body.classList.contains('room-active')) {
    joinPanel.hidden = true;
    authForms.hidden = Boolean(authUser);
    memberPanel.hidden = !authUser;
    restoreAuthPanelHome();
  }

  if (restoreFocus && desktopSignupButton instanceof HTMLElement) {
    desktopSignupButton.focus({ preventScroll: true });
  }
}

function renderAuthUser(user) {
  authUser = user || null;
  authLoading.hidden = true;
  authForms.hidden = Boolean(authUser);
  memberPanel.hidden = !authUser;

  if (!authUser) {
    if (adminPanelLink) adminPanelLink.hidden = true;
    if (chatContextAdmin) chatContextAdmin.hidden = true;
    if (chatContextAdminDivider) chatContextAdminDivider.hidden = true;
    setPrivateUnreadCount(0);
    privateMessagesButton.disabled = true;
    memberAvatar.textContent = 'YS';
    mobileHeaderAvatar.textContent = 'YS';
    renderAvatarFrame(memberFrame, {});
    renderDesktopAccount(null);
    applyNicknameEffect(memberName, 'none');
    logoutButton.textContent = 'Bu hesaptan çıkış yap';
    renderRoomDirectory();
    setStatus('Misafir olarak katılabilir, üye girişi yapabilir veya yeni hesap oluşturabilirsin.', 'normal');
    return;
  }

  const isGuest = authUser.accountType === 'guest' || authUser.role === 'guest';
  if (adminPanelLink) adminPanelLink.hidden = authUser.role !== 'admin';
  if (chatContextAdmin) chatContextAdmin.hidden = authUser.role !== 'admin';
  if (chatContextAdminDivider) chatContextAdminDivider.hidden = authUser.role !== 'admin';
  if (isGuest) setPrivateUnreadCount(0);
  renderAvatar(memberAvatar, authUser);
  renderAvatar(mobileHeaderAvatar, authUser);
  renderDesktopAccount(authUser);
  renderAvatarFrame(memberFrame, authUser);
  memberName.textContent = authUser.displayName;
  applyNicknameEffect(memberName, authUser.nicknameEffect);
  memberUsername.textContent = isGuest
    ? 'Geçici misafir oturumu'
    : `@${authUser.username}`;
  memberRole.textContent = roleLabel(authUser.role, authUser.isVip);
  memberRole.dataset.role = authUser.isVip ? 'vip' : authUser.role;
  logoutButton.textContent = isGuest
    ? 'Misafir oturumunu kapat'
    : 'Bu hesaptan çıkış yap';
  renderRoomDirectory();
  if (!isGuest && document.body.classList.contains('auth-overlay-open')) closeAuthOverlay();
  setStatus(`Hoş geldin ${authUser.displayName}. Odaya katılmaya hazırsın.`, 'success');
}


function readSsoTicketFromUrl() {
  const url = new URL(window.location.href);

  const queryTicket = url.searchParams.get('sso');

  if (queryTicket) {
    return queryTicket;
  }

  const hash = String(url.hash || '');

  if (!hash.startsWith('#sso=')) {
    return null;
  }

  const encodedTicket = hash.slice('#sso='.length);

  if (!encodedTicket) {
    return null;
  }

  try {
    return decodeURIComponent(encodedTicket);
  } catch {
    return null;
  }
}

function clearSsoTicketFromUrl() {
  const url = new URL(window.location.href);

  url.searchParams.delete('sso');
  url.hash = '';

  const cleanUrl =
    `${url.pathname}${url.search}`;

  window.history.replaceState(
    null,
    document.title,
    cleanUrl,
  );
}

async function consumeSsoTicket() {
  const ticket = readSsoTicketFromUrl();

  if (!ticket) {
    return false;
  }

  /*
   * Bilet tek kullanımlıktır. Adres çubuğundan mümkün olduğunca
   * erken kaldırılarak tarayıcı geçmişinde veya ekran görüntüsünde
   * görünmesi engellenir.
   */
  clearSsoTicketFromUrl();

  authLoading.hidden = false;
  authForms.hidden = true;
  memberPanel.hidden = true;
  setStatus('Yalla hesabın güvenli şekilde bağlanıyor…', 'warning');

  try {
    const data = await apiRequest('/api/auth/sso', {
      method: 'POST',
      body: JSON.stringify({ ticket }),
    });

    renderAuthUser(data.user);
    setStatus(
      `Hoş geldin ${data.user.displayName}. Yalla hesabınla giriş yaptın.`,
      'success',
    );

    return true;
  } catch (error) {
    authLoading.hidden = true;
    authForms.hidden = false;
    memberPanel.hidden = true;

    setStatus(
      error.message || 'Yalla hesabıyla giriş tamamlanamadı.',
      'error',
    );

    return false;
  }
}

async function loadAuthSession() {
  try {
    const data = await apiRequest('/api/auth/me');
    renderAuthUser(data.authenticated ? data.user : null);
  } catch (error) {
    authLoading.hidden = true;
    authForms.hidden = false;
    memberPanel.hidden = true;
    setStatus(error.message || 'Üyelik bilgileri alınamadı.', 'error');
  }
}

function setConnectionBadge(message, connected = true) {
  connectionBadge.textContent = message;
  connectionBadge.classList.toggle('is-offline', !connected);
}

function setUsersDrawer(open) {
  const shouldOpen = Boolean(open && room);
  document.body.classList.toggle('users-drawer-open', shouldOpen);
  usersDrawerBackdrop.hidden = !shouldOpen;
  mobileUsersButton.setAttribute('aria-expanded', String(shouldOpen));

  if (shouldOpen) {
    usersPanelClose.focus({ preventScroll: true });
  }
}

function setRoomsDrawer(open) {
  const shouldOpen = Boolean(open && room);
  document.body.classList.toggle('rooms-drawer-open', shouldOpen);
  roomsDrawerBackdrop.hidden = !shouldOpen;
  mobileRoomsButton.setAttribute('aria-expanded', String(shouldOpen));

  if (shouldOpen) roomsPanelClose.focus({ preventScroll: true });
}

function isPrivateMessageMember() {
  return Boolean(
    authUser
    && authUser.accountType === 'member'
    && authUser.role !== 'guest',
  );
}

function setPrivateUnreadCount(value) {
  const count = Math.max(0, Number(value) || 0);
  privateUnreadCountValue = count;
  privateUnreadBadge.hidden = count < 1;
  privateUnreadBadge.textContent = count > 99 ? '99+' : String(count);
  if (desktopPrivateUnreadBadge) {
    desktopPrivateUnreadBadge.hidden = count < 1;
    desktopPrivateUnreadBadge.textContent = count > 99 ? '99+' : String(count);
  }
  mobileAccountUnreadBadge.hidden = count < 1;
  mobileAccountUnreadBadge.textContent = count > 99 ? '99+' : String(count);
  privateMessagesButton.classList.toggle('has-unread', count > 0);
  desktopPrivateMessagesButton?.classList.toggle('has-unread', count > 0);
  privateMessagesButton.setAttribute(
    'aria-label',
    count > 0 ? `Özel mesajları aç, ${count} okunmamış mesaj` : 'Özel mesajları aç',
  );
  desktopPrivateMessagesButton?.setAttribute(
    'aria-label',
    count > 0 ? `Özel mesajları aç, ${count} okunmamış mesaj` : 'Özel mesajları aç',
  );
}

function setMobileAccountMenu(open, restoreFocus = false) {
  const shouldOpen = Boolean(open && room && !okeyModeActive);
  mobileAccountMenu.hidden = !shouldOpen;
  mobileProfileButton.setAttribute('aria-expanded', String(shouldOpen));

  if (shouldOpen) {
    mobileAccountProfileButton.focus({ preventScroll: true });
  } else if (restoreFocus) {
    mobileProfileButton.focus({ preventScroll: true });
  }
}

function setRoomMenu(open, restoreFocus = false) {
  const shouldOpen = Boolean(open && room);

  if (shouldOpen) roomMenuPreviousFocus = document.activeElement;
  roomActionMenu.hidden = !shouldOpen;
  roomMenuButton.setAttribute('aria-expanded', String(shouldOpen));
  roomMenuWrap.classList.toggle('is-open', shouldOpen);

  if (shouldOpen) {
    const firstEnabled = roomActionMenu.querySelector('button:not(:disabled)');
    firstEnabled?.focus({ preventScroll: true });
  } else if (restoreFocus && roomMenuPreviousFocus instanceof HTMLElement) {
    roomMenuPreviousFocus.focus({ preventScroll: true });
  }

  if (!shouldOpen) roomMenuPreviousFocus = null;
}

function privateMessageTime(value, includeDate = false) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return includeDate
    ? date.toLocaleDateString('tr-TR', { day: '2-digit', month: 'short' })
    : date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
}

function renderPrivateConversations() {
  privateConversationsElement.replaceChildren();
  privateConversationsCount.textContent = `${privateConversations.length} konuşma`;

  if (!privateConversations.length) {
    const empty = document.createElement('p');
    empty.className = 'private-list-status';
    empty.textContent = 'Henüz özel mesaj konuşman yok.';
    privateConversationsElement.append(empty);
    return;
  }

  for (const conversation of privateConversations) {
    const { peer, lastMessage } = conversation;
    const button = document.createElement('button');
    button.className = 'private-conversation';
    button.classList.toggle('is-active', peer.id === activePrivatePeer?.id);
    button.classList.toggle('has-unread', conversation.unreadCount > 0);
    button.type = 'button';

    const avatarWrap = document.createElement('span');
    avatarWrap.className = 'private-conversation-avatar-wrap';
    const avatar = document.createElement('span');
    avatar.className = 'private-conversation-avatar';
    renderAvatar(avatar, peer);
    avatarWrap.append(avatar, createAvatarFrameElement(peer, 'private-conversation-frame'));

    const copy = document.createElement('span');
    copy.className = 'private-conversation-copy';
    const header = document.createElement('span');
    header.className = 'private-conversation-header';
    const name = document.createElement('strong');
    name.textContent = peer.displayName;
    applyNicknameEffect(name, peer.nicknameEffect);
    const time = document.createElement('time');
    time.textContent = privateMessageTime(lastMessage.createdAt);
    header.append(name, time);

    const preview = document.createElement('span');
    preview.className = 'private-conversation-preview';
    preview.textContent = `${lastMessage.fromSelf ? 'Sen: ' : ''}${lastMessage.message}`;
    copy.append(header, preview);
    button.append(avatarWrap, copy);

    if (conversation.unreadCount > 0) {
      const unread = document.createElement('span');
      unread.className = 'private-conversation-unread';
      unread.textContent = conversation.unreadCount > 99
        ? '99+'
        : String(conversation.unreadCount);
      button.append(unread);
    }

    button.addEventListener('click', () => {
      void openPrivateConversation(peer);
    });
    privateConversationsElement.append(button);
  }
}

async function loadPrivateConversations(showLoading = true) {
  if (!isPrivateMessageMember() || privateConversationLoading) return;

  privateConversationLoading = true;
  if (showLoading) {
    const loading = document.createElement('p');
    loading.className = 'private-list-status';
    loading.textContent = 'Konuşmalar yükleniyor…';
    privateConversationsElement.replaceChildren(loading);
  }

  try {
    const data = await apiRequest('/api/private-messages/conversations');
    privateConversations = data.conversations || [];
    setPrivateUnreadCount(data.unreadCount);
    renderPrivateConversations();
  } catch (error) {
    if (showLoading) {
      const failed = document.createElement('p');
      failed.className = 'private-list-status is-error';
      failed.textContent = error.message || 'Konuşmalar yüklenemedi.';
      privateConversationsElement.replaceChildren(failed);
    }
  } finally {
    privateConversationLoading = false;
  }
}

function renderPrivateThreadPeer(peer) {
  activePrivatePeer = peer;
  renderAvatar(privateThreadAvatar, peer);
  renderAvatarFrame(privateThreadFrame, peer);
  privateThreadName.textContent = peer.displayName;
  applyNicknameEffect(privateThreadName, peer.nicknameEffect);
  privateThreadUsername.textContent = peer.username ? `@${peer.username}` : 'Kayıtlı üye';
  privateThreadEmpty.hidden = true;
  privateThread.hidden = false;
  privateMessagesDialog.classList.add('is-thread-open');
  renderPrivateConversations();
}

function appendPrivateMessage(message) {
  if (!message?.id || privateThreadMessages.querySelector(`[data-message-id="${CSS.escape(message.id)}"]`)) {
    return;
  }

  const article = document.createElement('article');
  article.className = 'private-message';
  article.classList.toggle('is-self', Boolean(message.fromSelf));
  article.dataset.messageId = message.id;

  const meta = document.createElement('div');
  meta.className = 'private-message-meta';
  const sender = document.createElement('strong');
  sender.textContent = message.fromSelf ? 'Sen' : activePrivatePeer?.displayName || 'Üye';
  const time = document.createElement('time');
  time.textContent = privateMessageTime(message.createdAt);
  meta.append(sender, time);

  const bubble = document.createElement('div');
  bubble.className = 'private-message-bubble';
  bubble.textContent = message.message;
  article.append(meta, bubble);

  if (message.fromSelf) {
    const receipt = document.createElement('small');
    receipt.className = 'private-message-receipt';
    receipt.textContent = message.readAt ? 'Okundu' : 'Gönderildi';
    article.append(receipt);
  }

  privateThreadMessages.append(article);
  privateThreadMessages.scrollTop = privateThreadMessages.scrollHeight;
}

async function openPrivateConversation(peer) {
  if (!peer?.id || !isPrivateMessageMember()) return;

  renderPrivateThreadPeer(peer);
  const loading = document.createElement('p');
  loading.className = 'private-thread-status';
  loading.textContent = 'Mesajlar yükleniyor…';
  privateThreadMessages.replaceChildren(loading);
  privateMessageInput.disabled = true;
  privateMessageSend.disabled = true;

  try {
    const data = await apiRequest(
      `/api/private-messages/${encodeURIComponent(peer.id)}`,
    );
    renderPrivateThreadPeer(data.peer);
    setPrivateUnreadCount(data.unreadCount);
    privateThreadMessages.replaceChildren();

    if (!data.messages?.length) {
      const empty = document.createElement('p');
      empty.className = 'private-thread-status';
      empty.textContent = 'İlk özel mesajı sen gönder.';
      privateThreadMessages.append(empty);
    } else {
      data.messages.forEach(appendPrivateMessage);
    }

    privateConversations = privateConversations.map((conversation) => (
      conversation.peer.id === data.peer.id
        ? { ...conversation, peer: data.peer, unreadCount: 0 }
        : conversation
    ));
    renderPrivateConversations();
    privateMessageInput.disabled = false;
    privateMessageSend.disabled = false;
    privateMessageInput.focus({ preventScroll: true });
  } catch (error) {
    const failed = document.createElement('p');
    failed.className = 'private-thread-status is-error';
    failed.textContent = error.message || 'Mesajlar yüklenemedi.';
    privateThreadMessages.replaceChildren(failed);
  }
}

async function openPrivateMessages(peer = null, trigger = null) {
  if (!isPrivateMessageMember()) {
    setStatus('Özel mesajlar yalnızca kayıtlı üyeler tarafından kullanılabilir.', 'warning');
    return;
  }

  privateDialogPreviousFocus = trigger || document.activeElement;
  setRoomMenu(false);
  privateMessagesDialog.hidden = false;
  document.body.classList.add('private-messages-open');
  await loadPrivateConversations();

  if (peer?.id && peer.id !== authUser.id) {
    await openPrivateConversation(peer);
  } else {
    privateMessagesClose.focus({ preventScroll: true });
  }
}

function closePrivateMessages(restoreFocus = true) {
  privateMessagesDialog.hidden = true;
  privateMessagesDialog.classList.remove('is-thread-open');
  document.body.classList.remove('private-messages-open');
  privateThread.hidden = true;
  privateThreadEmpty.hidden = false;
  privateThreadMessages.replaceChildren();
  activePrivatePeer = null;

  if (restoreFocus && privateDialogPreviousFocus instanceof HTMLElement) {
    privateDialogPreviousFocus.focus({ preventScroll: true });
  }

  privateDialogPreviousFocus = null;
}

function handlePrivateMessage(payload) {
  if (!payload?.id || !isPrivateMessageMember()) return;

  const fromSelf = payload.senderId === authUser.id;
  const peer = fromSelf ? payload.recipient : payload.sender;
  const message = { ...payload, fromSelf };

  if (
    activePrivatePeer?.id === peer?.id
    && !privateMessagesDialog.hidden
  ) {
    const status = privateThreadMessages.querySelector('.private-thread-status');
    status?.remove();
    appendPrivateMessage(message);

    if (!fromSelf) {
      void emitWithAck('private:read', { peerId: peer.id }, 6_000).catch(() => null);
    }
  } else if (!fromSelf) {
    setStatus(`${peer?.displayName || 'Bir üye'} sana özel mesaj gönderdi.`, 'success');
  }

  void loadPrivateConversations(false);
}

function handlePrivateRead(payload) {
  if (!payload?.readerId || payload.readerId !== activePrivatePeer?.id) return;

  privateThreadMessages
    .querySelectorAll('.private-message.is-self .private-message-receipt')
    .forEach((receipt) => {
      receipt.textContent = 'Okundu';
    });
}

function activeDirectoryRoom() {
  const slug = session?.roomSlug || selectedRoomSlug;
  return roomDirectory.find((item) => item.slug === slug) || null;
}

function canCreateRoom() {
  if (!authUser || authUser.accountType !== 'member') return false;
  return authUser.role === 'admin'
    || Boolean(authUser.isVip)
    || Boolean(roomDirectoryPermissions.canCreateRoom)
    || isSelfOwner();
}

function canManageActiveRoom() {
  if (!authUser || authUser.accountType !== 'member') return false;
  const activeRoom = activeDirectoryRoom();
  return authUser.role === 'admin'
    || Boolean(activeRoom?.canManage)
    || isSelfOwner();
}

function requestedPortalRoomSlug() {
  try {
    return String(
      new URL(window.location.href).searchParams.get('room') || '',
    ).trim();
  } catch {
    return '';
  }
}

function mergeRoomDirectory(incomingRooms = []) {
  const previousBySlug = new Map(roomDirectory.map((item) => [item.slug, item]));
  roomDirectory = incomingRooms.map((item) => ({
    ...item,
    canManage: Boolean(item.canManage || previousBySlug.get(item.slug)?.canManage),
  }));

  if (!initialPortalRoomSelectionApplied) {
    initialPortalRoomSelectionApplied = true;
    const requestedRoomSlug = requestedPortalRoomSlug();

    if (roomDirectory.some((item) => item.slug === requestedRoomSlug)) {
      selectedRoomSlug = requestedRoomSlug;
      document.documentElement.dataset.portalRoomLink = 'v1';
    }
  }

  if (!selectedRoomSlug || !roomDirectory.some((item) => item.slug === selectedRoomSlug)) {
    selectedRoomSlug = roomDirectory[0]?.slug || null;
  }
}

function applyRoomDirectoryData(data = {}) {
  if (Array.isArray(data.rooms)) mergeRoomDirectory(data.rooms);
  if (data.permissions) {
    roomDirectoryPermissions = {
      ...roomDirectoryPermissions,
      ...data.permissions,
    };
  }

  updateParticipantCount();
  renderRoomDirectory();
}

function applyActiveRoomBackground(roomItem = null) {
  const imageUrl = String(roomItem?.chatBackgroundImageUrl || '').trim();
  const position = String(roomItem?.chatBackgroundPosition || 'center center').trim();
  const overlay = Math.max(0, Math.min(85, Number(roomItem?.chatBackgroundOverlay ?? 55))) / 100;

  if (imageUrl) {
    roomPanel.style.setProperty('--room-bg-image', `url(${JSON.stringify(imageUrl)})`);
    roomPanel.style.setProperty('--room-bg-position', position || 'center center');
    roomPanel.style.setProperty('--room-bg-overlay', String(overlay));
    roomPanel.classList.add('has-custom-room-background');
  } else {
    roomPanel.style.removeProperty('--room-bg-image');
    roomPanel.style.removeProperty('--room-bg-position');
    roomPanel.style.removeProperty('--room-bg-overlay');
    roomPanel.classList.remove('has-custom-room-background');
  }
}

function roomInitials(name) {
  return initials(name).slice(0, 2);
}

function renderRoomDirectory() {
  roomList.replaceChildren();
  const activeSlug = session?.roomSlug || selectedRoomSlug;

  if (!roomDirectory.length) {
    const empty = document.createElement('div');
    empty.className = 'room-list-loading';
    empty.textContent = 'Aktif sohbet odası bulunamadı.';
    roomList.append(empty);
  }

  for (const roomItem of roomDirectory) {
    const button = document.createElement('button');
    button.className = 'room-list-item';
    button.classList.toggle('is-active', roomItem.slug === activeSlug);
    button.type = 'button';
    button.dataset.roomSlug = roomItem.slug;

    const icon = document.createElement('span');
    icon.className = 'room-list-icon';
    icon.textContent = roomInitials(roomItem.name);

    const copy = document.createElement('span');
    copy.className = 'room-list-copy';

    const name = document.createElement('strong');
    name.textContent = roomItem.name;

    const meta = document.createElement('small');
    if (session?.roomSlug === roomItem.slug) {
      const dot = document.createElement('span');
      dot.className = 'live-dot';
      meta.append(dot, document.createTextNode(' Şu an buradasın'));
    } else {
      meta.textContent = `${roomItem.onlineCount || 0} kişi • ${roomItem.occupiedSeats || 0}/${roomItem.seatCount} koltuk`;
    }

    copy.append(name, meta);
    button.append(icon, copy);
    button.addEventListener('click', () => {
      if (roomActionPending || session?.roomSlug === roomItem.slug) {
        setRoomsDrawer(false);
        return;
      }

      selectedRoomSlug = roomItem.slug;
      renderRoomDirectory();
      setRoomsDrawer(false);
      setDesktopSidebarView('users');

      if (room) void switchToRoom(roomItem.slug);
    });
    roomList.append(button);
  }

  const previousSelection = selectedRoomSlug;
  joinRoomSelect.replaceChildren();
  for (const roomItem of roomDirectory) {
    const option = document.createElement('option');
    option.value = roomItem.slug;
    option.textContent = `${roomItem.name} — ${roomItem.onlineCount || 0} kişi`;
    joinRoomSelect.append(option);
  }
  joinRoomSelect.value = previousSelection || roomDirectory[0]?.slug || '';
  joinRoomSelect.disabled = roomDirectory.length === 0;

  const selected = roomDirectory.find((item) => item.slug === selectedRoomSlug)
    || roomDirectory[0];
  if (selected) {
    joinRoomName.textContent = selected.name;
    joinRoomMeta.textContent = `${selected.seatCount} koltuk • ${selected.onlineCount || 0} kişi çevrimiçi`;
  }

  const activeRoomItem = roomDirectory.find((item) => item.slug === activeSlug) || selected;
  if (document.body.classList.contains('room-active')) {
    applyActiveRoomBackground(activeRoomItem);
  }

  createRoomButton.hidden = !canCreateRoom();
  roomSettingsButton.hidden = !room || !canManageActiveRoom();
  mobileRoomSettingsShortcut.hidden = roomSettingsButton.hidden;
}

async function loadRoomDirectory() {
  try {
    const data = await apiRequest('/api/rooms');
    applyRoomDirectoryData(data);
  } catch (error) {
    roomList.replaceChildren();
    const message = document.createElement('div');
    message.className = 'room-list-loading';
    message.textContent = 'Odalar şu anda yüklenemiyor.';
    roomList.append(message);
    setStatus(error.message || 'Sohbet odaları alınamadı.', 'error');
  }
}

function closeCreateRoomDialog(restoreFocus = true) {
  createRoomDialog.hidden = true;
  document.body.classList.remove('room-manager-dialog-open');
  if (restoreFocus && roomManagerPreviousFocus instanceof HTMLElement) {
    roomManagerPreviousFocus.focus({ preventScroll: true });
  }
  roomManagerPreviousFocus = null;
}

function openCreateRoomDialog() {
  if (!canCreateRoom()) return;
  setRoomsDrawer(false);
  roomManagerPreviousFocus = document.activeElement;
  createRoomForm.reset();
  createRoomSeatCount.value = '12';
  createRoomDialog.hidden = false;
  document.body.classList.add('room-manager-dialog-open');
  createRoomName.focus({ preventScroll: true });
}

function updateSeatStepper() {
  const activeRoom = activeDirectoryRoom();
  const currentCount = Number(activeRoom?.seatCount || currentRoomState?.seatCount || 12);
  const index = allowedSeatCounts.indexOf(currentCount);
  roomSeatCountValue.textContent = String(currentCount);
  seatCountDecrease.disabled = roomActionPending || index <= 0;
  seatCountIncrease.disabled = roomActionPending || index < 0 || index >= allowedSeatCounts.length - 1;
}

function closeRoomSettingsDialog(restoreFocus = true) {
  roomSettingsDialog.hidden = true;
  document.body.classList.remove('room-manager-dialog-open');
  if (restoreFocus && roomManagerPreviousFocus instanceof HTMLElement) {
    roomManagerPreviousFocus.focus({ preventScroll: true });
  }
  roomManagerPreviousFocus = null;
}

function openRoomSettingsDialog() {
  const activeRoom = activeDirectoryRoom();
  if (!activeRoom || !canManageActiveRoom()) return;
  roomManagerPreviousFocus = document.activeElement;
  roomSettingsTitle.textContent = activeRoom.name;
  updateSeatStepper();
  roomSettingsDialog.hidden = false;
  document.body.classList.add('room-manager-dialog-open');
  roomSettingsClose.focus({ preventScroll: true });
}

async function changeActiveRoomSeatCount(direction) {
  const activeRoom = activeDirectoryRoom();
  if (!activeRoom || !canManageActiveRoom() || roomActionPending) return;

  const currentIndex = allowedSeatCounts.indexOf(Number(activeRoom.seatCount));
  const targetCount = allowedSeatCounts[currentIndex + direction];
  if (!targetCount) return;

  roomActionPending = true;
  updateSeatStepper();

  try {
    const data = await apiRequest(`/api/rooms/${encodeURIComponent(activeRoom.slug)}/seats`, {
      method: 'PATCH',
      body: JSON.stringify({ seatCount: targetCount }),
    });
    applyRoomDirectoryData(data);
    roomSeatCountValue.textContent = String(targetCount);
    setStatus(`Koltuk sayısı ${targetCount} olarak güncellendi.`, 'success');
  } catch (error) {
    setStatus(error.message || 'Koltuk sayısı değiştirilemedi.', 'error');
  } finally {
    roomActionPending = false;
    updateSeatStepper();
  }
}

function resetChatMessages(_roomName) {
  clearChatTyping();
  clearSelectedChatImage();
  chatMessages.replaceChildren();
}


const defaultChatViewSettings = Object.freeze({
  font: 'normal',
  align: 'standard',
});

function normalizeChatViewSettings(value = {}) {
  const font = ['small', 'normal', 'large'].includes(value?.font)
    ? value.font
    : defaultChatViewSettings.font;
  const align = ['left', 'standard', 'right'].includes(value?.align)
    ? value.align
    : defaultChatViewSettings.align;

  return { font, align };
}

function updateChatContextControls(settings) {
  chatContextFontButtons.forEach((button) => {
    const active = button.dataset.chatFont === settings.font;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });

  chatContextAlignButtons.forEach((button) => {
    const active = button.dataset.chatAlign === settings.align;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
  });
}

function applyChatViewSettings(value = defaultChatViewSettings, persist = true) {
  const settings = normalizeChatViewSettings(value);
  chatMessages.dataset.chatFont = settings.font;
  chatMessages.dataset.chatAlign = settings.align;
  updateChatContextControls(settings);

  if (persist) {
    try {
      window.localStorage.setItem(CHAT_VIEW_STORAGE_KEY, JSON.stringify(settings));
    } catch (error) {
      // Tarayıcı depolaması kapalıysa görünüm yine mevcut oturumda çalışır.
    }
  }

  return settings;
}

function loadChatViewSettings() {
  let saved = defaultChatViewSettings;

  try {
    saved = JSON.parse(window.localStorage.getItem(CHAT_VIEW_STORAGE_KEY) || 'null')
      || defaultChatViewSettings;
  } catch (error) {
    saved = defaultChatViewSettings;
  }

  applyChatViewSettings(saved, false);
}

function closeChatContextMenu(restoreFocus = false) {
  if (!chatContextMenu || chatContextMenu.hidden) return;
  chatContextMenu.hidden = true;
  chatContextMenu.style.removeProperty('left');
  chatContextMenu.style.removeProperty('top');
  document.body.classList.remove('chat-context-menu-open');

  if (restoreFocus) chatMessages.focus({ preventScroll: true });
}

function openChatContextMenu(event) {
  if (!chatContextMenu || !window.matchMedia('(min-width: 1024px)').matches) return;

  event.preventDefault();
  closeEmojiPicker();
  chatContextMenu.hidden = false;
  document.body.classList.add('chat-context-menu-open');

  const margin = 10;
  const viewportWidth = document.documentElement.clientWidth;
  const viewportHeight = document.documentElement.clientHeight;

  window.requestAnimationFrame(() => {
    const rect = chatContextMenu.getBoundingClientRect();
    const left = Math.min(
      Math.max(margin, event.clientX),
      Math.max(margin, viewportWidth - rect.width - margin),
    );
    const top = Math.min(
      Math.max(margin, event.clientY),
      Math.max(margin, viewportHeight - rect.height - margin),
    );

    chatContextMenu.style.left = `${left}px`;
    chatContextMenu.style.top = `${top}px`;
  });
}

function clearChatScreenLocally() {
  clearChatTyping();
  chatMessages.replaceChildren();

  const note = document.createElement('div');
  note.className = 'system-message chat-local-clear-note';
  note.textContent = 'Sohbet ekranın yalnızca bu cihazda temizlendi.';
  chatMessages.append(note);
  closeChatContextMenu();
}

function safeRoomChatImageUrl(value) {
  const url = String(value || '').trim();
  return /^\/uploads\/chat\/[a-z0-9-]+\.webp$/i.test(url) ? url : '';
}

function readableFileSize(bytes) {
  const size = Number(bytes || 0);
  if (!Number.isFinite(size) || size <= 0) return '';
  if (size < 1024 * 1024) return `${Math.max(1, Math.round(size / 1024))} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

function refreshChatComposerState() {
  const enabled = chatComposerEnabled && !chatImageUploadPending;
  chatInput.disabled = !enabled;
  chatSend.disabled = !enabled;
  emojiButton.disabled = !enabled;
  chatAttachmentButton.disabled = !enabled;
  chatImagePreviewRemove.disabled = chatImageUploadPending;
  chatSend.textContent = chatImageUploadPending ? 'Yükleniyor…' : 'Gönder';
}

function clearSelectedChatImage() {
  chatImagePreviewUrl = null;
  chatImageFile = null;
  chatImageInput.value = '';
  chatImagePreviewImage.removeAttribute('src');
  chatImagePreviewName.textContent = 'Resim';
  chatImagePreview.hidden = true;
}

function selectChatImage(file) {
  const allowedTypes = new Set(['image/jpeg', 'image/png', 'image/webp']);

  if (!file || !allowedTypes.has(file.type)) {
    clearSelectedChatImage();
    setStatus('JPEG, PNG veya WebP biçiminde bir resim seçmelisin.', 'error');
    return;
  }

  if (file.size > 5 * 1024 * 1024) {
    clearSelectedChatImage();
    setStatus('Oda resmi en fazla 5 MB olabilir.', 'error');
    return;
  }

  clearSelectedChatImage();
  chatImageFile = file;
  chatImagePreviewName.textContent = `${file.name || 'Resim'} · ${readableFileSize(file.size)}`;
  chatImagePreview.hidden = false;
  const reader = new FileReader();
  reader.addEventListener('load', () => {
    if (chatImageFile !== file || typeof reader.result !== 'string') return;
    chatImagePreviewUrl = reader.result;
    chatImagePreviewImage.src = reader.result;
  });
  reader.addEventListener('error', () => {
    if (chatImageFile !== file) return;
    clearSelectedChatImage();
    setStatus('Resim önizlemesi hazırlanamadı.', 'error');
  });
  reader.readAsDataURL(file);
  chatInput.focus({ preventScroll: true });
}

function typingIndicatorText(names) {
  if (names.length === 1) return `${names[0]} yazıyor…`;
  if (names.length === 2) return `${names[0]} ve ${names[1]} yazıyor…`;
  return `${names.length} kişi yazıyor…`;
}

function renderChatTyping() {
  if (!chatTyping) return;

  clearTimeout(remoteTypingCleanupTimer);
  remoteTypingCleanupTimer = null;

  const now = Date.now();

  for (const [identity, typer] of remoteTypers) {
    if (!typer || typer.expiresAt <= now) remoteTypers.delete(identity);
  }

  const activeTypers = [...remoteTypers.values()]
    .sort((left, right) => left.startedAt - right.startedAt);

  if (!activeTypers.length) {
    chatTyping.hidden = true;
    chatTyping.textContent = '';
    return;
  }

  chatTyping.textContent = typingIndicatorText(
    activeTypers.map((typer) => typer.name),
  );
  chatTyping.hidden = false;

  const nextExpiry = Math.min(...activeTypers.map((typer) => typer.expiresAt));
  remoteTypingCleanupTimer = setTimeout(
    renderChatTyping,
    Math.max(250, nextExpiry - now + 50),
  );
}

function handleChatTyping(payload) {
  if (!desktopTypingMedia.matches) return;

  const identity = String(payload?.identity || '');

  if (!identity || identity === session?.identity) return;

  if (!payload?.active) {
    remoteTypers.delete(identity);
    renderChatTyping();
    return;
  }

  const now = Date.now();
  const existing = remoteTypers.get(identity);

  remoteTypers.set(identity, {
    name: String(payload?.name || 'Bir kullanıcı'),
    startedAt: existing?.startedAt || now,
    expiresAt: now + REMOTE_TYPING_TTL_MS,
  });
  renderChatTyping();
}

function setLocalChatTyping(active) {
  const nextState = Boolean(active);
  const stateChanged = localTypingActive !== nextState;

  localTypingActive = nextState;

  if (seatSocket?.connected && (stateChanged || nextState)) {
    seatSocket.emit('chat:typing', { active: nextState });
  }
}

function stopLocalChatTyping() {
  clearTimeout(localTypingTimer);
  localTypingTimer = null;
  setLocalChatTyping(false);
}

function handleLocalChatTyping() {
  clearTimeout(localTypingTimer);
  localTypingTimer = null;

  if (
    !desktopTypingMedia.matches
    || !seatSocket?.connected
    || !chatInput.value.trim()
  ) {
    setLocalChatTyping(false);
    return;
  }

  setLocalChatTyping(true);
  localTypingTimer = setTimeout(stopLocalChatTyping, LOCAL_TYPING_IDLE_MS);
}

function clearChatTyping() {
  clearTimeout(localTypingTimer);
  clearTimeout(remoteTypingCleanupTimer);
  localTypingTimer = null;
  remoteTypingCleanupTimer = null;
  localTypingActive = false;
  remoteTypers.clear();

  if (chatTyping) {
    chatTyping.hidden = true;
    chatTyping.textContent = '';
  }
}

function initials(name) {
  const normalized = String(name || '?').trim();
  return [...normalized].slice(0, 2).join('').toLocaleUpperCase('tr-TR') || '?';
}

function clearProfilePreview() {
  if (profilePreviewUrl) URL.revokeObjectURL(profilePreviewUrl);
  profilePreviewUrl = null;
  profileAvatarInput.value = '';
}

function showProfile(profile) {
  const displayName = profile.displayName || profile.name || 'Kullanıcı';
  const accountType = profile.accountType || (profile.profileId ? 'member' : 'guest');
  const normalized = {
    ...profile,
    id: profile.id || profile.profileId || null,
    displayName,
    accountType,
    gender: safeGender(profile.gender),
    nicknameEffect: safeNicknameEffect(profile.nicknameEffect),
    avatarFrame: safeAvatarFrame(profile.avatarFrame, profile),
  };

  activeProfile = normalized;
  profileGenderLabel.hidden = false;
  renderAvatar(profileAvatar, normalized);
  renderAvatarFrame(profileFrame, normalized);
  profileName.textContent = displayName;
  applyNicknameEffect(profileName, normalized.nicknameEffect);
  const roomAssistant = Boolean(
    normalized.isRoomAssistant || accountType === 'assistant'
  );

  profileUsername.textContent = roomAssistant
    ? 'Oda Asistanı'
    : accountType === 'member' && normalized.username
      ? `@${normalized.username}`
      : 'Geçici misafir';
  profileRole.textContent = roomAssistant
    ? 'Oda Asistanı'
    : roleLabel(normalized.role, normalized.isVip);
  profileRole.dataset.role = roomAssistant
    ? 'assistant'
    : normalized.isVip ? 'vip' : normalized.role;
  profileGenderLabel.hidden = roomAssistant;
  profileGenderLabel.textContent = genderLabel(normalized.gender);
  profileGenderLabel.dataset.gender = normalized.gender;
  profileAccountLabel.textContent = roomAssistant
    ? 'Otomatik oda hesabı'
    : accountType === 'member'
      ? normalized.authSource === 'sngine'
        ? normalized.isVerified
          ? 'Yalla • Doğrulanmış'
          : 'Yalla hesabı'
        : 'Kayıtlı üye'
      : 'Misafir oturumu';
  const profileDescription = roomAssistant
    ? normalized.assistantBio
      || 'Bu hesap odadaki bilgilendirme ve duyuru akışına yardımcı olan bir oda asistanıdır.'
    : normalized.bio || 'Henüz bir hakkında yazısı eklenmemiş.';
  profileBio.textContent = profileDescription;
  profileBio.classList.toggle('is-empty', !profileDescription);
  profileJoined.textContent = accountType === 'member'
    ? joinedDateText(normalized.joinedAt)
    : '';

  const ownProfile = Boolean(
    accountType === 'member'
    && authUser?.accountType === 'member'
    && normalized.id
    && normalized.id === authUser.id,
  );

  profileEditButton.hidden = !ownProfile;
  profileEditButton.textContent = normalized.authSource === 'sngine'
    ? 'Yalla profilini düzenle'
    : 'Profili düzenle';
  profileMessageButton.hidden = !(
    isPrivateMessageMember()
    && accountType === 'member'
    && !ownProfile
  );
  profileGuestNote.hidden = accountType !== 'guest';
  profileView.hidden = false;
  profileEditForm.hidden = true;
}

async function openProfile(subject, trigger = null) {
  if (!subject) return;

  profilePreviousFocus = trigger || document.activeElement;
  profileDialog.hidden = false;
  document.body.classList.add('profile-dialog-open');
  profileView.hidden = false;
  profileEditForm.hidden = true;
  profileName.textContent = 'Profil yükleniyor…';
  renderAvatarFrame(profileFrame, {});
  profileUsername.textContent = '';
  profileBio.textContent = '';
  profileJoined.textContent = '';
  profileEditButton.hidden = true;
  profileMessageButton.hidden = true;
  profileGuestNote.hidden = true;

  const accountType = subject.accountType
    || ((subject.profileId || subject.id) ? 'member' : 'guest');
  const profileId = subject.profileId || subject.id;

  try {
    if (subject.isRoomAssistant || accountType === 'assistant') {
      showProfile({
        ...subject,
        displayName: subject.displayName || subject.name,
        accountType: 'assistant',
        role: 'member',
        isRoomAssistant: true,
      });
    } else if (accountType === 'member' && profileId) {
      const data = await apiRequest(`/api/profile/${encodeURIComponent(profileId)}`);
      showProfile(data.profile);
    } else {
      showProfile({
        ...subject,
        displayName: subject.displayName || subject.name,
        accountType: 'guest',
        role: 'guest',
      });
    }

    profileClose.focus({ preventScroll: true });
  } catch (error) {
    closeProfileDialog(false);
    setStatus(error.message || 'Profil açılamadı.', 'error');
  }
}

function closeProfileDialog(restoreFocus = true) {
  clearProfilePreview();
  profileDialog.hidden = true;
  profileView.hidden = false;
  profileEditForm.hidden = true;
  activeProfile = null;
  document.body.classList.remove('profile-dialog-open');

  if (restoreFocus && profilePreviousFocus instanceof HTMLElement) {
    profilePreviousFocus.focus({ preventScroll: true });
  }

  profilePreviousFocus = null;
}

function openProfileEditor() {
  if (!activeProfile || activeProfile.id !== authUser?.id) return;

  clearProfilePreview();
  profileDisplayName.value = activeProfile.displayName;
  profileBioInput.value = activeProfile.bio || '';
  profileGender.value = safeGender(activeProfile.gender);
  profileBioCount.textContent = `${[...profileBioInput.value].length} / 300`;
  profileNicknameEffect.value = safeNicknameEffect(activeProfile.nicknameEffect);
  const sngineSynced = activeProfile.authSource === 'sngine';
  profileDisplayName.disabled = sngineSynced;
  profileBioInput.disabled = sngineSynced;
  profileGender.disabled = sngineSynced;
  profileAvatarInput.disabled = sngineSynced;
  profileAvatarFileButton.hidden = sngineSynced;
  profileDisplayName.title = sngineSynced
    ? 'Bu bilgi Yalla hesabındaki profilinden senkronize edilir.'
    : '';
  profileBioInput.title = profileDisplayName.title;
  profileGender.title = profileDisplayName.title;
  selectedAvatarFrame = safeAvatarFrame(activeProfile.avatarFrame, activeProfile);
  renderAvatar(profileEditAvatar, activeProfile);
  renderAvatarFrame(profileEditFrame, activeProfile, selectedAvatarFrame);
  renderAvatarFramePicker();
  profileRemoveAvatar.hidden = sngineSynced || !activeProfile.avatarUrl;
  profileView.hidden = true;
  profileEditForm.hidden = false;
  (sngineSynced ? profileNicknameEffect : profileDisplayName)
    .focus({ preventScroll: true });
}

function cancelProfileEditor() {
  clearProfilePreview();
  profileEditForm.hidden = true;
  profileView.hidden = false;
  if (activeProfile) showProfile(activeProfile);
  profileEditButton.focus({ preventScroll: true });
}

function getSelfSeat(state = currentRoomState) {
  if (!state || !session) return null;
  return state.seats.find((seat) => seat.occupant?.identity === session.identity) || null;
}

function isSelfOwner(state = currentRoomState) {
  return Boolean(state && session && state.ownerIdentity === session.identity);
}

function canSelfModerate(state = currentRoomState) {
  if (!state || !session) return false;
  return Boolean(
    state.members?.find((member) => member.identity === session.identity)?.canModerate,
  );
}

function closeModerationDialog(restoreFocus = true) {
  moderationDialog.hidden = true;
  moderationTargetIdentity = null;
  document.body.classList.remove('moderation-dialog-open');

  if (restoreFocus && moderationPreviousFocus instanceof HTMLElement) {
    moderationPreviousFocus.focus({ preventScroll: true });
  }

  moderationPreviousFocus = null;
}

function openModerationDialog(member, trigger) {
  if (!canSelfModerate() || member.identity === session?.identity) return;

  setUsersDrawer(false);
  moderationTargetIdentity = member.identity;
  moderationPreviousFocus = trigger || document.activeElement;
  moderationTargetName.textContent = member.name;
  moderationTargetRole.textContent = member.isOwner
    ? `${roleLabel(member.role, member.isVip)} • Oda sahibi`
    : roleLabel(member.role, member.isVip);
  moderationReason.value = '';
  moderationDuration.value = '60';
  moderationDialog.hidden = false;
  document.body.classList.add('moderation-dialog-open');
  moderationReason.focus({ preventScroll: true });
}

function moderationActionLabel(action) {
  return {
    chat_mute: 'Sohbet susturma',
    media_mute: 'Mikrofon/kamera kısıtlama',
    room_kick: 'Odadan çıkarma',
    room_ban: 'Odaya girişi yasaklama',
  }[action] || 'Moderasyon';
}

async function applyModerationAction(action) {
  const target = currentRoomState?.members?.find(
    (member) => member.identity === moderationTargetIdentity,
  );

  if (!target || !canSelfModerate()) {
    closeModerationDialog(false);
    setStatus('Hedef kullanıcı artık odada değil.', 'warning');
    return;
  }

  if (
    (action === 'room_kick' || action === 'room_ban')
    && !window.confirm(`${target.name} için ${moderationActionLabel(action).toLocaleLowerCase('tr-TR')} işlemini onaylıyor musun?`)
  ) {
    return;
  }

  moderationActionButtons.forEach((button) => {
    button.disabled = true;
  });

  try {
    const response = await emitWithAck('moderation:apply', {
      targetIdentity: target.identity,
      action,
      durationMinutes: Number(moderationDuration.value),
      reason: moderationReason.value.trim(),
    });

    if (!response?.ok) {
      throw new Error(response?.message || 'Moderasyon işlemi tamamlanamadı.');
    }

    closeModerationDialog(false);
    setStatus(`${target.name}: ${moderationActionLabel(action)} uygulandı.`, 'success');
  } catch (error) {
    setStatus(error.message || 'Moderasyon işlemi tamamlanamadı.', 'error');
  } finally {
    moderationActionButtons.forEach((button) => {
      button.disabled = false;
    });
  }
}

function participantDisplayName(participant) {
  return participant.name || participant.identity;
}

function createChairIcon() {
  const chair = document.createElement('span');
  chair.className = 'seat-chair';
  chair.setAttribute('aria-hidden', 'true');
  chair.innerHTML = `
    <svg viewBox="0 0 64 58" focusable="false">
      <path class="chair-back" d="M8 31V18C8 8.6 15.6 1 25 1h14c9.4 0 17 7.6 17 17v13H8Z" />
      <path class="chair-seat" d="M11 31h42v10.5a5.5 5.5 0 0 1-5.5 5.5h-31a5.5 5.5 0 0 1-5.5-5.5V31Z" />
      <path class="chair-arm" d="M13 22C7.2 20.8 2 25.3 2 31v12.5A4.5 4.5 0 0 0 6.5 48H14V33a4 4 0 0 1 4-4v-3.5A11 11 0 0 0 13 22Zm38 0c5.8-1.2 11 3.3 11 9v12.5a4.5 4.5 0 0 1-4.5 4.5H50V33a4 4 0 0 0-4-4v-3.5a11 11 0 0 1 5-3.5Z" />
      <path class="chair-leg" d="M13 46h9l-2 10h-8l1-10Zm29 0h9l1 10h-8l-2-10Z" />
      <path class="chair-shine" d="M14 17.5A10.5 10.5 0 0 1 24.5 7h15A10.5 10.5 0 0 1 50 17.5V25H14v-7.5Z" />
    </svg>`;
  return chair;
}

function createMobileSeatMicrophoneIcon() {
  const icon = document.createElement('span');
  icon.className = 'mobile-seat-microphone';
  icon.setAttribute('aria-hidden', 'true');
  icon.innerHTML = `
    <svg viewBox="0 0 24 24" focusable="false">
      <path d="M12 15.1a3.6 3.6 0 0 0 3.6-3.6V6.1a3.6 3.6 0 1 0-7.2 0v5.4a3.6 3.6 0 0 0 3.6 3.6Z" />
      <path d="M18.2 11.2a6.2 6.2 0 0 1-12.4 0M12 17.4V22M8.7 22h6.6" />
    </svg>`;
  return icon;
}

function occupantByIdentity(identity) {
  return currentRoomState?.seats
    .find((seat) => seat.occupant?.identity === identity)?.occupant
    || okeyParticipantByIdentity(identity)
    || null;
}

function closeVideoViewer(restoreFocus = true) {
  const element = videoViewerMedia.querySelector('video');
  const track = videoViewerTrack;

  if (element) {
    try {
      track?.detach(element);
    } catch (error) {
      console.warn('Büyük kamera ayrılamadı:', error);
    }

    element.remove();
  }

  videoViewerIdentity = null;
  videoViewerTrack = null;
  videoViewer.hidden = true;
  document.body.classList.remove('video-viewer-open');

  if (restoreFocus && videoViewerPreviousFocus instanceof HTMLElement) {
    videoViewerPreviousFocus.focus({ preventScroll: true });
  }

  videoViewerPreviousFocus = null;
}

function openVideoViewer(identity) {
  const track = okeyModeActive
    ? okeyMediaVideoTracks.get(identity)
    : videoTracks.get(identity);

  if (!track) {
    setStatus('Bu kullanıcının kamerası şu anda açık değil.', 'warning');
    return;
  }

  closeVideoViewer(false);
  videoViewerPreviousFocus = document.activeElement;
  videoViewerIdentity = identity;
  videoViewerTrack = track;
  const participant = occupantByIdentity(identity);
  videoViewerName.textContent = participant?.name || participant?.displayName || 'Canlı kamera';

  const element = track.attach();
  element.autoplay = true;
  element.playsInline = true;
  element.muted = identity === session?.identity;
  videoViewerMedia.replaceChildren(element);

  videoViewer.hidden = false;
  document.body.classList.add('video-viewer-open');
  videoViewerClose.focus({ preventScroll: true });
}

function totalDirectoryOnlineCount() {
  return roomDirectory.reduce((total, roomItem) => {
    const roomOnlineCount = Number(roomItem?.onlineCount);

    return total + (
      Number.isFinite(roomOnlineCount) && roomOnlineCount > 0
        ? Math.floor(roomOnlineCount)
        : 0
    );
  }, 0);
}

function updateParticipantCount() {
  const currentRoomCount = currentRoomState?.onlineCount
    ?? (room ? room.remoteParticipants.size + 1 : 0);

  /*
   * Sağ üstteki sayaç sadece bulunulan odayı gösterir.
   * Sol taraftaki Çevrimiçi sayacı ise bütün odaların toplamıdır.
   */
  const globalOnlineCount = roomDirectory.length
    ? totalDirectoryOnlineCount()
    : currentRoomCount;

  participantCount.textContent = `${currentRoomCount} kişi`;
  onlineCount.textContent = String(globalOnlineCount);
  desktopOnlineCount.textContent = globalOnlineCount > 999 ? '999+' : String(globalOnlineCount);
  desktopUsersCount.textContent = currentRoomCount > 99 ? '99+' : String(currentRoomCount);
  mobileUsersCount.textContent = currentRoomCount > 99 ? '99+' : String(currentRoomCount);
  document.documentElement.dataset.globalOnlineCountFeature = 'v1-1';
  mobileUsersButton.setAttribute(
    'aria-label',
    `Bu odadaki çevrimiçi kişiler: ${currentRoomCount}`,
  );
}

function renderOnlineUsers() {
  onlineUsers.replaceChildren();

  const members = currentRoomState?.members || [];

  if (!members.length) {
    const empty = document.createElement('div');
    empty.className = 'empty-users';
    empty.textContent = 'Çevrimiçi kullanıcılar yükleniyor…';
    onlineUsers.append(empty);
    return;
  }

  for (const member of members) {
    const item = document.createElement('div');
    item.className = 'online-user';
    item.classList.toggle('is-self', member.identity === session?.identity);
    item.classList.toggle('is-room-assistant', Boolean(member.isRoomAssistant));

    const avatarWrap = document.createElement('span');
    avatarWrap.className = 'user-avatar-wrap';
    const avatar = document.createElement('span');
    avatar.className = 'user-avatar';
    renderAvatar(avatar, {
      ...member,
      displayName: member.name,
    });
    avatarWrap.append(avatar);
    if (safeAvatarFrame(member.avatarFrame, member) !== 'none') {
      avatarWrap.append(createAvatarFrameElement(member, 'user-frame'));
    }

    const copy = document.createElement('span');
    copy.className = 'online-user-copy';

    const name = document.createElement('strong');
    name.textContent = member.identity === session?.identity
      ? `${member.name} (Sen)`
      : member.name;
    applyNicknameEffect(name, member.nicknameEffect);

    const state = document.createElement('small');
    state.textContent = member.seatNumber
      ? `${member.seatNumber}. koltukta`
      : 'Dinleyici';

    copy.append(name, state);

    const profileButton = document.createElement('button');
    profileButton.className = 'online-profile-button';
    profileButton.type = 'button';
    profileButton.title = `${member.name} profilini aç`;
    profileButton.setAttribute('aria-label', `${member.name} profilini aç`);
    profileButton.append(avatarWrap, copy);
    profileButton.addEventListener('click', () => {
      void openProfile(member, profileButton);
    });
    item.append(profileButton);

    if (member.isOwner) {
      const shield = document.createElement('span');
      shield.className = 'owner-shield';
      shield.title = 'Oda yöneticisi';
      shield.textContent = 'Y';
      item.append(shield);
    }

    if (
      !member.isRoomAssistant
      && (
        member.isVip
        || member.role === 'guest'
        || member.role === 'moderator'
        || member.role === 'admin'
      )
    ) {
      const role = document.createElement('span');
      role.className = 'online-role';
      role.dataset.role = member.isVip ? 'vip' : member.role;
      role.title = roleLabel(member.role, member.isVip);
      role.textContent = member.isVip && member.role === 'member'
        ? 'V'
        : member.role === 'admin'
        ? 'A'
        : member.role === 'moderator'
          ? 'M'
          : 'G';
      item.append(role);
    }

    if (!member.isRoomAssistant && member.identity !== session?.identity) {
      const messageButton = document.createElement('button');
      messageButton.className = 'online-message-button';
      messageButton.type = 'button';
      messageButton.title = isPrivateMessageMember()
        ? `${member.name} kullanıcısına özel mesaj gönder`
        : 'Özel mesaj için üye girişi gerekir';
      messageButton.setAttribute('aria-label', messageButton.title);
      messageButton.textContent = '✉';
      messageButton.disabled = !(
        isPrivateMessageMember()
        && member.accountType === 'member'
        && (member.profileId || member.id)
      );
      messageButton.addEventListener('click', (event) => {
        event.stopPropagation();
        if (messageButton.disabled) {
          setStatus('Özel mesaj göndermek için kayıtlı üye olmalısın.', 'warning');
          return;
        }

        void openPrivateMessages({
          ...member,
          id: member.profileId || member.id,
          displayName: member.displayName || member.name,
        }, messageButton);
      });
      item.append(messageButton);
    }

    if (
      canSelfModerate()
      && !member.isRoomAssistant
      && member.identity !== session?.identity
    ) {
      const manage = document.createElement('button');
      manage.className = 'moderation-menu-button';
      manage.type = 'button';
      manage.title = `${member.name} için yönetici işlemleri`;
      manage.setAttribute('aria-label', `${member.name} için yönetici işlemleri`);
      manage.textContent = '⋮';
      manage.addEventListener('click', () => openModerationDialog(member, manage));
      item.append(manage);
    }

    onlineUsers.append(item);
  }
}

function detachRenderedVideos() {
  for (const { track, element } of seatVideoElements.values()) {
    try {
      track.detach(element);
    } catch (error) {
      console.warn('Koltuk kamerası ayrılamadı:', error);
    }

    element.remove();
  }

  seatVideoElements.clear();
}

function attachVideosToSeats() {
  for (const [identity, track] of videoTracks) {
    const media = seatsGrid.querySelector(
      `.seat-card[data-identity="${CSS.escape(identity)}"] .seat-media`,
    );

    if (!media) continue;

    const element = track.attach();
    element.autoplay = true;
    element.playsInline = true;
    element.muted = identity === session?.identity;
    media.append(element);
    seatVideoElements.set(identity, { track, element });
  }
}

function updateSpeakingClasses() {
  seatsGrid.querySelectorAll('.seat-card').forEach((seat) => {
    const identity = seat.dataset.identity;
    seat.classList.toggle(
      'is-speaking',
      Boolean(identity && activeSpeakerIdentities.has(identity)),
    );
  });

  okeySeatButtons.forEach((seat) => {
    const identity = seat.dataset.identity;
    seat.classList.toggle(
      'is-speaking',
      Boolean(identity && okeyActiveSpeakerIdentities.has(identity)),
    );
  });
}

function seatReactionDefinition(reactionId) {
  return seatReactionCatalog.find((reaction) => reaction.id === reactionId) || null;
}

function createSeatReactionElement(identity) {
  const activeReaction = activeSeatReactions.get(identity);
  if (!activeReaction) return null;

  const reaction = seatReactionDefinition(activeReaction.reactionId);
  const elapsed = Math.max(0, Date.now() - activeReaction.startedAt);
  if (!reaction || elapsed >= activeReaction.durationMs) {
    activeSeatReactions.delete(identity);
    return null;
  }

  const overlay = document.createElement('span');
  overlay.className = `seat-reaction seat-reaction-${reaction.id}`;
  overlay.dataset.reactionEventId = activeReaction.eventId;
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.setProperty('--seat-reaction-duration', `${activeReaction.durationMs}ms`);
  overlay.style.setProperty('--seat-reaction-delay', `${-elapsed}ms`);

  const face = document.createElement('span');
  face.className = 'seat-reaction-face';
  face.textContent = reaction.emoji;
  overlay.append(face);
  return overlay;
}

function syncSeatReaction(identity) {
  const media = seatsGrid.querySelector(
    `.seat-card[data-identity="${CSS.escape(identity)}"] .seat-media`,
  );

  if (!media) return;
  media.querySelector('.seat-reaction')?.remove();
  const overlay = createSeatReactionElement(identity);
  if (overlay) media.append(overlay);
}

function removeSeatReaction(identity, eventId) {
  const activeReaction = activeSeatReactions.get(identity);
  if (!activeReaction || activeReaction.eventId !== eventId) return;

  activeSeatReactions.delete(identity);
  seatReactionTimers.delete(identity);
  const card = seatsGrid.querySelector(
    `.seat-card[data-identity="${CSS.escape(identity)}"]`,
  );
  card?.querySelector('.seat-reaction')?.remove();
}

function clearSeatReactions() {
  for (const timer of seatReactionTimers.values()) clearTimeout(timer);
  seatReactionTimers.clear();
  activeSeatReactions.clear();
  seatsGrid.querySelectorAll('.seat-reaction').forEach((element) => element.remove());
}

function handleSeatReaction(payload) {
  const identity = String(payload?.identity || '');
  const reactionId = String(payload?.reactionId || '');
  if (!identity || !seatReactionIds.has(reactionId)) return;

  const durationMs = Math.min(Math.max(Number(payload?.durationMs) || 2_500, 1_000), 4_000);
  const startedAt = Date.now();
  const eventId = String(payload?.id || `${identity}-${startedAt}`);
  const remainingMs = durationMs - Math.max(0, Date.now() - startedAt);
  if (remainingMs <= 0) return;

  const previousTimer = seatReactionTimers.get(identity);
  if (previousTimer) clearTimeout(previousTimer);

  activeSeatReactions.set(identity, {
    eventId,
    reactionId,
    durationMs,
    startedAt,
  });
  syncSeatReaction(identity);

  seatReactionTimers.set(identity, window.setTimeout(() => {
    removeSeatReaction(identity, eventId);
  }, remainingMs + 60));
}

function renderSeats() {
  detachRenderedVideos();
  seatsGrid.replaceChildren();

  const fallbackSeatCount = Number(activeDirectoryRoom()?.seatCount || 12);
  const seats = currentRoomState?.seats
    || Array.from({ length: fallbackSeatCount }, (_, index) => ({
      number: index + 1,
      occupant: null,
    }));

  seatsGrid.dataset.seatCount = String(seats.length);
  const selfModerator = canSelfModerate();
  let occupiedCount = 0;

  for (const seat of seats) {
    const occupant = seat.occupant;
    const occupied = Boolean(occupant);
    const self = occupant?.identity === session?.identity;
    const hasCamera = Boolean(occupant?.identity && videoTracks.has(occupant.identity));

    if (occupied) occupiedCount += 1;

    const card = document.createElement('article');
    card.className = 'seat-card';
    card.classList.toggle('is-empty', !occupied);
    card.classList.toggle('is-occupied', occupied);
    card.classList.toggle('is-self', self);
    card.classList.toggle('has-camera', hasCamera);
    if (occupied) {
      const gender = safeGender(occupant.gender);
      card.dataset.gender = gender;
      card.classList.add(`gender-${gender}`);
    }
    card.dataset.seatNumber = String(seat.number);

    if (occupant?.identity) {
      card.dataset.identity = occupant.identity;
    }

    const main = document.createElement('button');
    main.className = 'seat-main';
    main.type = 'button';
    main.disabled = occupied && !self && !hasCamera;
    main.title = hasCamera
      ? `${occupant.name} kullanıcısının kamerasını büyüt`
      : occupied
        ? `${occupant.name} — ${seat.number}. koltuk`
      : `${seat.number}. koltuğa otur`;

    if (hasCamera) {
      main.addEventListener('click', () => openVideoViewer(occupant.identity));
    } else if (!occupied) {
      main.addEventListener('click', () => takeSeat(seat.number));
    } else if (self) {
      main.addEventListener('click', () => {
        setStatus('Koltuktan kalkmak için aşağıdaki koltuk düğmesini kullan.');
      });
    }

    const number = document.createElement('span');
    number.className = 'seat-number';
    number.textContent = `#${seat.number}`;

    const visual = document.createElement('span');
    visual.className = 'seat-visual';
    visual.append(createChairIcon(), createMobileSeatMicrophoneIcon());

    if (occupied) {
      const media = document.createElement('span');
      media.className = 'seat-media';
      renderAvatar(media, {
        ...occupant,
        displayName: occupant.name,
      });
      const reactionOverlay = createSeatReactionElement(occupant.identity);
      if (reactionOverlay) media.append(reactionOverlay);
      visual.append(media);
      if (safeAvatarFrame(occupant.avatarFrame, occupant) !== 'none') {
        visual.append(createAvatarFrameElement(occupant, 'seat-frame'));
      }
    } else {
      const emptyPlus = document.createElement('span');
      emptyPlus.className = 'seat-empty-plus';
      emptyPlus.textContent = '+';
      visual.append(emptyPlus);
    }

    const name = document.createElement('span');
    name.className = 'seat-name';
    name.textContent = occupied ? occupant.name : 'Boş koltuk';
    if (occupied) applyNicknameEffect(name, occupant.nicknameEffect);

    const state = document.createElement('span');
    state.className = 'seat-state';
    state.textContent = occupied
      ? (self ? 'Sen konuşmacısın' : 'Konuşmacı')
      : 'Oturmak için tıkla';

    main.append(number, visual, name, state);
    card.append(main);

    if (occupant?.isOwner) {
      const owner = document.createElement('span');
      owner.className = 'seat-owner-badge owner-shield';
      owner.title = 'Oda yöneticisi';
      owner.textContent = 'Y';
      card.append(owner);
    }

    if (selfModerator && occupied && !self) {
      const kick = document.createElement('button');
      kick.className = 'seat-kick';
      kick.type = 'button';
      kick.title = `${occupant.name} kullanıcısını koltuktan kaldır`;
      kick.setAttribute('aria-label', `${occupant.name} kullanıcısını koltuktan kaldır`);
      kick.textContent = '×';
      kick.addEventListener('click', () => kickSeat(seat.number, occupant.name));
      card.append(kick);
    }

    seatsGrid.append(card);
  }

  seatSummary.textContent = `${occupiedCount} / ${seats.length} dolu`;
  attachVideosToSeats();
  updateSpeakingClasses();
}

function setControlLabel(button, label) {
  const element = button.querySelector('.control-label');
  if (element) element.textContent = label;
}

function applyRoomAudioState() {
  document.querySelectorAll('body > audio').forEach((element) => {
    const mediaRoom = element.dataset.mediaRoom || 'voice';
    const isolatedFromActiveMode = okeyModeActive
      ? mediaRoom !== 'okey'
      : mediaRoom === 'okey';
    element.muted = roomAudioMuted || isolatedFromActiveMode;
  });

  const activeRoom = okeyModeActive ? okeyMediaRoom : room;
  const mediaLabel = okeyModeActive ? 'Okey sesi' : 'Oda sesi';
  audioOutputButton.classList.toggle('is-muted', roomAudioMuted);
  audioOutputButton.classList.toggle('is-active', !roomAudioMuted && Boolean(activeRoom));
  audioOutputButton.querySelector('.control-icon').textContent = roomAudioMuted ? '🔇' : '🔊';
  setControlLabel(
    audioOutputButton,
    `${mediaLabel} ${roomAudioMuted ? 'kapalı' : 'açık'}`,
  );
}

function updateMusicButton() {
  const isSharing = Boolean(musicAudioTrack);
  musicButton.classList.toggle('is-active', isSharing);
  setControlLabel(musicButton, isSharing ? 'Müziği durdur' : 'YouTube paylaş');
}

function updateControls() {
  const selfSeat = getSelfSeat();
  const seated = Boolean(selfSeat);
  const mediaAuthorized = canUseRoomMedia();
  const owner = isSelfOwner();
  const socketConnected = Boolean(seatSocket?.connected);
  const activeRoom = okeyModeActive ? okeyMediaRoom : room;
  const micEnabled = Boolean(activeRoom?.localParticipant.isMicrophoneEnabled);
  const cameraEnabled = Boolean(activeRoom?.localParticipant.isCameraEnabled);

  seatButton.disabled = !socketConnected || seatActionPending;
  setControlLabel(
    seatButton,
    seated ? `Koltuktan kalk #${selfSeat.number}` : 'Koltuk seç',
  );
  seatButton.classList.toggle('is-active', seated);

  micButton.disabled = !mediaAuthorized;
  audioOutputButton.disabled = !activeRoom;
  cameraButton.disabled = !mediaAuthorized;
  cameraQuickButton.disabled = !mediaAuthorized;
  mobileHeaderCameraButton.disabled = !mediaAuthorized;
  mobileHeaderLeaveButton.disabled = !room && !okeyModeActive;
  mobileProfileButton.disabled = !authUser;
  mobileAccountProfileButton.disabled = !authUser;
  okeyCameraButton.hidden = !okeyModeActive;
  okeyCameraButton.disabled = !mediaAuthorized;
  privateMessagesButton.disabled = !socketConnected || !isPrivateMessageMember();
  desktopPrivateMessagesButton.disabled = !socketConnected || !isPrivateMessageMember();
  mobileAccountMessagesButton.disabled = !socketConnected || !isPrivateMessageMember();
  roomMenuButton.disabled = !room && !okeyModeActive;
  connectionRefreshButton.disabled = !session?.roomSlug || roomActionPending;
  okeyModeButton.disabled = (!room && !okeyModeActive) || roomActionPending;
  desktopOkeyButton.disabled = okeyModeButton.disabled || okeyConnectPending;
  if (activePrivatePeer) {
    privateMessageInput.disabled = !socketConnected;
    privateMessageSend.disabled = !socketConnected;
  }
  micButton.classList.toggle('is-active', micEnabled);
  micButton.classList.toggle('is-muted', !micEnabled);
  cameraButton.classList.toggle('is-active', cameraEnabled);
  cameraQuickButton.classList.toggle('is-active', cameraEnabled);
  mobileHeaderCameraButton.classList.toggle('is-active', cameraEnabled);
  mobileHeaderCameraButton.setAttribute(
    'aria-label',
    cameraEnabled ? 'Kamerayı kapat' : 'Kamerayı aç',
  );
  okeyCameraButton.classList.toggle('is-active', cameraEnabled);
  setControlLabel(micButton, micEnabled ? 'Mikrofon açık' : 'Mikrofon kapalı');
  setControlLabel(cameraButton, cameraEnabled ? 'Kamera açık' : 'Kamera kapalı');
  setControlLabel(cameraQuickButton, cameraEnabled ? 'Kamera açık' : 'Kamera kapalı');
  setControlLabel(okeyCameraButton, cameraEnabled ? 'Kamera açık' : 'Kamera kapalı');
  applyRoomAudioState();

  musicButton.hidden = okeyModeActive || !owner;
  musicButton.disabled = !owner || !seated;
  updateMusicButton();
  updateSeatReactionControls();
}

async function ensureListenerMode({ force = false } = {}) {
  if (!room) return;

  if (!force && getSelfSeat()) {
    updateControls();
    return;
  }

  await stopMusicShare(false);

  try {
    if (room.localParticipant.isCameraEnabled) {
      await room.localParticipant.setCameraEnabled(false);
    }
  } catch (error) {
    console.warn('Kamera kapatılamadı:', error);
  }

  try {
    if (room.localParticipant.isMicrophoneEnabled) {
      await room.localParticipant.setMicrophoneEnabled(false);
    }
  } catch (error) {
    console.warn('Mikrofon kapatılamadı:', error);
  }

  const localVideo = videoTracks.get(session?.identity);
  localVideo?.detach().forEach((element) => element.remove());
  videoTracks.delete(session?.identity);
  updateControls();
  renderSeats();
}

function handleRoomState(state) {
  const previousState = currentRoomState;
  const wasSeated = Boolean(getSelfSeat(previousState));
  const wasOwner = isSelfOwner(previousState);

  currentRoomState = state;
  selectedRoomSlug = state.roomSlug || selectedRoomSlug;
  roomNameText.textContent = state.roomName || activeDirectoryRoom()?.name || 'Sohbet Odası';
  const roomOwner = state.members?.find((member) => member.isOwner);
  const selfMember = state.members?.find((member) => member.identity === session?.identity);
  if (selfMember) {
    renderDesktopAccount({
      ...authUser,
      ...selfMember,
      displayName: selfMember.name || authUser?.displayName || 'Seslicity',
      avatarUrl: selfMember.avatarUrl || authUser?.avatarUrl || '',
      avatarFrame: selfMember.avatarFrame || authUser?.avatarFrame || 'none',
      nicknameEffect: selfMember.nicknameEffect || authUser?.nicknameEffect || 'none',
    });
  }
  mobileRoomOwner.textContent = roomOwner?.name
    ? `Sahibi: ${roomOwner.name}`
    : `Oda: ${state.roomName || activeDirectoryRoom()?.name || 'Seslicity'}`;
  desktopRoomSubtitle.textContent = roomOwner?.name
    ? `Oda sahibi: ${roomOwner.name}`
    : (state.roomDescription || 'Seslicity canlı sohbet odası');

  const directoryIndex = roomDirectory.findIndex((item) => item.slug === state.roomSlug);
  if (directoryIndex >= 0) {
    roomDirectory[directoryIndex] = {
      ...roomDirectory[directoryIndex],
      name: state.roomName || roomDirectory[directoryIndex].name,
      description: state.roomDescription || roomDirectory[directoryIndex].description,
      seatCount: state.seatCount,
      onlineCount: state.onlineCount,
      occupiedSeats: state.seats?.filter((seat) => seat.occupant).length || 0,
    };
  }

  applyActiveRoomBackground(
    roomDirectory.find((item) => item.slug === state.roomSlug) || activeDirectoryRoom(),
  );

  if (
    moderationTargetIdentity
    && !state.members?.some((member) => member.identity === moderationTargetIdentity)
  ) {
    closeModerationDialog(false);
  }

  const seated = Boolean(getSelfSeat(state));
  const owner = isSelfOwner(state);

  if (wasSeated && !seated) {
    void ensureListenerMode();
  }

  if (wasOwner && !owner && musicAudioTrack) {
    void stopMusicShare();
  }

  updateParticipantCount();
  renderOnlineUsers();
  renderSeats();
  updateControls();
  renderRoomDirectory();
  if (okeyModeActive) renderOkeyState();
  if (!roomSettingsDialog.hidden) updateSeatStepper();
}

function emitWithAck(event, payload, timeout = 8_000) {
  return new Promise((resolve, reject) => {
    if (!seatSocket?.connected) {
      reject(new Error('Koltuk sunucusuna bağlı değilsin.'));
      return;
    }

    seatSocket.timeout(timeout).emit(event, payload, (error, response) => {
      if (error) {
        reject(new Error('Sunucudan zamanında cevap alınamadı.'));
        return;
      }

      resolve(response);
    });
  });
}

async function takeSeat(seatNumber) {
  if (!room || seatActionPending) return;

  seatActionPending = true;
  updateControls();
  setStatus(`${seatNumber}. koltuk hazırlanıyor…`, 'warning');

  try {
    const response = await emitWithAck('seat:take', { seatNumber });

    if (!response?.ok) {
      throw new Error(response?.message || 'Koltuk alınamadı.');
    }

    await room.localParticipant.setMicrophoneEnabled(true);
    setStatus(`${seatNumber}. koltuğa oturdun. Mikrofonun açık.`, 'success');
  } catch (error) {
    setStatus(error.message || 'Koltuk alınamadı.', 'error');
  } finally {
    seatActionPending = false;
    updateControls();
  }
}

async function leaveSeat() {
  const selfSeat = getSelfSeat();
  if (!selfSeat || seatActionPending) return;

  seatActionPending = true;
  updateControls();

  try {
    await ensureListenerMode({
      force: !(hasOkeyPlayerSeat() && okeyMediaLeaseGranted),
    });
    const response = await emitWithAck('seat:leave', {});

    if (!response?.ok) {
      throw new Error(response?.message || 'Koltuktan kalkılamadı.');
    }

    setStatus('Koltuktan kalktın. Dinleyici olarak devam ediyorsun.', 'success');
  } catch (error) {
    setStatus(error.message || 'Koltuktan kalkılamadı.', 'error');
  } finally {
    seatActionPending = false;
    updateControls();
  }
}

async function kickSeat(seatNumber, name) {
  if (!canSelfModerate() || seatActionPending) return;

  if (!window.confirm(`${name} kullanıcısını ${seatNumber}. koltuktan kaldırmak istiyor musun?`)) {
    return;
  }

  seatActionPending = true;
  updateControls();

  try {
    const response = await emitWithAck('seat:kick', { seatNumber });

    if (!response?.ok) {
      throw new Error(response?.message || 'Kullanıcı kaldırılamadı.');
    }

    setStatus(`${name} koltuktan kaldırıldı.`, 'success');
  } catch (error) {
    setStatus(error.message || 'Kullanıcı kaldırılamadı.', 'error');
  } finally {
    seatActionPending = false;
    updateControls();
  }
}

const ROOM_PRESENCE_VISIBLE_MS = 10000;
const ROOM_PRESENCE_FADE_MS = 600;
const ROOM_PRESENCE_MAX_VISIBLE = 6;

function expireRoomPresenceMessage(wrapper, immediate = false) {
  if (!wrapper?.isConnected) return;

  if (immediate) {
    wrapper.remove();
    return;
  }

  wrapper.classList.add('is-expiring');

  setTimeout(() => {
    wrapper.remove();
  }, ROOM_PRESENCE_FADE_MS);
}

function appendRoomSystemMessage(message) {
  if (!message || !['join', 'leave'].includes(message.action)) return;

  if (message.identity) {
    remoteTypers.delete(message.identity);
    renderChatTyping();
  }

  const wrapper = document.createElement('div');
  wrapper.className = `system-message room-presence-message is-${message.action}`;

  const icon = document.createElement('span');
  icon.className = 'room-presence-icon';
  icon.setAttribute('aria-hidden', 'true');
  icon.textContent = message.action === 'join' ? '👋' : '🚪';

  const name = document.createElement('strong');
  name.textContent = message.identity === session?.identity
    ? `${message.name} (Sen)`
    : message.name;
  applyNicknameEffect(name, message.nicknameEffect);

  const badge = document.createElement('span');
  badge.className = 'room-presence-role';
  badge.dataset.role = message.isVip ? 'vip' : message.role;
  badge.textContent = message.accountType === 'guest'
    ? 'Misafir'
    : roleLabel(message.role, message.isVip);

  const action = document.createElement('span');
  action.textContent = message.action === 'join'
    ? 'odaya giriş yaptı.'
    : 'odadan çıkış yaptı.';

  const time = document.createElement('time');
  const date = new Date(message.createdAt);
  time.textContent = Number.isNaN(date.getTime())
    ? ''
    : date.toLocaleTimeString('tr-TR', {
        hour: '2-digit',
        minute: '2-digit',
      });

  wrapper.append(icon, name, badge, action, time);
  chatMessages.append(wrapper);

  /*
   * Yoğun odalarda giriş/çıkış bildirimleri sohbeti kaplamasın.
   * Her bildirim 10 saniye görünür; son 600 ms'de yumuşakça kaybolur.
   */
  setTimeout(() => {
    expireRoomPresenceMessage(wrapper);
  }, ROOM_PRESENCE_VISIBLE_MS - ROOM_PRESENCE_FADE_MS);

  const visiblePresenceMessages = [
    ...chatMessages.querySelectorAll('.room-presence-message'),
  ];

  while (visiblePresenceMessages.length > ROOM_PRESENCE_MAX_VISIBLE) {
    const oldestMessage = visiblePresenceMessages.shift();
    expireRoomPresenceMessage(oldestMessage, true);
  }

  while (chatMessages.children.length > 101) {
    chatMessages.firstElementChild?.remove();
  }

  chatMessages.scrollTop = chatMessages.scrollHeight;
}

async function requestRoomMessageDelete(message, button) {
  if (
    authUser?.role !== 'admin'
    || !seatSocket?.connected
    || !message?.id
  ) {
    return;
  }

  const preview = message?.kind === 'image'
    ? 'Odaya gönderilen resim'
    : String(message.message || '').slice(0, 90);
  const confirmed = window.confirm(
    `${message.name} kullanıcısının mesajı silinsin mi?\n\n${preview}`,
  );

  if (!confirmed) return;

  button.disabled = true;

  try {
    const response = await emitWithAck(
      'chat:delete',
      { messageId: message.id },
      6_000,
    );

    if (!response?.ok) {
      throw new Error(response?.message || 'Mesaj silinemedi.');
    }
  } catch (error) {
    button.disabled = false;
    setStatus(error.message || 'Mesaj silinemedi.', 'error');
  }
}

function removeDeletedRoomMessage(payload) {
  const messageId = String(payload?.id || '').trim();
  if (!messageId) return;

  const target = chatMessages.querySelector(
    `[data-message-id="${CSS.escape(messageId)}"]`,
  );

  if (!target) return;

  target.classList.add('is-deleting');

  setTimeout(() => {
    target.remove();
  }, 260);
}

function appendChatMessage(message) {
  if (message?.identity) {
    remoteTypers.delete(message.identity);
    renderChatTyping();
  }

  const wrapper = document.createElement('article');
  wrapper.className = 'chat-message';

  const messageAvatar = document.createElement('span');
  messageAvatar.className = 'chat-message-avatar';
  renderAvatar(messageAvatar, {
    ...message,
    displayName: message.name,
  });

  if (message?.id) {
    wrapper.dataset.messageId = String(message.id);
  }

  wrapper.classList.toggle('is-self', message.identity === session?.identity);
  wrapper.classList.toggle('is-owner', Boolean(message.isOwner));
  wrapper.classList.toggle(
    'is-bot',
    Boolean(message.isBot || message.accountType === 'bot'),
  );
  wrapper.classList.toggle('has-image', message?.kind === 'image');

  const meta = document.createElement('div');
  meta.className = 'chat-message-meta';

  const name = document.createElement('strong');
  name.textContent = message.identity === session?.identity
    ? `${message.name} (Sen)`
    : message.name;
  applyNicknameEffect(name, message.nicknameEffect);

  if (message.isBot || message.accountType === 'bot') {
    const botBadge = document.createElement('span');
    botBadge.className = 'chat-bot-badge';
    botBadge.textContent = 'BOT';
    meta.append(name, botBadge);
  } else {
    meta.append(name);
  }

  const time = document.createElement('span');
  const date = new Date(message.createdAt);
  time.textContent = Number.isNaN(date.getTime())
    ? ''
    : date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });

  const bubble = document.createElement('div');
  bubble.className = 'chat-bubble';

  if (message?.kind === 'image') {
    const imageUrl = safeRoomChatImageUrl(message?.image?.url);

    if (!imageUrl) return;

    const imageLink = document.createElement('a');
    imageLink.className = 'chat-image-link';
    imageLink.href = imageUrl;
    imageLink.target = '_blank';
    imageLink.rel = 'noopener';
    imageLink.setAttribute('aria-label', `${message.name} kullanıcısının gönderdiği resmi aç`);

    const image = document.createElement('img');
    image.className = 'chat-room-image';
    image.src = imageUrl;
    image.alt = `${message.name} kullanıcısının oda sohbetine gönderdiği resim`;
    image.loading = 'lazy';
    image.decoding = 'async';
    if (Number(message?.image?.width) > 0) image.width = Number(message.image.width);
    if (Number(message?.image?.height) > 0) image.height = Number(message.image.height);
    imageLink.append(image);
    bubble.append(imageLink);

    if (message.message) {
      const caption = document.createElement('p');
      caption.className = 'chat-image-caption';
      caption.textContent = message.message;
      bubble.append(caption);
    }
  } else {
    bubble.textContent = message.message;
  }

  meta.append(time);

  const isPrivateBotReply = ['welcome', 'command'].includes(
    String(message.botKind || ''),
  );

  if (
    authUser?.role === 'admin'
    && message?.id
    && !isPrivateBotReply
  ) {
    const deleteButton = document.createElement('button');
    deleteButton.className = 'chat-message-delete';
    deleteButton.type = 'button';
    deleteButton.title = 'Mesajı sil';
    deleteButton.setAttribute(
      'aria-label',
      `${message.name} kullanıcısının mesajını sil`,
    );
    deleteButton.textContent = '🗑';

    deleteButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      void requestRoomMessageDelete(message, deleteButton);
    });

    meta.append(deleteButton);
  }

  wrapper.append(messageAvatar, meta, bubble);
  chatMessages.append(wrapper);

  while (chatMessages.children.length > 101) {
    chatMessages.firstElementChild?.remove();
  }

  chatMessages.scrollTop = chatMessages.scrollHeight;
}

function setChatEnabled(enabled) {
  if (!enabled) stopLocalChatTyping();
  chatComposerEnabled = Boolean(enabled);
  refreshChatComposerState();
  if (!enabled) closeEmojiPicker();
  chatInput.placeholder = enabled
    ? 'Bir mesaj yaz…'
    : 'Sohbet sunucusuna bağlanılıyor…';
  updateSeatReactionControls();
}

function closeEmojiPicker() {
  emojiPicker.hidden = true;
  emojiButton.setAttribute('aria-expanded', 'false');
}

function insertEmoji(emoji) {
  const start = chatInput.selectionStart ?? chatInput.value.length;
  const end = chatInput.selectionEnd ?? start;
  const nextValue = `${chatInput.value.slice(0, start)}${emoji}${chatInput.value.slice(end)}`;

  if (nextValue.length > Number(chatInput.maxLength || 500)) return;

  chatInput.value = nextValue;
  handleLocalChatTyping();
  const caret = start + emoji.length;
  chatInput.focus();
  chatInput.setSelectionRange(caret, caret);
}

function updateSeatReactionControls() {
  const socketConnected = Boolean(seatSocket?.connected);
  const seated = Boolean(getSelfSeat());
  const cooldownMs = Math.max(0, seatReactionCooldownUntil - Date.now());
  const enabled = socketConnected && seated && !seatReactionPending && cooldownMs <= 0;

  seatReactionButtons.forEach((button) => {
    button.disabled = !enabled;
  });

  if (!seatReactionNote) return;
  if (!socketConnected) seatReactionNote.textContent = 'Odaya bağlanınca kullanabilirsin';
  else if (!seated) seatReactionNote.textContent = 'Koltukta oturunca kullanabilirsin';
  else if (seatReactionPending) seatReactionNote.textContent = 'Efekt gönderiliyor…';
  else if (cooldownMs > 0) seatReactionNote.textContent = 'Yeni efekt için kısa bir an bekle';
  else seatReactionNote.textContent = 'Avatarında 2,5 saniye oynar';
}

async function sendSeatReaction(reactionId) {
  if (!seatReactionIds.has(reactionId) || seatReactionPending) return;
  if (!getSelfSeat()) {
    setStatus('Avatar efekti göndermek için önce bir koltuğa oturmalısın.', 'warning');
    return;
  }

  if (seatReactionCooldownUntil > Date.now()) return;

  seatReactionPending = true;
  updateSeatReactionControls();

  try {
    const response = await emitWithAck('seat:reaction', { reactionId }, 5_000);
    if (!response?.ok) {
      if (Number(response?.retryAfterMs) > 0) {
        seatReactionCooldownUntil = Date.now() + Number(response.retryAfterMs);
      }
      throw new Error(response?.message || 'Koltuk efekti gönderilemedi.');
    }

    const cooldownMs = Math.min(
      Math.max(Number(response.cooldownMs) || 3_000, 500),
      5_000,
    );
    seatReactionCooldownUntil = Date.now() + cooldownMs;
    closeEmojiPicker();
  } catch (error) {
    setStatus(error.message || 'Koltuk efekti gönderilemedi.', 'error');
  } finally {
    seatReactionPending = false;
    updateSeatReactionControls();
    clearTimeout(seatReactionControlTimer);
    const waitMs = Math.max(0, seatReactionCooldownUntil - Date.now());
    seatReactionControlTimer = window.setTimeout(updateSeatReactionControls, waitMs + 80);
  }
}

const seatReactionSection = document.createElement('section');
seatReactionSection.className = 'emoji-picker-section seat-reaction-section';
const seatReactionHeading = document.createElement('div');
seatReactionHeading.className = 'emoji-picker-heading';
const seatReactionTitle = document.createElement('strong');
seatReactionTitle.textContent = 'Koltuk efekti';
seatReactionNote = document.createElement('small');
seatReactionHeading.append(seatReactionTitle, seatReactionNote);

const seatReactionGrid = document.createElement('div');
seatReactionGrid.className = 'seat-reaction-grid';
for (const reaction of seatReactionCatalog) {
  const button = document.createElement('button');
  button.className = `seat-reaction-option seat-reaction-option-${reaction.id}`;
  button.type = 'button';
  button.title = reaction.label;
  button.setAttribute('aria-label', `${reaction.label} koltuk efekti gönder`);

  const face = document.createElement('span');
  face.setAttribute('aria-hidden', 'true');
  face.textContent = reaction.emoji;
  const label = document.createElement('small');
  label.textContent = reaction.label;
  button.append(face, label);
  button.addEventListener('click', () => void sendSeatReaction(reaction.id));
  seatReactionButtons.push(button);
  seatReactionGrid.append(button);
}
seatReactionSection.append(seatReactionHeading, seatReactionGrid);

const chatEmojiSection = document.createElement('section');
chatEmojiSection.className = 'emoji-picker-section chat-emoji-section';
const chatEmojiHeading = document.createElement('div');
chatEmojiHeading.className = 'emoji-picker-heading';
const chatEmojiTitle = document.createElement('strong');
chatEmojiTitle.textContent = 'Mesaja ekle';
chatEmojiHeading.append(chatEmojiTitle);
const chatEmojiGrid = document.createElement('div');
chatEmojiGrid.className = 'chat-emoji-grid';

for (const emoji of chatEmojis) {
  const button = document.createElement('button');
  button.className = 'emoji-option';
  button.type = 'button';
  button.setAttribute('aria-label', `${emoji} emojisini ekle`);
  button.textContent = emoji;
  button.addEventListener('click', () => {
    insertEmoji(emoji);
    closeEmojiPicker();
  });
  chatEmojiGrid.append(button);
}
chatEmojiSection.append(chatEmojiHeading, chatEmojiGrid);
emojiPicker.append(seatReactionSection, chatEmojiSection);
updateSeatReactionControls();

function okeyActionId() {
  if (globalThis.crypto?.randomUUID) {
    return `okey-${globalThis.crypto.randomUUID()}`;
  }

  return `okey-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

function setOkeySpectators(open, restoreFocus = false) {
  const shouldOpen = Boolean(open && okeyModeActive);
  okeySpectatorsPopover.hidden = !shouldOpen;
  okeySpectatorsBackdrop.hidden = !shouldOpen;
  okeySpectatorsButton.setAttribute('aria-expanded', String(shouldOpen));

  if (shouldOpen) okeySpectatorsClose.focus({ preventScroll: true });
  else if (restoreFocus) okeySpectatorsButton.focus({ preventScroll: true });
}

function hasOkeyPlayerSeat() {
  return Boolean(okeyModeActive && okeyState?.you?.seatNumber);
}

function canUseRoomMedia() {
  if (okeyModeActive) {
    return Boolean(
      okeyMediaRoom
      && hasOkeyPlayerSeat()
      && okeyMediaRole === 'player'
      && okeyMediaLeaseGranted,
    );
  }

  return Boolean(room && getSelfSeat());
}

function clearOkeyMediaRenewTimer() {
  clearTimeout(okeyMediaRenewTimer);
  okeyMediaRenewTimer = null;
}

function scheduleOkeyMediaGrantRefresh(delay = null) {
  clearOkeyMediaRenewTimer();

  if (!hasOkeyPlayerSeat() || !okeySocket?.connected) return;

  const untilRefresh = Math.max(
    1_200,
    Math.min(
      7_000,
      Number(delay) || okeyMediaLeaseExpiresAt - Date.now() - 5_000,
    ),
  );

  okeyMediaRenewTimer = setTimeout(async () => {
    okeyMediaRenewTimer = null;

    try {
      const response = await emitOkeyWithAck('okey:state:get', {});
      if (response?.ok && response.state) renderOkeyState(response.state);
      else scheduleOkeyMediaGrantRefresh(1_500);
    } catch {
      scheduleOkeyMediaGrantRefresh(1_500);
    }
  }, untilRefresh);
}

async function claimOkeyMediaGrant(grant) {
  if (!hasOkeyPlayerSeat() || !grant) return;

  okeyLatestMediaGrant = grant;

  if (
    okeyMediaLeaseGranted
    && okeyMediaLeaseExpiresAt > Date.now() + 5_500
  ) {
    scheduleOkeyMediaGrantRefresh();
    return;
  }

  if (okeyMediaClaimPending) return;

  if (!seatSocket?.connected || !okeyMediaRoom) {
    scheduleOkeyMediaGrantRefresh(1_200);
    return;
  }

  okeyMediaClaimPending = true;
  const leaseGeneration = okeyMediaLeaseGeneration;

  try {
    if (okeyMediaRole !== 'player') {
      await connectOkeyMediaRoom({
        grant,
        replace: true,
      });
    }

    if (
      leaseGeneration !== okeyMediaLeaseGeneration
      || !hasOkeyPlayerSeat()
      || okeyMediaRole !== 'player'
    ) {
      return;
    }

    const response = await emitWithAck('okey:media:claim', { grant }, 6_000);

    if (!response?.ok) {
      throw new Error(response?.message || 'Okey medya izni açılamadı.');
    }

    if (
      leaseGeneration !== okeyMediaLeaseGeneration
      || !hasOkeyPlayerSeat()
    ) {
      await emitWithAck('okey:media:release', {}, 4_000).catch(() => null);
      return;
    }

    okeyMediaLeaseGranted = true;
    okeyMediaLeaseExpiresAt = new Date(response.expiresAt).getTime();

    if (!Number.isFinite(okeyMediaLeaseExpiresAt)) {
      okeyMediaLeaseExpiresAt = Date.now() + 10_000;
    }

    if (okeyAutoEnableMicrophone && okeyMediaRoom && hasOkeyPlayerSeat()) {
      okeyAutoEnableMicrophone = false;

      try {
        await okeyMediaRoom.localParticipant.setMicrophoneEnabled(true);
        setStatus('Okey yerine oturdun. Mikrofonun açık.', 'success');
      } catch (error) {
        setStatus(`Okey yerine oturdun; mikrofon açılamadı: ${error.message}`, 'warning');
      }
    }

    scheduleOkeyMediaGrantRefresh();
  } catch (error) {
    if (okeyMediaLeaseExpiresAt <= Date.now()) {
      okeyMediaLeaseGranted = false;
      okeyMediaLeaseExpiresAt = 0;
    }

    if (okeyModeActive && okeyMediaRole !== 'spectator') {
      await connectOkeyMediaRoom({ replace: true }).catch((restoreError) => {
        console.warn('Okey seyirci medya bağlantısı geri getirilemedi:', restoreError);
      });
    }

    setOkeyActionNote(error.message || 'Okey ses ve kamera izni alınamadı.', 'error');
    scheduleOkeyMediaGrantRefresh(1_500);
  } finally {
    okeyMediaClaimPending = false;
    updateControls();
  }
}

async function releaseOkeyMediaLease({
  stopMedia = true,
  downgradeConnection = true,
} = {}) {
  okeyMediaLeaseGeneration += 1;
  clearOkeyMediaRenewTimer();
  okeyLatestMediaGrant = null;
  okeyAutoEnableMicrophone = false;

  const shouldNotifyServer = Boolean(
    seatSocket?.connected
    && (okeyMediaLeaseGranted || okeyMediaClaimPending),
  );

  okeyMediaLeaseGranted = false;
  okeyMediaLeaseExpiresAt = 0;
  updateControls();

  if (shouldNotifyServer) {
    await emitWithAck('okey:media:release', {}, 4_000).catch(() => null);
  }

  if (stopMedia && okeyMediaRoom) {
    try {
      if (okeyMediaRoom.localParticipant.isCameraEnabled) {
        await okeyMediaRoom.localParticipant.setCameraEnabled(false);
      }
      if (okeyMediaRoom.localParticipant.isMicrophoneEnabled) {
        await okeyMediaRoom.localParticipant.setMicrophoneEnabled(false);
      }
    } catch (error) {
      console.warn('Okey yerel medyası kapatılamadı:', error);
    }

    const localVideo = okeyMediaVideoTracks.get(session?.identity);
    localVideo?.detach().forEach((element) => element.remove());
    okeyMediaVideoTracks.delete(session?.identity);
    renderOkeyState();
  }

  if (
    downgradeConnection
    && okeyModeActive
    && okeyMediaRoom
    && okeyMediaRole === 'player'
  ) {
    try {
      await connectOkeyMediaRoom({ replace: true });
    } catch (error) {
      setOkeyActionNote(
        `Okey seyirci bağlantısı geri getirilemedi: ${error.message}`,
        'error',
      );
    }
  }
}

function setOkeyConnectionBadge(message, state = 'offline') {
  okeyConnectionBadge.textContent = message;
  okeyConnectionBadge.classList.toggle('is-connected', state === 'connected');
  okeyConnectionBadge.classList.toggle('is-offline', state === 'offline');
}

function setOkeyActionNote(message, type = 'normal') {
  okeyActionNote.textContent = message;
  okeyActionNote.dataset.type = type;
}

function okeyParticipantPresentation(participant) {
  if (!participant) return null;

  const roomMember = currentRoomState?.members?.find(
    (member) => member.identity === participant.identity,
  );
  const ownProfile = participant.identity === session?.identity
    ? authUser
    : null;

  return {
    ...roomMember,
    ...participant,
    displayName: participant.displayName
      || roomMember?.name
      || ownProfile?.displayName
      || 'Kullanıcı',
    avatarUrl: participant.avatarUrl
      || roomMember?.avatarUrl
      || ownProfile?.avatarUrl
      || null,
  };
}

function appendOkeyAvatar(container, participant) {
  container.replaceChildren();
  const presentation = okeyParticipantPresentation(participant);

  if (presentation?.avatarUrl) {
    const image = document.createElement('img');
    image.src = presentation.avatarUrl;
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.referrerPolicy = 'no-referrer';
    container.append(image);
    return;
  }

  container.textContent = presentation ? initials(presentation.displayName) : '+';
}

function okeyParticipantByIdentity(identity) {
  return okeyState?.seats
    ?.find((seat) => seat.occupant?.identity === identity)
    ?.occupant || null;
}

function detachRenderedOkeyVideos() {
  for (const { track, element } of okeyVideoElements.values()) {
    try {
      track.detach(element);
    } catch (error) {
      console.warn('Okey kamera önizlemesi ayrılamadı:', error);
    }
    element.remove();
  }

  okeyVideoElements.clear();
}

function attachVideosToOkeySeats() {
  if (!okeyModeActive || !okeyState) return;

  for (const [identity, track] of okeyMediaVideoTracks) {
    const seat = okeyModePanel.querySelector(
      `.okey-seat[data-identity="${CSS.escape(identity)}"]`,
    );
    const avatar = seat?.querySelector('.okey-seat-avatar');

    if (!avatar) continue;

    const element = track.attach();
    element.autoplay = true;
    element.playsInline = true;
    element.muted = identity === session?.identity;
    avatar.replaceChildren(element);
    okeyVideoElements.set(identity, { track, element });
  }
}

const okeySeatPositionClasses = [
  'okey-seat-bottom',
  'okey-seat-left',
  'okey-seat-top',
  'okey-seat-right',
];

function okeySeatScreenPosition(seatNumber, viewerSeatNumber = null) {
  const normalizedSeat = Number(seatNumber);
  const normalizedViewer = Number(viewerSeatNumber);

  if (!Number.isInteger(normalizedViewer) || normalizedViewer < 1 || normalizedViewer > 4) {
    return okeySeatPositionClasses[normalizedSeat - 1] || 'okey-seat-bottom';
  }

  const relativeIndex = (normalizedSeat - normalizedViewer + 4) % 4;
  return okeySeatPositionClasses[relativeIndex];
}

function okeyColorLabel(color) {
  return {
    red: 'kırmızı',
    yellow: 'sarı',
    black: 'siyah',
    blue: 'mavi',
  }[color] || '';
}

function okeyTileLabel(tile) {
  if (!tile) return '';
  if (tile.fakeOkey) return 'Sahte okey';
  return `${okeyColorLabel(tile.color)} ${tile.value}`.trim();
}

function createOkeyTileElement(
  tile = null,
  { hidden = false, isOkey = false, interactive = false } = {},
) {
  const element = document.createElement(interactive ? 'button' : 'span');
  element.className = 'okey-game-tile';

  if (interactive) element.type = 'button';

  if (hidden) {
    element.classList.add('is-back');
    element.setAttribute('aria-hidden', 'true');
    return element;
  }

  element.classList.add(`is-${tile?.color || 'fake'}`);
  element.classList.toggle('is-fake', Boolean(tile?.fakeOkey));
  element.classList.toggle('is-okey', Boolean(isOkey));
  element.textContent = tile?.fakeOkey ? '★' : String(tile?.value || '');
  element.title = okeyTileLabel(tile);
  element.setAttribute('aria-label', okeyTileLabel(tile));

  if (interactive && tile?.id) {
    element.dataset.tileId = tile.id;
  }

  return element;
}

// PHASE2D_RACK_PURE_START
const OKEY_RACK_SLOT_COUNT = 16;

function compareOkeyRackTiles(left, right, strategy = 'color') {
  if (left.fakeOkey !== right.fakeOkey) return left.fakeOkey ? 1 : -1;

  const colorOrder = new Map([
    ['red', 0],
    ['yellow', 1],
    ['black', 2],
    ['blue', 3],
  ]);
  const leftColor = colorOrder.get(left.color) ?? 9;
  const rightColor = colorOrder.get(right.color) ?? 9;
  const colorDifference = leftColor - rightColor;
  const valueDifference = Number(left.value || 0) - Number(right.value || 0);

  if (strategy === 'number') {
    return valueDifference || colorDifference || String(left.id).localeCompare(String(right.id));
  }

  return colorDifference || valueDifference || String(left.id).localeCompare(String(right.id));
}

function createSortedOkeyRackSlots(hand, strategy = 'color') {
  const slots = Array.from({ length: OKEY_RACK_SLOT_COUNT }, () => null);
  [...hand]
    .sort((left, right) => compareOkeyRackTiles(left, right, strategy))
    .slice(0, OKEY_RACK_SLOT_COUNT)
    .forEach((tile, index) => {
      slots[index] = tile.id;
    });
  return slots;
}

function reconcileOkeyRackSlots(slots, hand) {
  const validIds = new Set(hand.map((tile) => tile.id));
  const seen = new Set();
  const next = Array.from({ length: OKEY_RACK_SLOT_COUNT }, () => null);

  for (let index = 0; index < OKEY_RACK_SLOT_COUNT; index += 1) {
    const tileId = Array.isArray(slots) ? slots[index] : null;
    if (typeof tileId !== 'string' || !validIds.has(tileId) || seen.has(tileId)) continue;
    next[index] = tileId;
    seen.add(tileId);
  }

  for (const tile of hand) {
    if (seen.has(tile.id)) continue;
    const emptyIndex = next.indexOf(null);
    if (emptyIndex < 0) break;
    next[emptyIndex] = tile.id;
    seen.add(tile.id);
  }

  return next;
}

function moveOkeyRackTileInSlots(slots, tileId, targetIndex) {
  if (
    !Array.isArray(slots)
    || typeof tileId !== 'string'
    || !Number.isInteger(targetIndex)
    || targetIndex < 0
    || targetIndex >= OKEY_RACK_SLOT_COUNT
  ) return slots;

  const sourceIndex = slots.indexOf(tileId);
  if (sourceIndex < 0 || sourceIndex === targetIndex) return slots;

  const next = [...slots];
  const targetTileId = next[targetIndex] || null;
  next[targetIndex] = tileId;
  next[sourceIndex] = targetTileId;
  return next;
}
// PHASE2D_RACK_PURE_END

function okeyRackStorageKey(state = okeyState) {
  const roomSlug = state?.roomSlug || session?.roomSlug;
  const identity = state?.you?.identity;
  if (!roomSlug || !identity) return null;

  return `seslicity:okey-rack:v1:${encodeURIComponent(roomSlug)}:${encodeURIComponent(identity)}`;
}

function saveOkeyRackLayout() {
  if (!okeyRackLayoutKey || !okeyRackGameId || okeyRackSlots.length !== OKEY_RACK_SLOT_COUNT) {
    return;
  }

  try {
    localStorage.setItem(okeyRackLayoutKey, JSON.stringify({
      version: 1,
      gameId: okeyRackGameId,
      slots: okeyRackSlots,
      updatedAt: Date.now(),
    }));
  } catch (error) {
    console.warn('Istaka düzeni cihazda saklanamadı:', error);
  }
}

function ensureOkeyRackLayout(state, ownHand) {
  const nextKey = okeyRackStorageKey(state);
  const nextGameId = String(state?.game?.id || '');
  const changedGame = nextKey !== okeyRackLayoutKey || nextGameId !== okeyRackGameId;
  let candidateSlots = okeyRackSlots;

  if (changedGame) {
    candidateSlots = null;

    if (nextKey && nextGameId) {
      try {
        const saved = JSON.parse(localStorage.getItem(nextKey) || 'null');
        if (
          saved?.version === 1
          && String(saved.gameId || '') === nextGameId
          && Array.isArray(saved.slots)
        ) {
          candidateSlots = saved.slots;
        }
      } catch (error) {
        console.warn('Kayıtlı ıstaka düzeni okunamadı:', error);
      }
    }

    okeyRackLayoutKey = nextKey;
    okeyRackGameId = nextGameId;
    okeyRackMoveTileId = null;
  }

  if (!Array.isArray(candidateSlots)) {
    candidateSlots = createSortedOkeyRackSlots(ownHand, 'color');
  }

  const reconciled = reconcileOkeyRackSlots(candidateSlots, ownHand);
  const changedSlots = JSON.stringify(reconciled) !== JSON.stringify(okeyRackSlots);
  okeyRackSlots = reconciled;

  if (changedGame || changedSlots) saveOkeyRackLayout();
  return okeyRackSlots;
}

function resetOkeyRackRuntime() {
  okeyRackLayoutKey = null;
  okeyRackGameId = null;
  okeyRackSlots = [];
  okeyRackArrangeMode = false;
  okeyRackMoveTileId = null;
  okeyRackDraggingTileId = null;
  okeyRackSuppressClickUntil = 0;
}

function refreshOkeyRackOnly() {
  renderOkeyRacks(okeyState);
  updateOkeyTileSelection();
}

function moveOkeyRackTile(tileId, targetIndex, { announce = true } = {}) {
  const nextSlots = moveOkeyRackTileInSlots(okeyRackSlots, tileId, targetIndex);
  if (nextSlots === okeyRackSlots) return false;

  okeyRackSlots = nextSlots;
  okeyRackMoveTileId = null;
  saveOkeyRackLayout();
  refreshOkeyRackOnly();

  if (announce) {
    setOkeyActionNote('Istaka düzenin bu cihazda kaydedildi.', 'success');
  }
  return true;
}

function sortOkeyRack(strategy) {
  const hand = Array.isArray(okeyState?.you?.hand) ? okeyState.you.hand : [];
  if (!hand.length || okeyActionPending) return;

  okeyRackSlots = createSortedOkeyRackSlots(hand, strategy);
  okeyRackMoveTileId = null;
  saveOkeyRackLayout();
  refreshOkeyRackOnly();
  setOkeyActionNote(
    strategy === 'number'
      ? 'Taşlar sayılarına göre dizildi.'
      : 'Taşlar renklerine göre dizildi.',
    'success',
  );
}

function updateOkeyRackTools() {
  const hasPrivateHand = Boolean(okeyState?.game && okeyState?.you?.hand?.length);
  okeyRackTools.hidden = !hasPrivateHand;

  if (!hasPrivateHand) {
    okeyRackArrangeMode = false;
    okeyRackMoveTileId = null;
  }

  okeyRackArrangeButton.disabled = !hasPrivateHand || okeyActionPending;
  okeyRackSortColorButton.disabled = !hasPrivateHand || okeyActionPending;
  okeyRackSortNumberButton.disabled = !hasPrivateHand || okeyActionPending;
  okeyRackArrangeButton.classList.toggle('is-active', okeyRackArrangeMode);
  okeyRackArrangeButton.setAttribute('aria-pressed', String(okeyRackArrangeMode));
  okeyRackArrangeButton.textContent = okeyRackArrangeMode ? 'Düzenlemeyi bitir' : 'Düzenle';
}

function updateOkeyTileSelection() {
  const canDiscard = Boolean(okeyState?.you?.canDiscard);
  if (!canDiscard) okeySelectedTileId = null;

  const selectedTile = okeyState?.you?.hand?.find(
    (tile) => tile.id === okeySelectedTileId,
  );

  if (!selectedTile) okeySelectedTileId = null;

  okeyModePanel.querySelectorAll('.okey-game-tile[data-tile-id]')
    .forEach((element) => {
      const selected = element.dataset.tileId === okeySelectedTileId;
      element.classList.toggle('is-selected', selected);
      element.classList.toggle('is-arrange-selected', element.dataset.tileId === okeyRackMoveTileId);
      element.setAttribute('aria-pressed', String(selected));
      element.disabled = okeyActionPending;
      element.setAttribute('aria-disabled', String(!canDiscard && !okeyRackArrangeMode));
    });

  okeyDiscardButton.disabled = Boolean(
    !canDiscard
    || !okeySelectedTileId
    || okeyActionPending
    || !okeySocket?.connected,
  );
  okeyDiscardButton.textContent = okeySelectedTileId ? 'Seçili taşı at' : 'Taş seç ve at';
  okeyDiscardButton.title = selectedTile
    ? `${okeyTileLabel(selectedTile)} taşını at`
    : 'Önce ıstakandan bir taş seç';
  updateOkeyRackTools();
}

function renderOkeyRacks(state) {
  const viewerSeatNumber = Number(state?.you?.seatNumber) || null;
  const game = state?.game || null;
  const ownHand = Array.isArray(state?.you?.hand) ? state.you.hand : [];

  for (const rack of Object.values(okeyVisualRacks)) {
    rack?.replaceChildren();
    rack?.classList.remove('has-tiles', 'has-private-hand', 'is-arranging');
    rack?.removeAttribute('aria-label');
    rack?.setAttribute('aria-hidden', 'true');
  }

  if (!game) {
    okeySelectedTileId = null;
    resetOkeyRackRuntime();
    return;
  }

  if (!ownHand.some((tile) => tile.id === okeySelectedTileId)) {
    okeySelectedTileId = null;
  }

  if (!ownHand.some((tile) => tile.id === okeyRackMoveTileId)) {
    okeyRackMoveTileId = null;
  }

  const privateSlots = ensureOkeyRackLayout(state, ownHand);
  const ownTilesById = new Map(ownHand.map((tile) => [tile.id, tile]));

  for (const seat of state?.seats || []) {
    const positionClass = okeySeatScreenPosition(seat.number, viewerSeatNumber);
    const position = positionClass.replace('okey-seat-', '');
    const rack = okeyVisualRacks[position];
    const isSelf = seat.number === viewerSeatNumber;
    const tileCount = Number(seat.tileCount) || 0;

    if (!rack || !seat.occupant || tileCount < 1) continue;

    const layer = document.createElement('div');
    layer.className = 'okey-rack-tiles';
    const tiles = isSelf
      ? privateSlots.map((tileId) => ownTilesById.get(tileId) || null)
      : Array.from({ length: tileCount }, () => null);

    for (const [slotIndex, tile] of tiles.entries()) {
      if (isSelf) {
        const slot = document.createElement('span');
        slot.className = 'okey-rack-slot';
        slot.dataset.rackSlot = String(slotIndex);
        slot.classList.toggle('is-empty', !tile);
        slot.tabIndex = okeyRackArrangeMode && !tile ? 0 : -1;
        if (!tile) {
          slot.setAttribute('role', 'button');
          slot.setAttribute('aria-label', `${slotIndex + 1}. boş ıstaka yeri`);
        }

        slot.addEventListener('dragover', (event) => {
          if (!okeyRackDraggingTileId || okeyActionPending) return;
          event.preventDefault();
          if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
          slot.classList.add('is-drop-target');
        });
        slot.addEventListener('dragleave', () => {
          slot.classList.remove('is-drop-target');
        });
        slot.addEventListener('drop', (event) => {
          event.preventDefault();
          slot.classList.remove('is-drop-target');
          const tileId = okeyRackDraggingTileId
            || event.dataTransfer?.getData('text/plain');
          if (tileId) moveOkeyRackTile(tileId, slotIndex);
        });
        slot.addEventListener('click', () => {
          if (!okeyRackArrangeMode || !okeyRackMoveTileId || tile || okeyActionPending) return;
          moveOkeyRackTile(okeyRackMoveTileId, slotIndex);
        });
        slot.addEventListener('keydown', (event) => {
          if (!okeyRackArrangeMode || !okeyRackMoveTileId || tile || okeyActionPending) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          moveOkeyRackTile(okeyRackMoveTileId, slotIndex);
        });

        if (!tile) {
          layer.append(slot);
          continue;
        }

        const tileElement = createOkeyTileElement(tile, {
          interactive: true,
          isOkey: Boolean(
            !tile.fakeOkey
            && tile.color === game.okey?.color
            && tile.value === game.okey?.value
          ),
        });
        tileElement.draggable = true;
        tileElement.dataset.rackSlot = String(slotIndex);
        tileElement.setAttribute('aria-grabbed', String(tile.id === okeyRackMoveTileId));
        tileElement.title = `${okeyTileLabel(tile)} • Sürükleyerek yerini değiştir`;

        tileElement.addEventListener('dragstart', (event) => {
          if (okeyActionPending) {
            event.preventDefault();
            return;
          }
          okeyRackDraggingTileId = tile.id;
          tileElement.classList.add('is-dragging');
          if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', tile.id);
          }
        });
        tileElement.addEventListener('dragend', () => {
          okeyRackDraggingTileId = null;
          okeyRackSuppressClickUntil = Date.now() + 300;
          tileElement.classList.remove('is-dragging');
          layer.querySelectorAll('.is-drop-target')
            .forEach((element) => element.classList.remove('is-drop-target'));
        });
        tileElement.addEventListener('click', (event) => {
          event.stopPropagation();
          if (Date.now() < okeyRackSuppressClickUntil) return;

          if (okeyRackArrangeMode) {
            if (okeyActionPending) return;

            if (!okeyRackMoveTileId) {
              okeyRackMoveTileId = tile.id;
              updateOkeyTileSelection();
              setOkeyActionNote(
                `${okeyTileLabel(tile)} seçildi. Taşımak istediğin yere dokun.`,
                'success',
              );
              return;
            }

            if (okeyRackMoveTileId === tile.id) {
              okeyRackMoveTileId = null;
              updateOkeyTileSelection();
              setOkeyActionNote('Istaka taşıma seçimi kaldırıldı.', 'normal');
              return;
            }

            moveOkeyRackTile(okeyRackMoveTileId, slotIndex);
            return;
          }

          if (!okeyState?.you?.canDiscard || okeyActionPending) {
            setOkeyActionNote(
              'Taşların yerini değiştirmek için Düzenle düğmesini kullanabilirsin.',
              'normal',
            );
            return;
          }

          okeySelectedTileId = okeySelectedTileId === tile.id ? null : tile.id;
          updateOkeyTileSelection();
          setOkeyActionNote(
            okeySelectedTileId
              ? `${okeyTileLabel(tile)} seçildi. Atmak için düğmeye dokun.`
              : 'Taş seçimi kaldırıldı.',
            okeySelectedTileId ? 'success' : 'normal',
          );
        });
        tileElement.addEventListener('keydown', (event) => {
          if (!okeyRackArrangeMode || okeyActionPending) return;

          const offsets = {
            ArrowLeft: -1,
            ArrowRight: 1,
            ArrowUp: -8,
            ArrowDown: 8,
          };
          const offset = offsets[event.key];
          if (!offset) return;

          event.preventDefault();
          const targetIndex = slotIndex + offset;
          if (targetIndex < 0 || targetIndex >= OKEY_RACK_SLOT_COUNT) return;
          moveOkeyRackTile(tile.id, targetIndex, { announce: false });
        });

        slot.append(tileElement);
        layer.append(slot);
        continue;
      }

      const tileElement = createOkeyTileElement(tile, {
        hidden: true,
      });
      layer.append(tileElement);
    }

    rack.append(layer);
    rack.classList.add('has-tiles');
    rack.classList.toggle('has-private-hand', isSelf);
    rack.classList.toggle('is-arranging', isSelf && okeyRackArrangeMode);
    rack.setAttribute('aria-hidden', isSelf ? 'false' : 'true');

    if (isSelf) {
      rack.setAttribute(
        'aria-label',
        `Istakandaki ${tileCount} taş. Masaüstünde sürükleyebilir, mobilde Düzenle düğmesini kullanabilirsin.`,
      );
    }
  }
}

function renderOkeyState(state = okeyState) {
  detachRenderedOkeyVideos();
  okeyState = state || null;
  okeyActionSequence = Number(okeyState?.you?.lastActionSequence) || 0;

  const seatedCount = Number(okeyState?.seatedCount) || 0;
  const readyCount = okeyState?.seats?.filter((seat) => seat.ready).length || 0;
  const spectatorCount = Number(okeyState?.spectatorCount) || 0;
  const playing = okeyState?.status === 'playing' && Boolean(okeyState?.game);
  const viewerSeatNumber = Number(okeyState?.you?.seatNumber) || null;
  const turnPhase = okeyState?.game?.turnPhase || null;
  const lastDiscard = okeyState?.game?.lastDiscard || null;
  const turnSeat = okeyState?.seats?.find(
    (seat) => seat.number === okeyState?.game?.turnSeatNumber,
  );

  okeyTableStatus.textContent = playing
    ? `Okey: ${okeyTileLabel(okeyState.game.okey)}`
    : okeyState?.status === 'ready'
      ? 'Dört oyuncu da hazır'
      : 'Oyuncular bekleniyor';
  okeyTableSummary.textContent = playing
    ? `Sıra: ${turnSeat?.occupant?.displayName || `${okeyState.game.turnSeatNumber}. oyuncu`} • ${turnPhase === 'draw' ? 'taş çekecek' : 'taş atacak'} • ${okeyState.game.remainingTileCount} taş`
    : `${readyCount} / ${seatedCount || 4} oyuncu hazır`;
  okeyTableMark.textContent = playing
    ? String(okeyState.game.indicator?.value || '?')
    : 'S';
  okeyTableMark.classList.toggle('is-indicator', playing);
  if (playing) {
    okeyTableMark.dataset.color = okeyState.game.indicator?.color || '';
    okeyTableMark.title = `Gösterge: ${okeyTileLabel(okeyState.game.indicator)} • Okey: ${okeyTileLabel(okeyState.game.okey)}`;
    okeyTableMark.setAttribute('aria-hidden', 'false');
    okeyTableMark.setAttribute('aria-label', `Gösterge ${okeyTileLabel(okeyState.game.indicator)}`);
  } else {
    delete okeyTableMark.dataset.color;
    okeyTableMark.removeAttribute('title');
    okeyTableMark.setAttribute('aria-hidden', 'true');
  }

  okeyLastDiscard.replaceChildren();
  okeyLastDiscard.hidden = !lastDiscard?.tile;
  if (lastDiscard?.tile) {
    const tile = createOkeyTileElement(lastDiscard.tile, {
      isOkey: Boolean(
        !lastDiscard.tile.fakeOkey
        && lastDiscard.tile.color === okeyState.game.okey?.color
        && lastDiscard.tile.value === okeyState.game.okey?.value
      ),
    });
    const label = document.createElement('small');
    label.textContent = 'Son atılan';
    okeyLastDiscard.append(tile, label);
    okeyLastDiscard.setAttribute(
      'aria-label',
      `Son atılan taş ${okeyTileLabel(lastDiscard.tile)}`,
    );
  } else {
    okeyLastDiscard.removeAttribute('aria-label');
  }
  okeySpectatorCount.textContent = `${spectatorCount} izleyici`;
  okeySpectatorsTotal.textContent = String(spectatorCount);

  for (const button of okeySeatButtons) {
    const seatNumber = Number(button.dataset.okeySeat);
    const seat = okeyState?.seats?.find((item) => item.number === seatNumber);
    const occupant = seat?.occupant || null;
    const self = occupant?.identity === okeyState?.you?.identity;
    const hasCamera = Boolean(
      occupant?.identity && okeyMediaVideoTracks.has(occupant.identity),
    );
    const avatar = button.querySelector('.okey-seat-avatar');
    const name = button.querySelector('.okey-seat-name');
    const seatState = button.querySelector('.okey-seat-state');

    button.classList.remove(...okeySeatPositionClasses);
    button.classList.add(okeySeatScreenPosition(seatNumber, viewerSeatNumber));

    appendOkeyAvatar(avatar, occupant);
    name.textContent = occupant?.displayName || 'Boş yer';
    seatState.textContent = occupant
      ? (!occupant.connected
          ? 'Bağlantısı bekleniyor'
          : playing
            ? `${Number(seat.tileCount) || 0} taş${seat.number === okeyState.game.turnSeatNumber ? ' • Sırası' : ''}`
            : seat.ready
            ? 'Hazır'
            : self
              ? 'Hazır olman bekleniyor'
              : 'Masada')
      : 'Oturmak için dokun';

    button.classList.toggle('is-self', Boolean(self));
    button.classList.toggle('is-ready', Boolean(seat?.ready));
    button.classList.toggle(
      'is-turn',
      Boolean(playing && seat?.number === okeyState?.game?.turnSeatNumber),
    );
    button.classList.toggle('is-disconnected', Boolean(occupant && !occupant.connected));
    button.classList.toggle('has-camera', hasCamera);
    button.classList.toggle(
      'is-speaking',
      Boolean(
        occupant?.identity && okeyActiveSpeakerIdentities.has(occupant.identity),
      ),
    );
    if (occupant?.identity) button.dataset.identity = occupant.identity;
    else delete button.dataset.identity;
    button.disabled = Boolean(
      okeyActionPending
      || !okeySocket?.connected
      || (playing && !occupant)
      || (occupant && !self && !hasCamera),
    );
    button.setAttribute(
      'aria-label',
      occupant
        ? `${seatNumber}. yer, ${occupant.displayName}${seat.ready ? ', hazır' : ''}`
        : `${seatNumber}. boş Okey oyuncu yerine otur`,
    );
  }

  renderOkeyRacks(okeyState);
  attachVideosToOkeySeats();

  okeySpectatorsList.replaceChildren();
  const spectators = okeyState?.spectators || [];

  if (!spectators.length) {
    const empty = document.createElement('p');
    empty.textContent = 'Şu anda masada seyirci yok.';
    okeySpectatorsList.append(empty);
  } else {
    for (const spectator of spectators) {
      const item = document.createElement('div');
      item.className = 'okey-spectator-item';
      const avatar = document.createElement('span');
      appendOkeyAvatar(avatar, spectator);
      const name = document.createElement('strong');
      name.textContent = spectator.displayName;
      item.classList.toggle('is-disconnected', !spectator.connected);
      item.append(avatar, name);
      okeySpectatorsList.append(item);
    }
  }

  const seated = Boolean(okeyState?.you?.seatNumber);
  const ready = Boolean(okeyState?.you?.ready);
  const canDrawWall = Boolean(okeyState?.you?.canDrawWall);
  const canTakeDiscard = Boolean(okeyState?.you?.canTakeDiscard);
  const canDiscard = Boolean(okeyState?.you?.canDiscard);

  okeyDrawWallButton.hidden = !canDrawWall;
  okeyDrawWallButton.disabled = !canDrawWall || okeyActionPending || !okeySocket?.connected;
  okeyTakeDiscardButton.hidden = !canTakeDiscard;
  okeyTakeDiscardButton.disabled = !canTakeDiscard || okeyActionPending || !okeySocket?.connected;
  okeyTakeDiscardButton.textContent = 'Atılan taşı al';
  okeyTakeDiscardButton.title = lastDiscard?.tile
    ? `${okeyTileLabel(lastDiscard.tile)} taşını al`
    : 'Son atılan taşı al';
  okeyDiscardButton.hidden = !canDiscard;

  okeyReadyButton.hidden = playing;
  okeyReadyButton.disabled = playing || !seated || okeyActionPending || !okeySocket?.connected;
  okeyReadyButton.textContent = playing ? 'Oyun başladı' : ready ? 'Hazır değilim' : 'Hazır ol';
  okeyReadyButton.classList.toggle('is-active', ready);
  okeyLeaveSeatButton.disabled = !seated || okeyActionPending || !okeySocket?.connected;

  okeyResetButton.hidden = !okeyState?.you?.canReset;
  okeyResetButton.disabled = okeyActionPending || !okeySocket?.connected;
  okeyCloseButton.hidden = !okeyState?.you?.canClose;
  okeyCloseButton.disabled = okeyActionPending || !okeySocket?.connected;

  updateOkeyTileSelection();

  if (!okeyState) {
    setOkeyActionNote('Güvenli Okey bağlantısı hazırlanıyor…', 'warning');
  } else if (playing && canDiscard) {
    setOkeyActionNote('Sıra sende. Istakandan bir taş seçip at.', 'success');
  } else if (playing && (canDrawWall || canTakeDiscard)) {
    setOkeyActionNote(
      canTakeDiscard
        ? `Sıra sende. Ortadan çekebilir veya ${okeyTileLabel(lastDiscard?.tile)} taşını alabilirsin.`
        : 'Sıra sende. Ortadan bir taş çek.',
      'success',
    );
  } else if (playing && seated) {
    setOkeyActionNote(
      `Sıra ${turnSeat?.occupant?.displayName || 'diğer oyuncuda'}.`,
      'normal',
    );
  } else if (playing) {
    setOkeyActionNote('Oyun başladı. Oyuncuların taşları gizli tutuluyor.', 'success');
  } else if (!seated) {
    setOkeyActionNote('Seyircisin. Boş bir oyuncu yerine dokunarak masaya oturabilirsin.');
  } else if (!ready) {
    setOkeyActionNote('Oyuncu yerin ayrıldı. Hazır olduğunda düğmeye dokun.', 'success');
  } else {
    setOkeyActionNote('Hazırsın. Diğer oyuncular bekleniyor.', 'success');
  }

  if (seated && okeyState?.you?.mediaGrant && !okeyIntentionalLeave) {
    void claimOkeyMediaGrant(okeyState.you.mediaGrant);
  } else if (
    !seated
    && (okeyMediaLeaseGranted || okeyMediaClaimPending || okeyLatestMediaGrant)
  ) {
    void releaseOkeyMediaLease();
  }

  updateControls();
}

function scheduleOkeyReconnect() {
  clearTimeout(okeyReconnectTimer);
  okeyReconnectTimer = null;

  if (!okeyModeActive || okeyIntentionalLeave || !session?.roomSlug) return;

  setOkeyConnectionBadge('Yeniden bağlanıyor', 'offline');
  okeyReconnectTimer = setTimeout(() => {
    okeyReconnectTimer = null;
    void connectOkeySocket(true);
  }, 900);
}

async function connectOkeySocket(isReconnect = false) {
  if (
    !okeyModeActive
    || !session?.roomSlug
    || okeyConnectPending
    || okeySocket?.connected
  ) {
    return;
  }

  okeyConnectPending = true;
  okeyIntentionalLeave = false;
  setOkeyConnectionBadge(isReconnect ? 'Geri dönülüyor' : 'Bağlanıyor', 'pending');

  try {
    const ticketData = await apiRequest('/api/okey/ticket', {
      method: 'POST',
      body: JSON.stringify({ roomSlug: session.roomSlug }),
    });

    if (!okeyModeActive || ticketData.room?.slug !== session.roomSlug) return;

    const socket = io({
      path: ticketData.socketPath || '/okey/socket.io',
      auth: { ticket: ticketData.ticket },
      transports: ['websocket', 'polling'],
      reconnection: false,
      timeout: 8_000,
    });

    okeySocket?.removeAllListeners();
    okeySocket?.disconnect();
    okeySocket = socket;

    socket.on('connect', () => {
      if (socket !== okeySocket) return;
      setOkeyConnectionBadge('Okey bağlı', 'connected');
    });

    socket.on('okey:welcome', (payload) => {
      if (socket !== okeySocket) return;
      renderOkeyState(payload?.state);
      setOkeyConnectionBadge('Okey bağlı', 'connected');
      setOkeyActionNote(
        isReconnect
          ? 'Masadaki yerine güvenli şekilde geri döndün.'
          : 'Okey masasına seyirci olarak bağlandın.',
        'success',
      );
    });

    socket.on('okey:state', (state) => {
      if (socket === okeySocket && state) renderOkeyState(state);
    });

    socket.on('okey:table:closed', (payload) => {
      if (socket !== okeySocket) return;
      okeyIntentionalLeave = true;
      setStatus(payload?.message || 'Okey masası yönetici tarafından kapatıldı.', 'warning');
      void setOkeyMode(false, { skipServerLeave: true });
    });

    socket.on('okey:session:replaced', (payload) => {
      if (socket !== okeySocket) return;
      okeyIntentionalLeave = true;
      setStatus(payload?.message || 'Okey oturumun başka bir sekmede açıldı.', 'warning');
      void setOkeyMode(false, { skipServerLeave: true });
    });

    socket.on('disconnect', () => {
      if (socket !== okeySocket) return;
      okeySocket = null;
      renderOkeyState(okeyState);
      scheduleOkeyReconnect();
    });

    socket.on('connect_error', (error) => {
      if (socket !== okeySocket) return;
      socket.removeAllListeners();
      socket.disconnect();
      okeySocket = null;
      setOkeyActionNote(
        `Okey bağlantısı kurulamadı: ${error.message}`,
        'error',
      );
      scheduleOkeyReconnect();
    });
  } catch (error) {
    setOkeyActionNote(error.message || 'Okey masasına bağlanılamadı.', 'error');
    scheduleOkeyReconnect();
  } finally {
    okeyConnectPending = false;
  }
}

function emitOkeyWithAck(event, payload, timeout = 8_000) {
  return new Promise((resolve, reject) => {
    if (!okeySocket?.connected) {
      reject(new Error('Okey sunucusuna bağlı değilsin.'));
      return;
    }

    okeySocket.timeout(timeout).emit(event, payload, (error, response) => {
      if (error) {
        reject(new Error('Okey sunucusundan zamanında cevap alınamadı.'));
        return;
      }

      resolve(response);
    });
  });
}

async function performOkeyAction(event, payload = {}) {
  if (okeyActionPending) return null;

  const actionPayload = {
    ...payload,
    actionId: okeyActionId(),
    sequence: okeyActionSequence + 1,
  };

  okeyActionPending = true;
  renderOkeyState();

  try {
    const response = await emitOkeyWithAck(event, actionPayload);

    if (!response?.ok) {
      throw new Error(response?.message || 'Okey işlemi tamamlanamadı.');
    }

    okeyActionSequence = actionPayload.sequence;
    if (response.state) renderOkeyState(response.state);
    return response;
  } finally {
    okeyActionPending = false;
    renderOkeyState();
  }
}

async function disconnectOkeySocket({ leaveTable = true } = {}) {
  clearTimeout(okeyReconnectTimer);
  okeyReconnectTimer = null;
  okeyIntentionalLeave = true;
  setOkeySpectators(false);

  const socket = okeySocket;
  okeySocket = null;

  if (socket?.connected && leaveTable) {
    const actionPayload = {
      actionId: okeyActionId(),
      sequence: okeyActionSequence + 1,
    };

    await new Promise((resolve) => {
      socket.timeout(3_500).emit(
        'okey:mode:leave',
        actionPayload,
        (_error, response) => {
          if (response?.ok) okeyActionSequence = actionPayload.sequence;
          resolve();
        },
      );
      setTimeout(resolve, 3_700);
    });
  }

  await releaseOkeyMediaLease({ downgradeConnection: false });

  socket?.removeAllListeners();
  socket?.disconnect();
  okeyState = null;
  okeyActionSequence = 0;
  okeyActionPending = false;
  okeyConnectPending = false;
  setOkeyConnectionBadge('Bağlı değil', 'offline');
  renderOkeyState(null);
}

async function suspendNormalMediaRoomForOkey() {
  const activeRoom = room;
  room = null;
  normalMediaSuspendedForOkey = true;

  if (activeRoom) {
    await activeRoom.disconnect().catch((error) => {
      console.warn('Normal oda medyası kapatılırken hata oluştu:', error);
    });
  }

  clearVoiceMediaElements();
  applyRoomAudioState();
}

async function restoreNormalMediaRoomAfterOkey() {
  if (!normalMediaSuspendedForOkey || !session?.roomSlug || room) return;

  const tokenData = await apiRequest('/api/token', {
    method: 'POST',
    body: JSON.stringify({ roomSlug: session.roomSlug }),
  });

  if (tokenData.identity !== session.identity) {
    throw new Error('Normal oda medya kimliği doğrulanamadı.');
  }

  const nextRoom = createLiveKitRoom();
  room = nextRoom;
  registerRoomEvents(nextRoom);

  try {
    await nextRoom.connect(tokenData.serverUrl, tokenData.token);
    try {
      await nextRoom.startAudio();
    } catch (audioError) {
      console.warn('Normal oda sesi yeniden başlatılamadı:', audioError);
    }
  } catch (error) {
    if (room === nextRoom) room = null;
    await nextRoom.disconnect().catch(() => null);
    throw error;
  }

  session.token = tokenData.token;
  normalMediaSuspendedForOkey = false;
  updateParticipantCount();
}

async function prepareNormalRoomForOkey() {
  await ensureListenerMode({ force: true });

  if (getSelfSeat()) {
    const response = await emitWithAck('seat:leave', {}, 5_000);
    if (!response?.ok) {
      throw new Error(response?.message || 'Normal konuşmacı koltuğu bırakılamadı.');
    }
  }

  await suspendNormalMediaRoomForOkey();
}

function applyOkeyModeUi(active) {
  if (active) setMobileAccountMenu(false);
  voiceModePanel.hidden = false;
  okeyModePanel.hidden = !active;
  document.body.classList.toggle('okey-mode-active', active);
  okeyModeButton.setAttribute('aria-pressed', String(active));
  okeyModeButtonLabel.textContent = active ? 'Odaya dön' : 'Oyna';
  desktopOkeyButton.setAttribute('aria-pressed', String(active));
  desktopOkeyButton.classList.toggle('is-active', active);
  desktopOkeyLabel.textContent = active ? 'Sohbete dön' : 'Oyna';
  applyRoomAudioState();
  updateControls();
}

async function setOkeyMode(
  enabled,
  { skipServerLeave = false, skipMediaRestore = false } = {},
) {
  const shouldEnable = Boolean(enabled && room && session?.roomSlug);

  if (shouldEnable) {
    if (okeyModeActive) return;

    try {
      await prepareNormalRoomForOkey();
      okeyModeActive = true;
      applyOkeyModeUi(true);
      renderOkeyState(null);
      await connectOkeyMediaRoom();
      await connectOkeySocket(false);
      setStatus('Okey ses odasına geçtin. Normal oda sesi tamamen ayrıldı.', 'success');
    } catch (error) {
      await disconnectOkeyMediaRoom();
      await restoreNormalMediaRoomAfterOkey().catch((restoreError) => {
        console.warn('Normal oda medyası geri getirilemedi:', restoreError);
      });
      okeyModeActive = false;
      applyOkeyModeUi(false);
      setStatus(error.message || 'Okey modu başlatılamadı.', 'error');
      if (!room && session?.roomSlug) {
        const roomSlug = session.roomSlug;
        normalMediaSuspendedForOkey = false;
        await connectToRoom(roomSlug);
      }
    }
    return;
  }

  if (!okeyModeActive) {
    applyOkeyModeUi(false);
    return;
  }

  await disconnectOkeySocket({ leaveTable: !skipServerLeave });
  await disconnectOkeyMediaRoom();
  let restoreError = null;
  if (!skipMediaRestore) {
    try {
      await restoreNormalMediaRoomAfterOkey();
    } catch (error) {
      restoreError = error;
    }
  } else {
    normalMediaSuspendedForOkey = false;
  }
  okeyModeActive = false;
  applyOkeyModeUi(false);
  if (restoreError) {
    const roomSlug = session?.roomSlug;
    setStatus(
      `Normal oda ses bağlantısı geri getirilemedi: ${restoreError.message}`,
      'error',
    );
    normalMediaSuspendedForOkey = false;
    if (roomSlug) await connectToRoom(roomSlug);
  }
}

function connectSeatSocket(token) {
  seatSocket?.disconnect();

  seatSocket = io({
    path: '/api/socket.io',
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 700,
    timeout: 8_000,
  });

  seatSocket.on('connect', () => {
    setConnectionBadge('Canlı bağlantı', true);
    clearChatTyping();
    setChatEnabled(true);
    updateControls();
    if (hasOkeyPlayerSeat() && okeyLatestMediaGrant) {
      void claimOkeyMediaGrant(okeyLatestMediaGrant);
    }
  });

  seatSocket.on('disconnect', () => {
    clearChatTyping();
    setConnectionBadge('Yeniden bağlanıyor', false);
    setChatEnabled(false);
    updateControls();
  });

  seatSocket.on('connect_error', (error) => {
    setConnectionBadge('Koltuk bağlantısı yok', false);
    setStatus(`Koltuk bağlantısı kurulamadı: ${error.message}`, 'error');
  });

  seatSocket.on('room:state', handleRoomState);
  seatSocket.on('rooms:state', applyRoomDirectoryData);
  seatSocket.on('seat:reaction', handleSeatReaction);
  seatSocket.on('chat:typing', handleChatTyping);
  seatSocket.on('chat:message', appendChatMessage);
  seatSocket.on('chat:deleted', removeDeletedRoomMessage);
  seatSocket.on('chat:system', appendRoomSystemMessage);
  seatSocket.on('private:unread', (payload) => {
    setPrivateUnreadCount(payload?.count);
  });
  seatSocket.on('private:message', handlePrivateMessage);
  seatSocket.on('private:read', handlePrivateRead);
  seatSocket.on('seat:kicked', async (payload) => {
    await ensureListenerMode({
      force: !(hasOkeyPlayerSeat() && okeyMediaLeaseGranted),
    });
    setStatus(payload?.message || 'Yönetici tarafından koltuktan kaldırıldın.', 'warning');
  });
  seatSocket.on('moderation:notice', async (payload) => {
    if (payload?.action === 'media_mute') {
      await releaseOkeyMediaLease({ stopMedia: true });
      await ensureListenerMode({ force: true });
    }

    setStatus(payload?.message || 'Hesabına bir yönetici işlemi uygulandı.', 'warning');
  });
  seatSocket.on('moderation:kicked', async (payload) => {
    forcedExitMessage = payload?.message || 'Yönetici tarafından odadan çıkarıldın.';
    disconnectSeatSocket();

    if (room) {
      await room.disconnect();
    } else {
      resetRoomUi();
    }
  });
}

function disconnectSeatSocket() {
  clearChatTyping();
  if (!seatSocket) return;
  seatSocket.removeAllListeners();
  seatSocket.disconnect();
  seatSocket = null;
}

function storeVideoTrack(track, participant) {
  const existing = videoTracks.get(participant.identity);

  if (existing && existing !== track) {
    if (videoViewerTrack === existing) closeVideoViewer(false);
    existing.detach().forEach((element) => element.remove());
  }

  videoTracks.set(participant.identity, track);
  renderSeats();
  if (okeyModeActive) renderOkeyState();
}

function removeVideoTrack(track, participant) {
  if (videoViewerTrack === track) closeVideoViewer(false);
  track.detach().forEach((element) => element.remove());

  if (videoTracks.get(participant.identity) === track) {
    videoTracks.delete(participant.identity);
  }

  renderSeats();
  if (okeyModeActive) renderOkeyState();
}

function attachRemoteTrack(track, publication, participant) {
  if (track.kind === Track.Kind.Audio) {
    const element = track.attach();
    element.autoplay = true;
    element.dataset.mediaRoom = 'voice';
    document.body.append(element);
    applyRoomAudioState();
    return;
  }

  if (track.kind === Track.Kind.Video && publication.source === Track.Source.Camera) {
    storeVideoTrack(track, participant);
  }
}

function createLiveKitRoom() {
  return new Room({
    adaptiveStream: true,
    dynacast: true,
    disconnectOnPageLeave: true,
    audioCaptureDefaults: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
      channelCount: 1,
    },
    publishDefaults: {
      simulcast: true,
      videoCodec: 'vp8',
    },
  });
}

function storeOkeyVideoTrack(track, participant) {
  const existing = okeyMediaVideoTracks.get(participant.identity);

  if (existing && existing !== track) {
    if (videoViewerTrack === existing) closeVideoViewer(false);
    existing.detach().forEach((element) => element.remove());
  }

  okeyMediaVideoTracks.set(participant.identity, track);
  if (okeyModeActive) renderOkeyState();
}

function removeOkeyVideoTrack(track, participant) {
  if (videoViewerTrack === track) closeVideoViewer(false);
  track.detach().forEach((element) => element.remove());

  if (okeyMediaVideoTracks.get(participant.identity) === track) {
    okeyMediaVideoTracks.delete(participant.identity);
  }

  if (okeyModeActive) renderOkeyState();
}

function attachRemoteOkeyTrack(track, publication, participant) {
  if (track.kind === Track.Kind.Audio) {
    const element = track.attach();
    element.autoplay = true;
    element.dataset.mediaRoom = 'okey';
    document.body.append(element);
    applyRoomAudioState();
    return;
  }

  if (track.kind === Track.Kind.Video && publication.source === Track.Source.Camera) {
    storeOkeyVideoTrack(track, participant);
  }
}

function clearOkeyMediaElements() {
  if ([...okeyMediaVideoTracks.values()].includes(videoViewerTrack)) {
    closeVideoViewer(false);
  }
  document.querySelectorAll('body > audio[data-media-room="okey"]')
    .forEach((audio) => audio.remove());
  detachRenderedOkeyVideos();
  for (const track of okeyMediaVideoTracks.values()) {
    track.detach().forEach((element) => element.remove());
  }
  okeyMediaVideoTracks.clear();
  okeyActiveSpeakerIdentities = new Set();
}

function clearOkeyMediaReconnectTimer() {
  clearTimeout(okeyMediaReconnectTimer);
  okeyMediaReconnectTimer = null;
}

function scheduleOkeyMediaReconnect() {
  clearOkeyMediaReconnectTimer();

  if (!okeyModeActive || okeyIntentionalLeave || !session?.roomSlug) return;

  okeyMediaReconnectTimer = setTimeout(async () => {
    okeyMediaReconnectTimer = null;

    if (!okeyModeActive || okeyMediaRoom || okeyMediaConnectPending) return;

    try {
      await connectOkeyMediaRoom({ replace: true });

      if (hasOkeyPlayerSeat() && okeySocket?.connected) {
        const response = await emitOkeyWithAck('okey:state:get', {});
        if (response?.ok && response.state) renderOkeyState(response.state);
      }
    } catch (error) {
      setOkeyActionNote(
        `Okey ses bağlantısı yeniden kurulamadı: ${error.message}`,
        'error',
      );
      scheduleOkeyMediaReconnect();
    }
  }, 900);
}

function registerOkeyMediaRoomEvents(activeRoom) {
  activeRoom
    .on(RoomEvent.ParticipantDisconnected, (participant) => {
      const track = okeyMediaVideoTracks.get(participant.identity);
      track?.detach().forEach((element) => element.remove());
      okeyMediaVideoTracks.delete(participant.identity);
      if (videoViewerTrack === track) closeVideoViewer(false);
      if (okeyModeActive) renderOkeyState();
    })
    .on(RoomEvent.TrackSubscribed, attachRemoteOkeyTrack)
    .on(RoomEvent.TrackUnsubscribed, (track, _publication, participant) => {
      if (track.kind === Track.Kind.Video) removeOkeyVideoTrack(track, participant);
      else track.detach().forEach((element) => element.remove());
    })
    .on(RoomEvent.TrackMuted, (publication, participant) => {
      if (publication.source === Track.Source.Camera && publication.track) {
        removeOkeyVideoTrack(publication.track, participant);
      }
      updateControls();
    })
    .on(RoomEvent.TrackUnmuted, (publication, participant) => {
      if (publication.source === Track.Source.Camera && publication.track) {
        storeOkeyVideoTrack(publication.track, participant);
      }
      updateControls();
    })
    .on(RoomEvent.LocalTrackPublished, (publication, participant) => {
      if (publication.source === Track.Source.Camera && publication.track) {
        storeOkeyVideoTrack(publication.track, participant);
      }
      updateControls();
    })
    .on(RoomEvent.LocalTrackUnpublished, (publication, participant) => {
      if (publication.track?.kind === Track.Kind.Video) {
        removeOkeyVideoTrack(publication.track, participant);
      }
      updateControls();
    })
    .on(RoomEvent.ActiveSpeakersChanged, (speakers) => {
      okeyActiveSpeakerIdentities = new Set(
        speakers.map((speaker) => speaker.identity),
      );
      updateSpeakingClasses();
    })
    .on(RoomEvent.MediaDevicesError, (error) => {
      setStatus(`Okey cihaz izni alınamadı: ${error.message}`, 'error');
    })
    .on(RoomEvent.Reconnecting, () => {
      setOkeyConnectionBadge('Medya bağlanıyor', 'pending');
    })
    .on(RoomEvent.Reconnected, () => {
      setOkeyConnectionBadge(
        okeyMediaRole === 'player' ? 'Oyuncu sesi bağlı' : 'Okey bağlı',
        'connected',
      );
      setStatus('Okey ses ve görüntü bağlantısı yeniden kuruldu.', 'success');
    })
    .on(RoomEvent.Disconnected, () => {
      if (activeRoom !== okeyMediaRoom) return;
      okeyMediaRoom = null;
      okeyMediaRole = 'disconnected';
      clearOkeyMediaElements();
      applyRoomAudioState();
      updateControls();
      if (okeyModeActive) {
        setOkeyActionNote('Okey ses ve görüntü bağlantısı kesildi. Sohbet bağlantın devam ediyor.', 'error');
        scheduleOkeyMediaReconnect();
      }
    });
}

async function connectOkeyMediaRoom({ grant = null, replace = false } = {}) {
  if (
    !okeyModeActive
    || !session?.roomSlug
    || okeyMediaConnectPending
    || (okeyMediaRoom && !replace)
  ) return false;

  const connectionGeneration = ++okeyMediaConnectionGeneration;
  okeyMediaConnectPending = true;
  let nextRoom = null;

  try {
    const requestBody = { roomSlug: session.roomSlug };
    if (grant) requestBody.grant = grant;

    const tokenData = await apiRequest('/api/okey/media-token', {
      method: 'POST',
      body: JSON.stringify(requestBody),
    });

    if (tokenData.identity !== session.identity) {
      throw new Error('Okey medya kimliği doğrulanamadı.');
    }

    const expectedRole = grant ? 'player' : 'spectator';

    if (
      tokenData.mediaRole !== expectedRole
      || Boolean(tokenData.canPublish) !== Boolean(grant)
      || (grant && Number(tokenData.seatNumber) !== Number(okeyState?.you?.seatNumber))
    ) {
      throw new Error('Okey medya rolü doğrulanamadı.');
    }

    if (
      !okeyModeActive
      || connectionGeneration !== okeyMediaConnectionGeneration
    ) return false;

    const previousRoom = okeyMediaRoom;
    okeyMediaRoom = null;
    okeyMediaRole = 'connecting';
    clearOkeyMediaElements();
    await previousRoom?.disconnect().catch(() => null);

    if (
      !okeyModeActive
      || connectionGeneration !== okeyMediaConnectionGeneration
    ) return false;

    nextRoom = createLiveKitRoom();
    okeyMediaRoom = nextRoom;
    registerOkeyMediaRoomEvents(nextRoom);
    await nextRoom.connect(tokenData.serverUrl, tokenData.token);

    if (!okeyModeActive || nextRoom !== okeyMediaRoom) {
      await nextRoom.disconnect().catch(() => null);
      return false;
    }

    try {
      await nextRoom.startAudio();
    } catch (audioError) {
      console.warn('Okey ses oynatma başlatılamadı:', audioError);
    }

    okeyMediaRole = expectedRole;
    clearOkeyMediaReconnectTimer();
    setOkeyConnectionBadge(
      expectedRole === 'player' ? 'Oyuncu sesi bağlı' : 'Okey bağlı',
      'connected',
    );
    applyRoomAudioState();
    updateControls();
    return true;
  } catch (error) {
    if (nextRoom === okeyMediaRoom) okeyMediaRoom = null;
    if (!okeyMediaRoom) okeyMediaRole = 'disconnected';
    await nextRoom?.disconnect().catch(() => null);
    clearOkeyMediaElements();
    throw error;
  } finally {
    if (connectionGeneration === okeyMediaConnectionGeneration) {
      okeyMediaConnectPending = false;
    }
  }
}

async function disconnectOkeyMediaRoom() {
  clearOkeyMediaReconnectTimer();
  okeyMediaConnectionGeneration += 1;
  const activeRoom = okeyMediaRoom;
  okeyMediaRoom = null;
  okeyMediaRole = 'disconnected';
  okeyMediaConnectPending = false;
  clearOkeyMediaElements();
  await activeRoom?.disconnect().catch(() => null);
  applyRoomAudioState();
  updateControls();
}

function registerRoomEvents(activeRoom) {
  activeRoom
    .on(RoomEvent.ParticipantConnected, () => {
      updateParticipantCount();
    })
    .on(RoomEvent.ParticipantDisconnected, (participant) => {
      const track = videoTracks.get(participant.identity);
      if (videoViewerTrack === track) closeVideoViewer(false);
      track?.detach().forEach((element) => element.remove());
      videoTracks.delete(participant.identity);
      updateParticipantCount();
      renderSeats();
      if (okeyModeActive) renderOkeyState();
    })
    .on(RoomEvent.TrackSubscribed, attachRemoteTrack)
    .on(RoomEvent.TrackUnsubscribed, (track, _publication, participant) => {
      if (track.kind === Track.Kind.Video) removeVideoTrack(track, participant);
      else track.detach().forEach((element) => element.remove());
    })
    .on(RoomEvent.TrackMuted, (publication, participant) => {
      if (publication.source === Track.Source.Camera && publication.track) {
        removeVideoTrack(publication.track, participant);
      }
      updateControls();
    })
    .on(RoomEvent.TrackUnmuted, (publication, participant) => {
      if (publication.source === Track.Source.Camera && publication.track) {
        storeVideoTrack(publication.track, participant);
      }
      updateControls();
    })
    .on(RoomEvent.LocalTrackPublished, (publication, participant) => {
      if (publication.source === Track.Source.Camera && publication.track) {
        storeVideoTrack(publication.track, participant);
      }
      updateControls();
    })
    .on(RoomEvent.LocalTrackUnpublished, (publication, participant) => {
      if (publication.track?.kind === Track.Kind.Video) {
        removeVideoTrack(publication.track, participant);
      }
      updateControls();
    })
    .on(RoomEvent.ActiveSpeakersChanged, (speakers) => {
      activeSpeakerIdentities = new Set(speakers.map((speaker) => speaker.identity));
      updateSpeakingClasses();
    })
    .on(RoomEvent.MediaDevicesError, (error) => {
      setStatus(`Cihaz izni alınamadı: ${error.message}`, 'error');
    })
    .on(RoomEvent.Reconnecting, () => {
      setConnectionBadge('Medya bağlanıyor', false);
      setStatus('Ses ve görüntü bağlantısı yeniden kuruluyor…', 'warning');
    })
    .on(RoomEvent.Reconnected, () => {
      setConnectionBadge('Canlı bağlantı', true);
      setStatus('Ses ve görüntü bağlantısı yeniden kuruldu.', 'success');
    })
    .on(RoomEvent.Disconnected, () => {
      if (activeRoom !== room || switchingRoom || normalMediaSuspendedForOkey) return;
      resetRoomUi();
    });
}

async function stopMusicShare(showStatus = true) {
  if (stoppingMusic) return;

  if (!musicAudioTrack && !musicVideoTrack) {
    updateMusicButton();
    return;
  }

  stoppingMusic = true;

  const audioTrack = musicAudioTrack;
  const videoTrack = musicVideoTrack;
  musicAudioTrack = null;
  musicVideoTrack = null;

  try {
    if (audioTrack && room) {
      await room.localParticipant.unpublishTrack(audioTrack, true);
    } else {
      audioTrack?.stop();
    }
  } catch (error) {
    console.warn('Müzik yayından kaldırılamadı:', error);
    audioTrack?.stop();
  }

  videoTrack?.stop();
  stoppingMusic = false;
  updateMusicButton();

  if (showStatus && room) {
    setStatus('YouTube müzik paylaşımı durduruldu.');
  }
}

async function startMusicShare() {
  if (!room || !getSelfSeat() || !isSelfOwner()) return;

  const tracks = await room.localParticipant.createScreenTracks({
    audio: true,
    video: { displaySurface: 'browser' },
    preferCurrentTab: false,
    selfBrowserSurface: 'exclude',
    systemAudio: 'include',
    suppressLocalAudioPlayback: false,
  });

  const audioTrack = tracks.find((track) => track.kind === Track.Kind.Audio);
  const videoTrack = tracks.find((track) => track.kind === Track.Kind.Video);

  if (!audioTrack) {
    tracks.forEach((track) => track.stop());
    throw new Error(
      'YouTube sekmesini ve “Sekme sesini paylaş” seçeneğini seçmelisin.',
    );
  }

  musicAudioTrack = audioTrack;
  musicVideoTrack = videoTrack || null;

  if ('contentHint' in audioTrack.mediaStreamTrack) {
    audioTrack.mediaStreamTrack.contentHint = 'music';
  }

  const handleCaptureEnded = () => {
    void stopMusicShare(false).then(() => {
      if (room) setStatus('YouTube müzik paylaşımı sona erdi.');
    });
  };

  audioTrack.mediaStreamTrack.addEventListener('ended', handleCaptureEnded, {
    once: true,
  });
  videoTrack?.mediaStreamTrack.addEventListener('ended', handleCaptureEnded, {
    once: true,
  });

  try {
    await room.localParticipant.publishTrack(audioTrack, {
      source: Track.Source.ScreenShareAudio,
      name: 'youtube-music',
      audioPreset: AudioPresets.musicHighQualityStereo,
      forceStereo: true,
      dtx: false,
      red: true,
    });
  } catch (error) {
    await stopMusicShare(false);
    throw error;
  }

  updateMusicButton();
  setStatus('YouTube müziği stereo olarak paylaşılıyor.', 'success');
}

function clearVoiceMediaElements() {
  if ([...videoTracks.values()].includes(videoViewerTrack)) {
    closeVideoViewer(false);
  }
  document.querySelectorAll('body > audio:not([data-media-room="okey"])')
    .forEach((audio) => audio.remove());
  detachRenderedVideos();
  for (const track of videoTracks.values()) {
    track.detach().forEach((element) => element.remove());
  }
  videoTracks.clear();
  activeSpeakerIdentities = new Set();
}

function clearMediaElements() {
  closeVideoViewer(false);
  document.querySelectorAll('body > audio').forEach((audio) => audio.remove());
  clearVoiceMediaElements();
  clearOkeyMediaElements();
  clearSeatReactions();
}

function resetRoomUi() {
  void setOkeyMode(false, {
    skipServerLeave: true,
    skipMediaRestore: true,
  });
  disconnectSeatSocket();
  clearMediaElements();
  closeModerationDialog(false);
  closePrivateMessages(false);
  setRoomMenu(false);
  setUsersDrawer(false);
  setRoomsDrawer(false);
  closeCreateRoomDialog(false);
  closeRoomSettingsDialog(false);
  document.body.classList.remove('room-active');

  musicAudioTrack?.stop();
  musicVideoTrack?.stop();
  musicAudioTrack = null;
  musicVideoTrack = null;
  stoppingMusic = false;
  roomAudioMuted = false;

  currentRoomState = null;
  mobileRoomOwner.textContent = 'Sahibi yükleniyor';
  desktopRoomSubtitle.textContent = 'Oda bilgileri yükleniyor';
  session = null;
  room = null;
  normalMediaSuspendedForOkey = false;
  seatActionPending = false;
  seatReactionPending = false;
  seatReactionCooldownUntil = 0;
  clearTimeout(seatReactionControlTimer);
  seatReactionControlTimer = null;
  roomActionPending = false;
  switchingRoom = false;

  roomPanel.hidden = true;
  joinPanel.hidden = false;
  joinButton.disabled = false;
  setChatEnabled(false);
  renderOnlineUsers();
  renderSeats();
  updateParticipantCount();
  renderRoomDirectory();
  const exitMessage = forcedExitMessage
    || (leavingRoom ? 'Odadan ayrıldın.' : 'Oda bağlantısı sona erdi.');
  setStatus(exitMessage, forcedExitMessage ? 'warning' : 'normal');
  forcedExitMessage = null;
  leavingRoom = false;
}

async function connectToRoom(roomSlug) {
  if (!authUser || roomActionPending) return;

  const targetRoom = roomDirectory.find((item) => item.slug === roomSlug)
    || roomDirectory[0];

  if (!targetRoom) {
    setStatus('Katılabileceğin aktif bir oda bulunamadı.', 'error');
    return;
  }

  roomActionPending = true;
  switchingRoom = Boolean(room);
  joinButton.disabled = true;
  setStatus(`${targetRoom.name} bağlantısı hazırlanıyor…`, 'warning');

  try {
    if (room) {
      const previousRoomSlug = session?.roomSlug;
      const sameRoomReconnect = previousRoomSlug === targetRoom.slug;

      await setOkeyMode(false);
      await ensureListenerMode({ force: true });

      if (!sameRoomReconnect) {
        await emitWithAck(
          'room:leave',
          { reason: 'room_switch' },
          5_000,
        ).catch(() => null);
      }

      disconnectSeatSocket();

      const previousRoom = room;
      room = null;
      await previousRoom.disconnect();
      clearMediaElements();
      currentRoomState = null;
      session = null;
    }

    const tokenData = await apiRequest('/api/token', {
      method: 'POST',
      body: JSON.stringify({ roomSlug: targetRoom.slug }),
    });
    authUser = tokenData.user;
    selectedRoomSlug = tokenData.roomInfo.slug;

    session = {
      identity: tokenData.identity,
      name: tokenData.user.displayName,
      token: tokenData.token,
      roomName: tokenData.room,
      roomSlug: tokenData.roomInfo.slug,
    };

    const nextRoom = createLiveKitRoom();

    room = nextRoom;
    registerRoomEvents(nextRoom);
    await nextRoom.connect(tokenData.serverUrl, tokenData.token);

    try {
      await nextRoom.startAudio();
    } catch (audioError) {
      console.warn('Ses oynatma başlatılamadı:', audioError);
    }

    joinPanel.hidden = true;
    roomPanel.hidden = false;
    document.body.classList.add('room-active');
    applyActiveRoomBackground(tokenData.roomInfo);
    roomNameText.textContent = tokenData.roomInfo.name;
    desktopRoomSubtitle.textContent = tokenData.roomInfo.description
      || 'Seslicity canlı sohbet odası';
    resetChatMessages(tokenData.roomInfo.name);
    setConnectionBadge('Koltuk bağlanıyor', false);
    setStatus(`${tokenData.roomInfo.name} odasına dinleyici olarak katıldın.`, 'success');
    sendAppPortalAnalytics('room_join', tokenData.roomInfo.slug);

    renderSeats();
    updateParticipantCount();
    updateControls();
    applyRoomDirectoryData({ rooms: roomDirectory.map((item) => (
      item.slug === tokenData.roomInfo.slug ? { ...item, ...tokenData.roomInfo } : item
    )) });
    connectSeatSocket(tokenData.token);
  } catch (error) {
    console.error(error);

    if (room) {
      const failedRoom = room;
      room = null;
      await failedRoom.disconnect().catch(() => null);
    }

    disconnectSeatSocket();
    clearMediaElements();
    session = null;
    currentRoomState = null;
    roomPanel.hidden = true;
    joinPanel.hidden = false;
    document.body.classList.remove('room-active');

    if (error.status === 401) renderAuthUser(null);
    setStatus(error.message || 'Bağlantı kurulamadı.', 'error');
  } finally {
    roomActionPending = false;
    switchingRoom = false;
    joinButton.disabled = false;
    renderRoomDirectory();
  }
}

async function switchToRoom(roomSlug) {
  if ((!room && !okeyModeActive) || roomActionPending || session?.roomSlug === roomSlug) {
    return;
  }
  if (okeyModeActive) await setOkeyMode(false);
  await connectToRoom(roomSlug);
}

async function connectAfterAuthentication() {
  await loadRoomDirectory();

  const roomSlug = selectedRoomSlug || roomDirectory[0]?.slug;
  if (!roomSlug) {
    setStatus('Şu anda katılabileceğin aktif bir oda bulunamadı.', 'warning');
    return;
  }

  await connectToRoom(roomSlug);
}

guestTab.addEventListener('click', () => setAuthTab('guest'));
loginTab.addEventListener('click', () => setAuthTab('login'));
registerTab.addEventListener('click', () => setAuthTab('register'));

loginForm.addEventListener('submit', async (event) => {
  event.preventDefault();
  loginSubmit.disabled = true;
  setStatus('Üyelik bilgilerin doğrulanıyor…', 'warning');

  try {
    const data = await apiRequest('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({
        identifier: loginIdentifier.value.trim(),
        password: loginPassword.value,
      }),
    });

    loginPassword.value = '';
    renderAuthUser(data.user);
    await connectAfterAuthentication();
  } catch (error) {
    setStatus(error.message || 'Giriş yapılamadı.', 'error');
  } finally {
    loginSubmit.disabled = false;
  }
});

registerForm.addEventListener('submit', async (event) => {
  event.preventDefault();
  registerSubmit.disabled = true;
  setStatus('Üyeliğin güvenli şekilde oluşturuluyor…', 'warning');

  try {
    const data = await apiRequest('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify({
        username: registerUsername.value.trim(),
        displayName: registerDisplayName.value.trim(),
        gender: registerGender.value,
        email: registerEmail.value.trim(),
        password: registerPassword.value,
      }),
    });

    registerForm.reset();
    renderAuthUser(data.user);
    await connectAfterAuthentication();
  } catch (error) {
    setStatus(error.message || 'Üyelik oluşturulamadı.', 'error');
  } finally {
    registerSubmit.disabled = false;
  }
});


guestGenderOptions.forEach((option, index) => {
  option.addEventListener('click', () => {
    setGuestGender(option.dataset.genderValue || '', false);
  });

  option.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
    event.preventDefault();

    const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
    const nextIndex = (index + direction + guestGenderOptions.length) % guestGenderOptions.length;
    const next = guestGenderOptions[nextIndex];
    setGuestGender(next.dataset.genderValue || '', true);
  });
});

syncGuestGenderCards();

guestForm.addEventListener('submit', async (event) => {
  event.preventDefault();

  if (!guestGender?.value) {
    if (guestGenderError) guestGenderError.hidden = false;
    guestGenderOptions[0]?.focus({ preventScroll: true });
    setStatus('Devam etmek için cinsiyet seçimini tamamla.', 'warning');
    return;
  }

  guestSubmit.disabled = true;
  setStatus('Güvenli misafir oturumun hazırlanıyor…', 'warning');

  try {
    const data = await apiRequest('/api/auth/guest', {
      method: 'POST',
      body: JSON.stringify({
        displayName: guestDisplayName.value.trim(),
        gender: guestGender.value,
      }),
    });

    guestForm.reset();
    renderAuthUser(data.user);
    await connectAfterAuthentication();
  } catch (error) {
    setStatus(error.message || 'Misafir girişi yapılamadı.', 'error');
  } finally {
    guestSubmit.disabled = false;
  }
});

logoutButton.addEventListener('click', async () => {
  logoutButton.disabled = true;

  try {
    if (room && seatSocket?.connected) {
      await setOkeyMode(false);
      await emitWithAck(
        'room:leave',
        { reason: 'logout' },
        5_000,
      ).catch(() => null);
      disconnectSeatSocket();
      await room.disconnect().catch(() => null);
    }

    await apiRequest('/api/auth/logout', { method: 'POST' });

    /*
     * Ana giriş deneyimi seslicity.com üzerindedir. Çıkıştan sonra uygulamanın
     * eski misafir formunu göstermeyip ana sayfadaki yeni giriş kartına dön.
     * replace kullanımı geri tuşuyla oturumu kapatılmış uygulamaya dönülmesini engeller.
     */
    window.location.replace('https://seslicity.com/#portal-auth-card');
    return;
  } catch (error) {
    setStatus(error.message || 'Çıkış yapılamadı.', 'error');
  } finally {
    logoutButton.disabled = false;
  }
});

memberAvatar.addEventListener('click', () => {
  if (authUser) void openProfile(authUser, memberAvatar);
});

profileClose.addEventListener('click', () => closeProfileDialog());

profileDialog.addEventListener('click', (event) => {
  if (event.target === profileDialog) closeProfileDialog();
});

let yallaProfileEditOpenedAt = 0;
let yallaProfileEditWasHidden = false;

function openYallaAccountProfile() {
  closeProfileDialog(false);

  yallaProfileEditOpenedAt = Date.now();
  yallaProfileEditWasHidden = false;

  const profileWindow = window.open(
    'https://app.seslicity.com',
    '_blank',
  );

  if (profileWindow) {
    try {
      profileWindow.opener = null;
    } catch {
      // Tarayıcı erişime izin vermeyebilir.
    }

    setStatus(
      'Yalla profilin açıldı. Değişiklik yaptıktan sonra bu sekmeye döndüğünde profilin otomatik yenilenecek.',
      'success',
    );

    return;
  }

  window.location.assign(
    'https://app.seslicity.com',
  );
}

document.addEventListener('visibilitychange', () => {
  if (document.hidden && yallaProfileEditOpenedAt) {
    yallaProfileEditWasHidden = true;
  }
});

window.addEventListener('focus', () => {
  if (
    !yallaProfileEditOpenedAt
    || !yallaProfileEditWasHidden
    || Date.now() - yallaProfileEditOpenedAt < 1500
  ) {
    return;
  }

  yallaProfileEditOpenedAt = 0;
  yallaProfileEditWasHidden = false;

  /*
   * Ana Yalla profilindeki kullanıcı adı, avatar, biyografi,
   * cinsiyet, VIP ve doğrulama bilgilerini yeniden senkronize et.
   */
  window.location.assign(
    'https://app.seslicity.com',
  );
});

profileEditButton.addEventListener('click', () => {
  if (activeProfile?.authSource === 'sngine') {
    openYallaAccountProfile();
    return;
  }

  openProfileEditor();
});
profileEditCancel.addEventListener('click', cancelProfileEditor);
profileMessageButton.addEventListener('click', () => {
  if (!activeProfile || activeProfile.id === authUser?.id) return;

  const peer = activeProfile;
  const returnFocus = profilePreviousFocus;
  closeProfileDialog(false);
  void openPrivateMessages(peer, returnFocus);
});

profileFrameRemove.addEventListener('click', () => {
  if (!activeProfile || activeProfile.id !== authUser?.id) return;

  selectedAvatarFrame = 'none';
  renderAvatarFrame(profileEditFrame, activeProfile, selectedAvatarFrame);
  renderAvatar(profileEditAvatar, {
    ...activeProfile,
    displayName: profileDisplayName.value || activeProfile.displayName,
    avatarUrl: profilePreviewUrl || activeProfile.avatarUrl,
    avatarFrame: selectedAvatarFrame,
  });
  renderAvatarFramePicker();
  setStatus('Çerçeve kaldırıldı. Değişikliği uygulamak için Kaydet’e dokun.', 'success');
});

profileBioInput.addEventListener('input', () => {
  profileBioCount.textContent = `${[...profileBioInput.value].length} / 300`;
});

profileDisplayName.addEventListener('input', () => {
  const source = {
    ...activeProfile,
    displayName: profileDisplayName.value || activeProfile?.displayName,
    avatarFrame: selectedAvatarFrame,
    avatarUrl: profilePreviewUrl || activeProfile?.avatarUrl,
  };
  renderAvatar(profileEditAvatar, source);
});

profileAvatarInput.addEventListener('change', () => {
  const file = profileAvatarInput.files?.[0];
  if (!file) return;

  if (file.size > 2 * 1024 * 1024) {
    profileAvatarInput.value = '';
    setStatus('Avatar dosyası en fazla 2 MB olabilir.', 'error');
    return;
  }

  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
    profileAvatarInput.value = '';
    setStatus('Avatar JPEG, PNG veya WebP biçiminde olmalıdır.', 'error');
    return;
  }

  if (profilePreviewUrl) URL.revokeObjectURL(profilePreviewUrl);
  profilePreviewUrl = URL.createObjectURL(file);
  renderAvatar(profileEditAvatar, {
    ...activeProfile,
    displayName: profileDisplayName.value || activeProfile?.displayName,
    avatarUrl: profilePreviewUrl,
    avatarFrame: selectedAvatarFrame,
  });
});

profileEditForm.addEventListener('submit', async (event) => {
  event.preventDefault();
  if (!activeProfile || activeProfile.id !== authUser?.id) return;

  const selectedFile = activeProfile.authSource === 'sngine'
    ? null
    : profileAvatarInput.files?.[0] || null;
  profileSave.disabled = true;
  profileRemoveAvatar.disabled = true;
  profileEditCancel.disabled = true;
  setStatus('Profilin güncelleniyor…', 'warning');
  let savedUser = null;

  try {
    let data = await apiRequest('/api/profile/me', {
      method: 'PATCH',
      body: JSON.stringify({
        displayName: profileDisplayName.value.trim(),
        bio: profileBioInput.value.trim(),
        gender: profileGender.value,
        nicknameEffect: profileNicknameEffect.value,
        avatarFrame: selectedAvatarFrame,
      }),
    });
    savedUser = data.user;

    if (selectedFile) {
      const formData = new FormData();
      formData.append('avatar', selectedFile);
      data = await apiRequest('/api/profile/avatar', {
        method: 'POST',
        body: formData,
      });
      savedUser = data.user;
    }

    authUser = savedUser;
    if (session) session.name = authUser.displayName;
    clearProfilePreview();
    renderAuthUser(authUser);
    showProfile(authUser);
    setStatus('Profilin güncellendi.', 'success');
  } catch (error) {
    if (savedUser) {
      authUser = savedUser;
      if (session) session.name = authUser.displayName;
      clearProfilePreview();
      renderAuthUser(authUser);
      showProfile(authUser);
      setStatus(
        selectedFile
          ? `${error.message || 'Fotoğraf yüklenemedi.'} Diğer profil bilgilerin kaydedildi.`
          : error.message || 'Profil güncellenemedi.',
        'warning',
      );
    } else {
      setStatus(error.message || 'Profil güncellenemedi.', 'error');
    }
  } finally {
    profileSave.disabled = false;
    profileRemoveAvatar.disabled = false;
    profileEditCancel.disabled = false;
  }
});

profileRemoveAvatar.addEventListener('click', async () => {
  if (!activeProfile?.avatarUrl || activeProfile.id !== authUser?.id) return;

  profileRemoveAvatar.disabled = true;
  setStatus('Profil fotoğrafı kaldırılıyor…', 'warning');

  try {
    const data = await apiRequest('/api/profile/avatar', { method: 'DELETE' });
    authUser = data.user;
    clearProfilePreview();
    renderAuthUser(authUser);
    showProfile(authUser);
    setStatus('Profil fotoğrafın kaldırıldı.', 'success');
  } catch (error) {
    setStatus(error.message || 'Profil fotoğrafı kaldırılamadı.', 'error');
  } finally {
    profileRemoveAvatar.disabled = false;
  }
});

joinForm.addEventListener('submit', async (event) => {
  event.preventDefault();

  if (!authUser) {
    renderAuthUser(null);
    setStatus('Odaya katılmak için giriş yapmalısın.', 'error');
    return;
  }

  await connectToRoom(selectedRoomSlug);
});

joinRoomSelect.addEventListener('change', () => {
  selectedRoomSlug = joinRoomSelect.value;
  renderRoomDirectory();
});

desktopRoomsTab.addEventListener('click', () => setDesktopSidebarView('rooms'));
desktopUsersTab.addEventListener('click', () => setDesktopSidebarView('users'));

desktopAccountProfile.addEventListener('click', () => {
  if (authUser) void openProfile(authUser, desktopAccountProfile);
});

desktopOkeyButton.addEventListener('click', () => {
  if (!desktopOkeyButton.disabled) okeyModeButton.click();
});

desktopPrivateMessagesButton.addEventListener('click', () => {
  if (!desktopPrivateMessagesButton.disabled) void openPrivateMessages(null, desktopPrivateMessagesButton);
});

cameraQuickButton.addEventListener('click', () => {
  if (!cameraQuickButton.disabled) cameraButton.click();
});

desktopThemeToggle?.addEventListener('click', () => {
  applyDesktopTheme(getDesktopTheme() === 'light' ? 'dark' : 'light');
});

authOverlayClose?.addEventListener('click', () => closeAuthOverlay(true));

joinPanel.addEventListener('click', (event) => {
  if (document.body.classList.contains('room-active')
    && document.body.classList.contains('auth-overlay-open')
    && event.target === joinPanel) {
    closeAuthOverlay(true);
  }
});

desktopSignupButton.addEventListener('click', () => {
  const isMember = authUser?.accountType === 'member' && authUser?.role !== 'guest';

  if (isMember) {
    void openProfile(authUser, desktopSignupButton);
    return;
  }

  openAuthOverlay('register');
});

okeyModeButton.addEventListener('click', async () => {
  if ((!room && !okeyModeActive) || okeyConnectPending) return;

  okeyModeButton.disabled = true;

  try {
    await setOkeyMode(!okeyModeActive);
  } catch (error) {
    setStatus(error.message || 'Okey modu değiştirilemedi.', 'error');
  } finally {
    updateControls();
  }
});

okeySpectatorsButton.addEventListener('click', () => {
  setOkeySpectators(okeySpectatorsPopover.hidden);
});

okeySpectatorsBackdrop.addEventListener('click', () => {
  setOkeySpectators(false, true);
});

okeySpectatorsClose.addEventListener('click', () => {
  setOkeySpectators(false, true);
});

for (const button of okeySeatButtons) {
  button.addEventListener('click', async () => {
    if (!okeySocket?.connected || okeyActionPending) return;

    const seatNumber = Number(button.dataset.okeySeat);
    const seat = okeyState?.seats?.find((item) => item.number === seatNumber);
    const occupant = seat?.occupant || null;

    if (occupant) {
      if (okeyMediaVideoTracks.has(occupant.identity)) {
        openVideoViewer(occupant.identity);
      }
      return;
    }

    okeyAutoEnableMicrophone = !okeyState?.you?.seatNumber;

    try {
      await performOkeyAction('okey:seat:take', {
        seatNumber,
      });
      setOkeyActionNote(
        `${seatNumber}. oyuncu yerine oturdun. Ses bağlantın hazırlanıyor.`,
        'success',
      );
    } catch (error) {
      okeyAutoEnableMicrophone = false;
      setOkeyActionNote(error.message || 'Oyuncu yerine oturulamadı.', 'error');
    }
  });
}

okeyDrawWallButton.addEventListener('click', async () => {
  if (!okeyState?.you?.canDrawWall || okeyActionPending) return;

  try {
    await performOkeyAction('okey:turn:draw-wall');
  } catch (error) {
    setOkeyActionNote(error.message || 'Ortadan taş çekilemedi.', 'error');
  }
});

okeyTakeDiscardButton.addEventListener('click', async () => {
  if (!okeyState?.you?.canTakeDiscard || okeyActionPending) return;

  try {
    await performOkeyAction('okey:turn:take-discard');
  } catch (error) {
    setOkeyActionNote(error.message || 'Atılan taş alınamadı.', 'error');
  }
});

okeyRackArrangeButton.addEventListener('click', () => {
  if (!okeyState?.game || !okeyState?.you?.hand?.length || okeyActionPending) return;

  okeyRackArrangeMode = !okeyRackArrangeMode;
  okeyRackMoveTileId = null;
  okeySelectedTileId = null;
  refreshOkeyRackOnly();
  setOkeyActionNote(
    okeyRackArrangeMode
      ? 'Düzenleme açık. Bir taşa, ardından taşımak istediğin yere dokun.'
      : 'Istaka düzenleme kapatıldı.',
    okeyRackArrangeMode ? 'success' : 'normal',
  );
});

okeyRackSortColorButton.addEventListener('click', () => {
  sortOkeyRack('color');
});

okeyRackSortNumberButton.addEventListener('click', () => {
  sortOkeyRack('number');
});

okeyDiscardButton.addEventListener('click', async () => {
  if (!okeyState?.you?.canDiscard || !okeySelectedTileId || okeyActionPending) return;

  const selectedTile = okeyState.you.hand?.find(
    (tile) => tile.id === okeySelectedTileId,
  );

  if (!selectedTile) {
    okeySelectedTileId = null;
    updateOkeyTileSelection();
    return;
  }

  try {
    await performOkeyAction('okey:turn:discard', {
      tileId: selectedTile.id,
    });
  } catch (error) {
    setOkeyActionNote(error.message || 'Seçilen taş atılamadı.', 'error');
  }
});

okeyReadyButton.addEventListener('click', async () => {
  if (!okeyState?.you?.seatNumber || okeyActionPending) return;

  try {
    await performOkeyAction('okey:ready:set', {
      ready: !okeyState.you.ready,
    });
  } catch (error) {
    setOkeyActionNote(error.message || 'Hazır durumu değiştirilemedi.', 'error');
  }
});

okeyLeaveSeatButton.addEventListener('click', async () => {
  if (!okeyState?.you?.seatNumber || okeyActionPending) return;

  try {
    await performOkeyAction('okey:seat:leave');
    setOkeyActionNote('Masadan kalktın; seyirci olarak devam ediyorsun.', 'success');
  } catch (error) {
    setOkeyActionNote(error.message || 'Masadan kalkılamadı.', 'error');
  }
});

okeyResetButton.addEventListener('click', async () => {
  if (!okeyState?.you?.canReset || okeyActionPending) return;
  if (!window.confirm('Masadaki bütün oyuncu yerleri sıfırlansın mı?')) return;

  try {
    await performOkeyAction('okey:table:reset');
    setOkeyActionNote('Okey masası sıfırlandı.', 'success');
  } catch (error) {
    setOkeyActionNote(error.message || 'Masa sıfırlanamadı.', 'error');
  }
});

okeyCloseButton.addEventListener('click', async () => {
  if (!okeyState?.you?.canClose || okeyActionPending) return;
  if (!window.confirm('Okey masası kapatılsın ve herkes sohbet moduna dönsün mü?')) return;

  try {
    await performOkeyAction('okey:table:close');
  } catch (error) {
    setOkeyActionNote(error.message || 'Masa kapatılamadı.', 'error');
  }
});

seatButton.addEventListener('click', () => {
  if (getSelfSeat()) {
    void leaveSeat();
    return;
  }

  seatsGrid.scrollIntoView({ behavior: 'smooth', block: 'center' });
  setStatus('Oturmak istediğin boş koltuğa tıkla.');
});

micButton.addEventListener('click', async () => {
  const activeRoom = okeyModeActive ? okeyMediaRoom : room;
  if (!activeRoom || !canUseRoomMedia()) return;

  micButton.disabled = true;

  try {
    await activeRoom.localParticipant.setMicrophoneEnabled(
      !activeRoom.localParticipant.isMicrophoneEnabled,
    );
    updateControls();
  } catch (error) {
    setStatus(`Mikrofon değiştirilemedi: ${error.message}`, 'error');
  } finally {
    updateControls();
  }
});

audioOutputButton.addEventListener('click', () => {
  const activeRoom = okeyModeActive ? okeyMediaRoom : room;
  if (!activeRoom) return;

  roomAudioMuted = !roomAudioMuted;
  applyRoomAudioState();
  setStatus(
    roomAudioMuted
      ? `${okeyModeActive ? 'Okey masasından' : 'Odadan'} gelen sesler bu cihazda kapatıldı.`
      : `${okeyModeActive ? 'Okey masasından' : 'Odadan'} gelen sesler yeniden açıldı.`,
    roomAudioMuted ? 'warning' : 'success',
  );
});

async function toggleLocalCamera() {
  const activeRoom = okeyModeActive ? okeyMediaRoom : room;
  const activeVideoMap = okeyModeActive ? okeyMediaVideoTracks : videoTracks;
  if (!activeRoom || !canUseRoomMedia()) return;

  setRoomMenu(false);
  cameraButton.disabled = true;
  okeyCameraButton.disabled = true;

  try {
    const enabled = !activeRoom.localParticipant.isCameraEnabled;
    const publication = await activeRoom.localParticipant.setCameraEnabled(enabled);

    if (!enabled) {
      const track = activeVideoMap.get(session.identity);
      if (videoViewerIdentity === session.identity) closeVideoViewer(false);
      track?.detach().forEach((element) => element.remove());
      activeVideoMap.delete(session.identity);
      if (okeyModeActive) renderOkeyState();
      else renderSeats();
    } else if (publication?.track) {
      if (okeyModeActive) {
        storeOkeyVideoTrack(publication.track, activeRoom.localParticipant);
      } else {
        storeVideoTrack(publication.track, activeRoom.localParticipant);
      }
    }

    updateControls();
  } catch (error) {
    setStatus(`Kamera değiştirilemedi: ${error.message}`, 'error');
  } finally {
    updateControls();
  }
}

cameraButton.addEventListener('click', () => {
  void toggleLocalCamera();
});

okeyCameraButton.addEventListener('click', () => {
  void toggleLocalCamera();
});

musicButton.addEventListener('click', async () => {
  if (!room || !getSelfSeat() || !isSelfOwner()) return;

  musicButton.disabled = true;

  try {
    if (musicAudioTrack) await stopMusicShare();
    else await startMusicShare();
  } catch (error) {
    console.error(error);
    setStatus(`Müzik paylaşılamadı: ${error.message}`, 'error');
  } finally {
    updateControls();
  }
});

chatForm.addEventListener('submit', async (event) => {
  event.preventDefault();

  const message = chatInput.value.trim();
  const selectedImage = chatImageFile;
  if ((!message && !selectedImage) || !seatSocket?.connected || chatImageUploadPending) return;

  stopLocalChatTyping();
  chatImageUploadPending = true;
  refreshChatComposerState();

  try {
    if (selectedImage) {
      const formData = new FormData();
      formData.append('image', selectedImage);
      formData.append('roomSlug', session?.roomSlug || selectedRoomSlug || '');
      if (message) formData.append('caption', message);

      await apiRequest('/api/chat/image', {
        method: 'POST',
        body: formData,
      });
      chatInput.value = '';
      clearSelectedChatImage();
    } else {
      chatInput.value = '';
      const response = await emitWithAck('chat:send', { message }, 6_000);

      if (!response?.ok) {
        throw new Error(response?.message || 'Mesaj gönderilemedi.');
      }
    }
  } catch (error) {
    chatInput.value = message;
    setStatus(error.message || 'Mesaj gönderilemedi.', 'error');
  } finally {
    chatImageUploadPending = false;
    refreshChatComposerState();
    chatInput.focus({ preventScroll: true });
  }
});

chatInput.addEventListener('input', handleLocalChatTyping);
chatInput.addEventListener('blur', stopLocalChatTyping);

chatAttachmentButton.addEventListener('click', () => {
  if (chatAttachmentButton.disabled) return;
  chatImageInput.click();
});

chatImageInput.addEventListener('change', () => {
  selectChatImage(chatImageInput.files?.[0] || null);
});

chatImagePreviewRemove.addEventListener('click', () => {
  if (chatImageUploadPending) return;
  clearSelectedChatImage();
  chatInput.focus({ preventScroll: true });
});

emojiButton.addEventListener('click', () => {
  const opening = emojiPicker.hidden;
  emojiPicker.hidden = !opening;
  emojiButton.setAttribute('aria-expanded', String(opening));
});

document.addEventListener('click', (event) => {
  if (!emojiWrap.contains(event.target)) closeEmojiPicker();
  if (
    !mobileProfileButton.contains(event.target)
    && !mobileAccountMenu.contains(event.target)
    && !mobileAccountMenu.hidden
  ) {
    setMobileAccountMenu(false);
  }
  if (!roomMenuWrap.contains(event.target) && !roomActionMenu.hidden) {
    setRoomMenu(false);
  }
});

leaveButton.addEventListener('click', async () => {
  if ((!room && !okeyModeActive) || leavingRoom) return;

  setRoomMenu(false);
  leavingRoom = true;
  leaveButton.disabled = true;

  try {
    await setOkeyMode(false);
    if (getSelfSeat()) await ensureListenerMode({ force: true });
    await emitWithAck('room:leave', { reason: 'user_leave' }, 5_000).catch(() => null);

    disconnectSeatSocket();
    await room?.disconnect();
  } finally {
    leaveButton.disabled = false;
  }
});

roomMenuButton.addEventListener('click', () => {
  setRoomMenu(roomActionMenu.hidden, true);
});

connectionRefreshButton.addEventListener('click', async () => {
  if ((!room && !okeyModeActive) || roomActionPending || !session?.roomSlug) return;

  const roomSlug = session.roomSlug;
  setRoomMenu(false);
  setStatus('Oda bağlantısı yenileniyor…', 'warning');
  if (okeyModeActive) await setOkeyMode(false);
  await connectToRoom(roomSlug);
});

privateMessagesButton.addEventListener('click', () => {
  void openPrivateMessages(null, privateMessagesButton);
});

privateMessagesClose.addEventListener('click', () => closePrivateMessages());

privateMessagesDialog.addEventListener('click', (event) => {
  if (event.target === privateMessagesDialog) closePrivateMessages();
});

privateThreadBack.addEventListener('click', () => {
  activePrivatePeer = null;
  privateThread.hidden = true;
  privateThreadEmpty.hidden = false;
  privateMessagesDialog.classList.remove('is-thread-open');
  renderPrivateConversations();
  privateConversationsPanel.focus?.({ preventScroll: true });
});

privateMessageForm.addEventListener('submit', async (event) => {
  event.preventDefault();
  if (!activePrivatePeer || !seatSocket?.connected) return;

  const message = privateMessageInput.value.trim();
  if (!message) return;

  privateMessageInput.value = '';
  privateMessageInput.disabled = true;
  privateMessageSend.disabled = true;

  try {
    const response = await emitWithAck('private:send', {
      recipientId: activePrivatePeer.id,
      message,
    }, 8_000);

    if (!response?.ok) {
      throw new Error(response?.message || 'Özel mesaj gönderilemedi.');
    }
  } catch (error) {
    privateMessageInput.value = message;
    setStatus(error.message || 'Özel mesaj gönderilemedi.', 'error');
  } finally {
    privateMessageInput.disabled = false;
    privateMessageSend.disabled = false;
    privateMessageInput.focus({ preventScroll: true });
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  if (!privateMessagesDialog.hidden) {
    event.preventDefault();
    closePrivateMessages();
  } else if (!mobileAccountMenu.hidden) {
    event.preventDefault();
    setMobileAccountMenu(false, true);
  } else if (!roomActionMenu.hidden) {
    event.preventDefault();
    setRoomMenu(false, true);
  }
});

videoViewerClose.addEventListener('click', () => closeVideoViewer());

videoViewer.addEventListener('click', (event) => {
  if (event.target === videoViewer) closeVideoViewer();
});

mobileUsersButton.addEventListener('click', () => setUsersDrawer(true));
mobileRoomBackButton.addEventListener('click', () => setRoomsDrawer(true));
usersPanelClose.addEventListener('click', () => setUsersDrawer(false));
usersDrawerBackdrop.addEventListener('click', () => setUsersDrawer(false));
mobileRoomsButton.addEventListener('click', () => setRoomsDrawer(true));
roomsPanelClose.addEventListener('click', () => setRoomsDrawer(false));
roomsDrawerBackdrop.addEventListener('click', () => setRoomsDrawer(false));

createRoomButton.addEventListener('click', openCreateRoomDialog);
createRoomClose.addEventListener('click', () => closeCreateRoomDialog());
roomSettingsButton.addEventListener('click', openRoomSettingsDialog);
mobileRoomSettingsShortcut.addEventListener('click', () => {
  setRoomMenu(false);
  openRoomSettingsDialog();
});
mobileProfileButton.addEventListener('click', () => {
  setMobileAccountMenu(mobileAccountMenu.hidden, true);
});
mobileAccountProfileButton.addEventListener('click', () => {
  setMobileAccountMenu(false);
  if (authUser) void openProfile(authUser, mobileProfileButton);
});
mobileAccountMessagesButton.addEventListener('click', () => {
  setMobileAccountMenu(false);
  void openPrivateMessages(null, mobileProfileButton);
});
mobileHeaderCameraButton.addEventListener('click', () => {
  void toggleLocalCamera();
});
mobileHeaderLeaveButton.addEventListener('click', () => {
  leaveButton.click();
});
roomSettingsClose.addEventListener('click', () => closeRoomSettingsDialog());
seatCountDecrease.addEventListener('click', () => {
  void changeActiveRoomSeatCount(-1);
});
seatCountIncrease.addEventListener('click', () => {
  void changeActiveRoomSeatCount(1);
});

createRoomDialog.addEventListener('click', (event) => {
  if (event.target === createRoomDialog) closeCreateRoomDialog();
});

roomSettingsDialog.addEventListener('click', (event) => {
  if (event.target === roomSettingsDialog) closeRoomSettingsDialog();
});

createRoomForm.addEventListener('submit', async (event) => {
  event.preventDefault();
  if (!canCreateRoom() || roomActionPending) return;

  roomActionPending = true;
  createRoomSubmit.disabled = true;
  setStatus('Yeni sohbet odası oluşturuluyor…', 'warning');

  try {
    const data = await apiRequest('/api/rooms', {
      method: 'POST',
      body: JSON.stringify({
        name: createRoomName.value.trim(),
        description: createRoomDescription.value.trim(),
        seatCount: Number(createRoomSeatCount.value),
      }),
    });
    applyRoomDirectoryData(data);
    selectedRoomSlug = data.room.slug;
    closeCreateRoomDialog(false);
    setStatus(`${data.room.name} odası oluşturuldu.`, 'success');
    roomActionPending = false;
    renderRoomDirectory();

    if (room) await switchToRoom(data.room.slug);
  } catch (error) {
    setStatus(error.message || 'Yeni oda oluşturulamadı.', 'error');
  } finally {
    roomActionPending = false;
    createRoomSubmit.disabled = false;
    renderRoomDirectory();
  }
});


chatMessages.setAttribute('tabindex', '0');
chatMessages.addEventListener('contextmenu', openChatContextMenu);

chatContextClear?.addEventListener('click', clearChatScreenLocally);

chatContextAdmin?.addEventListener('click', () => {
  if (authUser?.role !== 'admin') return;
  closeChatContextMenu();
  window.open('/admin/', '_blank', 'noopener');
});

chatContextReset?.addEventListener('click', () => {
  applyChatViewSettings(defaultChatViewSettings);
  closeChatContextMenu();
});

chatContextFontButtons.forEach((button) => {
  button.addEventListener('click', () => {
    applyChatViewSettings({
      font: button.dataset.chatFont,
      align: chatMessages.dataset.chatAlign,
    });
  });
});

chatContextAlignButtons.forEach((button) => {
  button.addEventListener('click', () => {
    applyChatViewSettings({
      font: chatMessages.dataset.chatFont,
      align: button.dataset.chatAlign,
    });
  });
});

document.addEventListener('pointerdown', (event) => {
  if (!chatContextMenu || chatContextMenu.hidden) return;
  if (!chatContextMenu.contains(event.target)) closeChatContextMenu();
});

document.addEventListener('contextmenu', (event) => {
  if (!chatContextMenu || chatContextMenu.hidden) return;
  if (!chatMessages.contains(event.target) && !chatContextMenu.contains(event.target)) {
    closeChatContextMenu();
  }
});

window.addEventListener('resize', () => closeChatContextMenu());
window.addEventListener('blur', () => closeChatContextMenu());
document.addEventListener('scroll', () => closeChatContextMenu(), true);

moderationClose.addEventListener('click', () => closeModerationDialog());

moderationDialog.addEventListener('click', (event) => {
  if (event.target === moderationDialog) closeModerationDialog();
});

moderationActionButtons.forEach((button) => {
  button.addEventListener('click', () => {
    void applyModerationAction(button.dataset.moderationAction);
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && chatContextMenu && !chatContextMenu.hidden) {
    closeChatContextMenu(true);
    return;
  }

  if (event.key === 'Escape' && document.body.classList.contains('auth-overlay-open')) {
    closeAuthOverlay(true);
    return;
  }

  if (event.key === 'Escape' && !okeySpectatorsPopover.hidden) {
    setOkeySpectators(false, true);
    return;
  }

  if (event.key === 'Escape' && document.body.classList.contains('rooms-drawer-open')) {
    setRoomsDrawer(false);
    mobileRoomsButton.focus({ preventScroll: true });
    return;
  }

  if (event.key === 'Escape' && !createRoomDialog.hidden) {
    closeCreateRoomDialog();
    return;
  }

  if (event.key === 'Escape' && !roomSettingsDialog.hidden) {
    closeRoomSettingsDialog();
    return;
  }

  if (event.key === 'Escape' && document.body.classList.contains('users-drawer-open')) {
    setUsersDrawer(false);
    mobileUsersButton.focus({ preventScroll: true });
    return;
  }

  if (event.key === 'Escape' && !emojiPicker.hidden) {
    closeEmojiPicker();
    emojiButton.focus({ preventScroll: true });
    return;
  }

  if (event.key === 'Escape' && !profileDialog.hidden) {
    closeProfileDialog();
    return;
  }

  if (event.key === 'Escape' && !videoViewer.hidden) {
    closeVideoViewer();
    return;
  }

  if (event.key === 'Escape' && !moderationDialog.hidden) {
    closeModerationDialog();
  }
});


const PORTAL_GUEST_HANDOFF_MAX_AGE_MS = 10 * 60 * 1000;

function decodePortalGuestHandoff(value) {
  try {
    const clean = String(value || '').trim();
    if (!clean || clean.length > 800) return null;
    const base64 = clean.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
    const parsed = JSON.parse(new TextDecoder().decode(bytes));
    const displayName = String(parsed?.displayName || '').trim();
    const gender = String(parsed?.gender || '');
    const createdAt = Number(parsed?.createdAt || 0);

    if (
      [...displayName].length < 2
      || [...displayName].length > 24
      || /[\u0000-\u001f\u007f]/.test(displayName)
      || !['male', 'female', 'unspecified'].includes(gender)
      || !Number.isFinite(createdAt)
      || Math.abs(Date.now() - createdAt) > PORTAL_GUEST_HANDOFF_MAX_AGE_MS
    ) return null;

    return { displayName, gender };
  } catch {
    return null;
  }
}

function readPortalGuestHandoff() {
  const hash = String(window.location.hash || '').replace(/^#/, '');
  if (!hash) return null;

  const params = new URLSearchParams(hash);
  const handoff = decodePortalGuestHandoff(params.get('portal_guest'));
  params.delete('portal_guest');
  const remainingHash = params.toString();
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}${remainingHash ? `#${remainingHash}` : ''}`,
  );
  return handoff;
}

const portalGuestHandoff = readPortalGuestHandoff();

if (authOverlayClose) authOverlayClose.hidden = true;
loadDesktopTheme();
loadChatViewSettings();
renderSeats();
renderOnlineUsers();
renderOkeyState(null);
setChatEnabled(false);
setDesktopSidebarView('users');
const requestedAuthTab = new URL(window.location.href).searchParams.get('auth');
setAuthTab(['login', 'register'].includes(requestedAuthTab) ? requestedAuthTab : 'guest');

sendAppPortalAnalytics('app_open', portalAnalyticsContext?.requestedRoomSlug || '');

document.documentElement.dataset.portalConversionTracking = portalAnalyticsContext
  ? 'v3'
  : 'inactive';

void (async () => {
  await loadAuthSession();
  await loadRoomDirectory();

  if (!authUser && portalGuestHandoff) {
    guestDisplayName.value = portalGuestHandoff.displayName;
    setGuestGender(portalGuestHandoff.gender, false);
    setStatus('Ana sayfadaki misafir girişin hazırlanıyor…', 'warning');

    try {
      const data = await apiRequest('/api/auth/guest', {
        method: 'POST',
        body: JSON.stringify(portalGuestHandoff),
      });
      renderAuthUser(data.user);
    } catch (error) {
      setAuthTab('guest');
      setStatus(error.message || 'Ana sayfadaki misafir girişi tamamlanamadı.', 'error');
      return;
    }
  }

  if (authUser) {
    const roomSlug = selectedRoomSlug || roomDirectory[0]?.slug;

    if (roomSlug) {
      await connectToRoom(roomSlug);
      return;
    }

    setStatus('Şu anda katılabileceğin aktif bir oda bulunamadı.', 'warning');
    return;
  }

  setAuthTab(['login', 'register'].includes(requestedAuthTab) ? requestedAuthTab : 'guest');
  setStatus(
    'Misafir olarak katılabilir, üye girişi yapabilir veya yeni hesap oluşturabilirsin.',
    'normal',
  );
})();
